var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/deepmerge/dist/cjs.js
var require_cjs = __commonJS({
  "../../node_modules/deepmerge/dist/cjs.js"(exports, module) {
    "use strict";
    var isMergeableObject = /* @__PURE__ */ __name(function isMergeableObject2(value) {
      return isNonNullObject(value) && !isSpecial(value);
    }, "isMergeableObject");
    function isNonNullObject(value) {
      return !!value && typeof value === "object";
    }
    __name(isNonNullObject, "isNonNullObject");
    function isSpecial(value) {
      var stringValue = Object.prototype.toString.call(value);
      return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
    }
    __name(isSpecial, "isSpecial");
    var canUseSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
    function isReactElement(value) {
      return value.$$typeof === REACT_ELEMENT_TYPE;
    }
    __name(isReactElement, "isReactElement");
    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }
    __name(emptyTarget, "emptyTarget");
    function cloneUnlessOtherwiseSpecified(value, options) {
      return options.clone !== false && options.isMergeableObject(value) ? deepmerge2(emptyTarget(value), value, options) : value;
    }
    __name(cloneUnlessOtherwiseSpecified, "cloneUnlessOtherwiseSpecified");
    function defaultArrayMerge(target, source, options) {
      return target.concat(source).map(function(element) {
        return cloneUnlessOtherwiseSpecified(element, options);
      });
    }
    __name(defaultArrayMerge, "defaultArrayMerge");
    function getMergeFunction(key, options) {
      if (!options.customMerge) {
        return deepmerge2;
      }
      var customMerge = options.customMerge(key);
      return typeof customMerge === "function" ? customMerge : deepmerge2;
    }
    __name(getMergeFunction, "getMergeFunction");
    function getEnumerableOwnPropertySymbols(target) {
      return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
      }) : [];
    }
    __name(getEnumerableOwnPropertySymbols, "getEnumerableOwnPropertySymbols");
    function getKeys(target) {
      return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
    }
    __name(getKeys, "getKeys");
    function propertyIsOnObject(object, property) {
      try {
        return property in object;
      } catch (_) {
        return false;
      }
    }
    __name(propertyIsOnObject, "propertyIsOnObject");
    function propertyIsUnsafe(target, key) {
      return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
    }
    __name(propertyIsUnsafe, "propertyIsUnsafe");
    function mergeObject(target, source, options) {
      var destination = {};
      if (options.isMergeableObject(target)) {
        getKeys(target).forEach(function(key) {
          destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
        });
      }
      getKeys(source).forEach(function(key) {
        if (propertyIsUnsafe(target, key)) {
          return;
        }
        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
          destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
        } else {
          destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
        }
      });
      return destination;
    }
    __name(mergeObject, "mergeObject");
    function deepmerge2(target, source, options) {
      options = options || {};
      options.arrayMerge = options.arrayMerge || defaultArrayMerge;
      options.isMergeableObject = options.isMergeableObject || isMergeableObject;
      options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
      var sourceIsArray = Array.isArray(source);
      var targetIsArray = Array.isArray(target);
      var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
      if (!sourceAndTargetTypesMatch) {
        return cloneUnlessOtherwiseSpecified(source, options);
      } else if (sourceIsArray) {
        return options.arrayMerge(target, source, options);
      } else {
        return mergeObject(target, source, options);
      }
    }
    __name(deepmerge2, "deepmerge");
    deepmerge2.all = /* @__PURE__ */ __name(function deepmergeAll(array, options) {
      if (!Array.isArray(array)) {
        throw new Error("first argument should be an array");
      }
      return array.reduce(function(prev, next) {
        return deepmerge2(prev, next, options);
      }, {});
    }, "deepmergeAll");
    var deepmerge_1 = deepmerge2;
    module.exports = deepmerge_1;
  }
});

// ../../node_modules/dayjs/dayjs.min.js
var require_dayjs_min = __commonJS({
  "../../node_modules/dayjs/dayjs.min.js"(exports, module) {
    !function(t, e) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs = e();
    }(exports, function() {
      "use strict";
      var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: /* @__PURE__ */ __name(function(t2) {
        var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
        return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
      }, "ordinal") }, m = /* @__PURE__ */ __name(function(t2, e2, n2) {
        var r2 = String(t2);
        return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
      }, "m"), v = { s: m, z: /* @__PURE__ */ __name(function(t2) {
        var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
        return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
      }, "z"), m: /* @__PURE__ */ __name(function t2(e2, n2) {
        if (e2.date() < n2.date()) return -t2(n2, e2);
        var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, c), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), c);
        return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
      }, "t"), a: /* @__PURE__ */ __name(function(t2) {
        return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
      }, "a"), p: /* @__PURE__ */ __name(function(t2) {
        return { M: c, y: h, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: f }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
      }, "p"), u: /* @__PURE__ */ __name(function(t2) {
        return void 0 === t2;
      }, "u") }, g = "en", D = {};
      D[g] = M;
      var p = "$isDayjsObject", S = /* @__PURE__ */ __name(function(t2) {
        return t2 instanceof _ || !(!t2 || !t2[p]);
      }, "S"), w = /* @__PURE__ */ __name(function t2(e2, n2, r2) {
        var i2;
        if (!e2) return g;
        if ("string" == typeof e2) {
          var s2 = e2.toLowerCase();
          D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
          var u2 = e2.split("-");
          if (!i2 && u2.length > 1) return t2(u2[0]);
        } else {
          var a2 = e2.name;
          D[a2] = e2, i2 = a2;
        }
        return !r2 && i2 && (g = i2), i2 || !r2 && g;
      }, "t"), O = /* @__PURE__ */ __name(function(t2, e2) {
        if (S(t2)) return t2.clone();
        var n2 = "object" == typeof e2 ? e2 : {};
        return n2.date = t2, n2.args = arguments, new _(n2);
      }, "O"), b = v;
      b.l = w, b.i = S, b.w = function(t2, e2) {
        return O(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
      };
      var _ = function() {
        function M2(t2) {
          this.$L = w(t2.locale, null, true), this.parse(t2), this.$x = this.$x || t2.x || {}, this[p] = true;
        }
        __name(M2, "M");
        var m2 = M2.prototype;
        return m2.parse = function(t2) {
          this.$d = function(t3) {
            var e2 = t3.date, n2 = t3.utc;
            if (null === e2) return /* @__PURE__ */ new Date(NaN);
            if (b.u(e2)) return /* @__PURE__ */ new Date();
            if (e2 instanceof Date) return new Date(e2);
            if ("string" == typeof e2 && !/Z$/i.test(e2)) {
              var r2 = e2.match($);
              if (r2) {
                var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
                return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
              }
            }
            return new Date(e2);
          }(t2), this.init();
        }, m2.init = function() {
          var t2 = this.$d;
          this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
        }, m2.$utils = function() {
          return b;
        }, m2.isValid = function() {
          return !(this.$d.toString() === l);
        }, m2.isSame = function(t2, e2) {
          var n2 = O(t2);
          return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
        }, m2.isAfter = function(t2, e2) {
          return O(t2) < this.startOf(e2);
        }, m2.isBefore = function(t2, e2) {
          return this.endOf(e2) < O(t2);
        }, m2.$g = function(t2, e2, n2) {
          return b.u(t2) ? this[e2] : this.set(n2, t2);
        }, m2.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m2.valueOf = function() {
          return this.$d.getTime();
        }, m2.startOf = function(t2, e2) {
          var n2 = this, r2 = !!b.u(e2) || e2, f2 = b.p(t2), l2 = /* @__PURE__ */ __name(function(t3, e3) {
            var i2 = b.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
            return r2 ? i2 : i2.endOf(a);
          }, "l"), $2 = /* @__PURE__ */ __name(function(t3, e3) {
            return b.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
          }, "$"), y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
          switch (f2) {
            case h:
              return r2 ? l2(1, 0) : l2(31, 11);
            case c:
              return r2 ? l2(1, M3) : l2(0, M3 + 1);
            case o:
              var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
              return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
            case a:
            case d:
              return $2(v2 + "Hours", 0);
            case u:
              return $2(v2 + "Minutes", 1);
            case s:
              return $2(v2 + "Seconds", 2);
            case i:
              return $2(v2 + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m2.endOf = function(t2) {
          return this.startOf(t2, false);
        }, m2.$set = function(t2, e2) {
          var n2, o2 = b.p(t2), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = f2 + "Date", n2[d] = f2 + "Date", n2[c] = f2 + "Month", n2[h] = f2 + "FullYear", n2[u] = f2 + "Hours", n2[s] = f2 + "Minutes", n2[i] = f2 + "Seconds", n2[r] = f2 + "Milliseconds", n2)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
          if (o2 === c || o2 === h) {
            var y2 = this.clone().set(d, 1);
            y2.$d[l2]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
          } else l2 && this.$d[l2]($2);
          return this.init(), this;
        }, m2.set = function(t2, e2) {
          return this.clone().$set(t2, e2);
        }, m2.get = function(t2) {
          return this[b.p(t2)]();
        }, m2.add = function(r2, f2) {
          var d2, l2 = this;
          r2 = Number(r2);
          var $2 = b.p(f2), y2 = /* @__PURE__ */ __name(function(t2) {
            var e2 = O(l2);
            return b.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
          }, "y");
          if ($2 === c) return this.set(c, this.$M + r2);
          if ($2 === h) return this.set(h, this.$y + r2);
          if ($2 === a) return y2(1);
          if ($2 === o) return y2(7);
          var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
          return b.w(m3, this);
        }, m2.subtract = function(t2, e2) {
          return this.add(-1 * t2, e2);
        }, m2.format = function(t2) {
          var e2 = this, n2 = this.$locale();
          if (!this.isValid()) return n2.invalidDate || l;
          var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = b.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, c2 = n2.months, f2 = n2.meridiem, h2 = /* @__PURE__ */ __name(function(t3, n3, i3, s3) {
            return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
          }, "h"), d2 = /* @__PURE__ */ __name(function(t3) {
            return b.s(s2 % 12 || 12, t3, "0");
          }, "d"), $2 = f2 || function(t3, e3, n3) {
            var r3 = t3 < 12 ? "AM" : "PM";
            return n3 ? r3.toLowerCase() : r3;
          };
          return r2.replace(y, function(t3, r3) {
            return r3 || function(t4) {
              switch (t4) {
                case "YY":
                  return String(e2.$y).slice(-2);
                case "YYYY":
                  return b.s(e2.$y, 4, "0");
                case "M":
                  return a2 + 1;
                case "MM":
                  return b.s(a2 + 1, 2, "0");
                case "MMM":
                  return h2(n2.monthsShort, a2, c2, 3);
                case "MMMM":
                  return h2(c2, a2);
                case "D":
                  return e2.$D;
                case "DD":
                  return b.s(e2.$D, 2, "0");
                case "d":
                  return String(e2.$W);
                case "dd":
                  return h2(n2.weekdaysMin, e2.$W, o2, 2);
                case "ddd":
                  return h2(n2.weekdaysShort, e2.$W, o2, 3);
                case "dddd":
                  return o2[e2.$W];
                case "H":
                  return String(s2);
                case "HH":
                  return b.s(s2, 2, "0");
                case "h":
                  return d2(1);
                case "hh":
                  return d2(2);
                case "a":
                  return $2(s2, u2, true);
                case "A":
                  return $2(s2, u2, false);
                case "m":
                  return String(u2);
                case "mm":
                  return b.s(u2, 2, "0");
                case "s":
                  return String(e2.$s);
                case "ss":
                  return b.s(e2.$s, 2, "0");
                case "SSS":
                  return b.s(e2.$ms, 3, "0");
                case "Z":
                  return i2;
              }
              return null;
            }(t3) || i2.replace(":", "");
          });
        }, m2.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m2.diff = function(r2, d2, l2) {
          var $2, y2 = this, M3 = b.p(d2), m3 = O(r2), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D2 = /* @__PURE__ */ __name(function() {
            return b.m(y2, m3);
          }, "D");
          switch (M3) {
            case h:
              $2 = D2() / 12;
              break;
            case c:
              $2 = D2();
              break;
            case f:
              $2 = D2() / 3;
              break;
            case o:
              $2 = (g2 - v2) / 6048e5;
              break;
            case a:
              $2 = (g2 - v2) / 864e5;
              break;
            case u:
              $2 = g2 / n;
              break;
            case s:
              $2 = g2 / e;
              break;
            case i:
              $2 = g2 / t;
              break;
            default:
              $2 = g2;
          }
          return l2 ? $2 : b.a($2);
        }, m2.daysInMonth = function() {
          return this.endOf(c).$D;
        }, m2.$locale = function() {
          return D[this.$L];
        }, m2.locale = function(t2, e2) {
          if (!t2) return this.$L;
          var n2 = this.clone(), r2 = w(t2, e2, true);
          return r2 && (n2.$L = r2), n2;
        }, m2.clone = function() {
          return b.w(this.$d, this);
        }, m2.toDate = function() {
          return new Date(this.valueOf());
        }, m2.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m2.toISOString = function() {
          return this.$d.toISOString();
        }, m2.toString = function() {
          return this.$d.toUTCString();
        }, M2;
      }(), k = _.prototype;
      return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function(t2) {
        k[t2[1]] = function(e2) {
          return this.$g(e2, t2[0], t2[1]);
        };
      }), O.extend = function(t2, e2) {
        return t2.$i || (t2(e2, _, O), t2.$i = true), O;
      }, O.locale = w, O.isDayjs = S, O.unix = function(t2) {
        return O(1e3 * t2);
      }, O.en = D[g], O.Ls = D, O.p = {}, O;
    });
  }
});

// ../../node_modules/dayjs/plugin/quarterOfYear.js
var require_quarterOfYear = __commonJS({
  "../../node_modules/dayjs/plugin/quarterOfYear.js"(exports, module) {
    !function(t, n) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_quarterOfYear = n();
    }(exports, function() {
      "use strict";
      var t = "month", n = "quarter";
      return function(e, i) {
        var r = i.prototype;
        r.quarter = function(t2) {
          return this.$utils().u(t2) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (t2 - 1));
        };
        var s = r.add;
        r.add = function(e2, i2) {
          return e2 = Number(e2), this.$utils().p(i2) === n ? this.add(3 * e2, t) : s.bind(this)(e2, i2);
        };
        var u = r.startOf;
        r.startOf = function(e2, i2) {
          var r2 = this.$utils(), s2 = !!r2.u(i2) || i2;
          if (r2.p(e2) === n) {
            var o = this.quarter() - 1;
            return s2 ? this.month(3 * o).startOf(t).startOf("day") : this.month(3 * o + 2).endOf(t).endOf("day");
          }
          return u.bind(this)(e2, i2);
        };
      };
    });
  }
});

// src/atoms/elevation.ts
var elevation = {
  low: {
    shadow: { boxShadow: "0 1px 8px 0 rgba(0, 0, 0, 0.08)" }
  },
  high: {
    shadow: { boxShadow: "0 1px 8px 0 rgba(0, 0, 0, 0.16)" }
  }
};

// src/atoms/radius.ts
var radius = {
  nonInteractive: "0",
  interactiveCompact: "4px",
  interactive: "8px",
  container: "0",
  round: "50%"
};

// src/atoms/spacing.ts
var spacing = {
  s4: "4px",
  s8: "8px",
  s16: "16px",
  s24: "24px",
  s32: "32px",
  s48: "48px"
};

// src/atoms/typography.ts
import { createGetFontVariationSettings } from "@instacart/ids-core";
var INSTACART_SANS_FONT_FAMILY = "Instacart Sans";
var INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS = `"${INSTACART_SANS_FONT_FAMILY}", Helvetica, Arial, sans-serif`;
var FONT_VARIATION_CONSTANTS = {
  wght: {
    normal: 400,
    semiBold: 600,
    bold: 700,
    extraBold: 800
  },
  opsz: {
    // These values are encoded into the static versions of our Instacart Sans
    // fonts. With our variable fonts we can just change this axis of variation
    // to get the same effect as changing font families.
    headline: 48,
    // Maps to Instacart Sans Headline
    subhead: 32,
    // Maps to Instacart Sans Subhead
    text: 8
    // Maps to Instacart Sans Text
  }
};
var getVariationSettings = createGetFontVariationSettings(FONT_VARIATION_CONSTANTS);
var typography = {
  headline: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 28,
    lineHeight: "32px"
  }, getVariationSettings({ wght: "semiBold", opsz: "subhead" })),
  title: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 24,
    lineHeight: "28px"
  }, getVariationSettings({ wght: "semiBold", opsz: "subhead" })),
  subtitle: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 18,
    lineHeight: "22px"
  }, getVariationSettings({ wght: "semiBold", opsz: "text" })),
  bodyRegular: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({ wght: "normal", opsz: "text" })),
  bodyEmphasized: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({ wght: "semiBold", opsz: "text" })),
  bodyStrikethrough: __spreadProps(__spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({ wght: "normal", opsz: "text" })), {
    textDecoration: "line-through"
  }),
  bodyLink: __spreadProps(__spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({ wght: "semiBold", opsz: "text" })), {
    textDecoration: "underline"
  }),
  accentRegular: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 12,
    lineHeight: "18px"
  }, getVariationSettings({ wght: "normal", opsz: "text" })),
  accentEmphasized: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 12,
    lineHeight: "18px"
  }, getVariationSettings({ wght: "semiBold", opsz: "text" }))
};

// src/atoms/theme/TDS_DEFAULT_COLORS.ts
var TDS_DEFAULT_COLORS = {
  colors: {
    systemGrayscale00: "#FFFFFF",
    systemGrayscale10: "#F6F7F8",
    systemGrayscale20: "#E8E9EB",
    systemGrayscale30: "#C7C8CD",
    systemGrayscale60: "#56595E",
    systemGrayscale80: "#242529",
    systemDetrimentalRegular: "#DE3534",
    systemDetrimentalDark: "#BB1C1B",
    systemDetrimentalExtraDark: "#AC1615",
    systemDetrimentalLight: "#FEF0F0",
    systemSuccessRegular: "#108910",
    systemSuccessDark: "#0D720D",
    systemSuccessExtraDark: "#0A610A",
    systemSuccessLight: "#E9FBE9",
    systemAlertRegular: "#F89F1A",
    systemAlertLight: "#FFFADF",
    systemInfoRegular: "#242529",
    systemInfoLight: "#FCF7F1",
    brandPrimaryRegular: "#0A5546",
    brandPrimaryDark: "#003D29",
    brandPrimaryExtraDark: "#001810",
    brandPrimaryLight: "#ECF6F3",
    brandPrimaryExtraLight: "#F5FBF9",
    dataCategory1: "#01A3AC",
    dataCategory2: "#5D5FEF",
    dataCategory3: "#7008A1",
    dataCategory4: "#EC269A",
    dataCategory5: "#003D29",
    dataSequentialSet1_1: "#01A3AC",
    dataSequentialSet1_2: "#1DBEC7",
    dataSequentialSet1_3: "#22D7E2",
    dataSequentialSet1_4: "#4BEAF3",
    dataSequentialSet1_5: "#75F7FF",
    dataSequentialSet2_1: "#5D5FEF",
    dataSequentialSet2_2: "#7C7DFF",
    dataSequentialSet2_3: "#9899FF",
    dataSequentialSet2_4: "#AFB0FF",
    dataSequentialSet2_5: "#CACFFF",
    dataSequentialSet3_1: "#7008A1",
    dataSequentialSet3_2: "#9B20D6",
    dataSequentialSet3_3: "#BE48F6",
    dataSequentialSet3_4: "#D479FF",
    dataSequentialSet3_5: "#E6B0FF",
    dataSequentialSet4_1: "#EC269A",
    dataSequentialSet4_2: "#FA54B5",
    dataSequentialSet4_3: "#FF7EC9",
    dataSequentialSet4_4: "#FFA6DA",
    dataSequentialSet4_5: "#FFD0EC",
    dataSequentialSet5_1: "#003D29",
    dataSequentialSet5_2: "#075D40",
    dataSequentialSet5_3: "#0A8C5C",
    dataSequentialSet5_4: "#23BF90",
    dataSequentialSet5_5: "#7DE4B9"
  }
};

// src/atoms/theme/TdsProvider.tsx
var import_deepmerge = __toESM(require_cjs());
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { useMemo as useMemo2 } from "react";

// src/atoms/theme/coreTheme.ts
var coreTheme = {
  tdsColors: TDS_DEFAULT_COLORS.colors,
  tdsRadius: radius,
  tdsTypography: typography
};

// src/atoms/theme/TdsProvider.tsx
import { MantineProvider } from "@mantine/core";

// src/atoms/theme/useTheme.tsx
import { useContext, useMemo } from "react";
import { useTheme as emotionUseTheme } from "@emotion/react";
import { CachedTDSThemeContext } from "@instacart/ids-core";
import { jsx } from "@emotion/react/jsx-runtime";
var ERROR_MESSAGE = `No <TdsProvider> in scope. Please add a <TdsProvider> to your component tree.`;
function useTheme() {
  const tdsContext = useContext(CachedTDSThemeContext);
  if (!tdsContext) {
    throw new Error(ERROR_MESSAGE);
  }
  return tdsContext.theme;
}
__name(useTheme, "useTheme");
function deriveThemeFromEmotionTheme(emotionTheme) {
  return {
    colors: emotionTheme.tdsColors,
    typography: emotionTheme.tdsTypography,
    radius: emotionTheme.tdsRadius
  };
}
__name(deriveThemeFromEmotionTheme, "deriveThemeFromEmotionTheme");
function CachedTdsThemeProvider({ children }) {
  const emotionTheme = emotionUseTheme();
  if (!("tdsColors" in emotionTheme) || !("tdsTypography" in emotionTheme) || !("tdsRadius" in emotionTheme)) {
    throw new Error(ERROR_MESSAGE);
  }
  const tdsTheme = useMemo(() => {
    return deriveThemeFromEmotionTheme(emotionTheme);
  }, [emotionTheme]);
  return /* @__PURE__ */ jsx(CachedTDSThemeContext.Provider, { value: { theme: tdsTheme }, children });
}
__name(CachedTdsThemeProvider, "CachedTdsThemeProvider");

// src/atoms/theme/TdsProvider.tsx
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import { jsx as jsx2 } from "@emotion/react/jsx-runtime";
function TdsProvider({
  children,
  theme: themeOverride = coreTheme
}) {
  const mergedTheme = useMemo2(() => {
    return (0, import_deepmerge.default)(coreTheme, themeOverride);
  }, [themeOverride]);
  return /* @__PURE__ */ jsx2(EmotionThemeProvider, { theme: mergedTheme, children: /* @__PURE__ */ jsx2(CachedTdsThemeProvider, { children: /* @__PURE__ */ jsx2(TdsMantineProvider, { children }) }) });
}
__name(TdsProvider, "TdsProvider");
function TdsMantineProvider({ children }) {
  return /* @__PURE__ */ jsx2(MantineProvider, { children });
}
__name(TdsMantineProvider, "TdsMantineProvider");

// src/molecules/Alert/Alert.tsx
import { ApprovedIcon, InformationIcon, IssueIcon } from "@instacart/ids-core";
import { useState, forwardRef as forwardRef5 } from "react";

// src/molecules/CloseButton/CloseButton.tsx
import { CloseIcon } from "@instacart/ids-core";

// src/molecules/ButtonBase/ButtonBase.tsx
import { Button } from "@mantine/core";

// src/molecules/LoadingDots/LoadingDots.tsx
import { keyframes } from "@emotion/react";
import { A11Y } from "@instacart/ids-core";
import { Fragment, jsx as jsx3, jsxs } from "@emotion/react/jsx-runtime";
var defaultLoadingDotSize = "calc(1em - 5px)";
var defaultLoadingDotGap = "calc(0.75em - 3px)";
function LoadingDots({
  children,
  loadingDotSize,
  loadingDotGap,
  color
}) {
  const loadingDots = keyframes`
    0%, {
      opacity: 1;
    }

    33% {
      opacity: 0.6;
    }

    66%, 100% {
      opacity: 0.3;
    }
  `;
  const dot = {
    width: loadingDotSize != null ? loadingDotSize : defaultLoadingDotSize,
    height: loadingDotSize != null ? loadingDotSize : defaultLoadingDotSize,
    animation: `${loadingDots} 1500ms infinite linear`,
    borderRadius: "50%",
    backgroundColor: color || "currentcolor",
    opacity: 0.5,
    flex: "0 0 auto"
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "span",
      {
        "aria-hidden": "true",
        "data-testid": "loading-dots",
        css: {
          display: "flex",
          gap: loadingDotGap != null ? loadingDotGap : defaultLoadingDotGap,
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          userSelect: "none"
        },
        children: [
          /* @__PURE__ */ jsx3("span", { css: [dot, { animationDelay: "0ms" }] }),
          /* @__PURE__ */ jsx3("span", { css: [dot, { animationDelay: `500ms` }] }),
          /* @__PURE__ */ jsx3("span", { css: [dot, { animationDelay: `1000ms` }] })
        ]
      }
    ),
    /* @__PURE__ */ jsx3("span", { css: A11Y.visuallyHidden, children })
  ] });
}
__name(LoadingDots, "LoadingDots");

// src/molecules/ButtonBase/ButtonBase.tsx
import { forwardRef } from "react";
import { jsx as jsx4, jsxs as jsxs2 } from "@emotion/react/jsx-runtime";
var ButtonBase = forwardRef((props, ref) => {
  const theme = useTheme();
  const _a = props, {
    disabled,
    loading,
    leftIcon: LeftIcon,
    rightIcon: RightIcon,
    compact,
    onClick,
    styles: styles3,
    fullWidth,
    className: className,
    style
  } = _a, rest = __objRest(_a, [
    "disabled",
    "loading",
    "leftIcon",
    "rightIcon",
    "compact",
    "onClick",
    "styles",
    "fullWidth",
    /** The below props are omitted to prevent custom restyling */
    "className",
    "style"
  ]);
  const {
    activeColor,
    activeTextColor,
    backgroundColor,
    borderColor,
    textColor,
    disabledTextColor,
    dotLoaderColor,
    focusColor,
    hoverColor,
    hoverTextColor,
    disabledColor,
    padding = compact ? `${spacing.s4} ${spacing.s16}` : `${spacing.s8} ${spacing.s16}`,
    minWidth = "96px",
    minHeight = compact ? "28px" : "40px",
    loadingDotSize = 8,
    loadingDotGap = 4,
    iconGap = spacing.s8,
    iconSize = compact ? 16 : 24,
    borderRadius = compact ? radius.interactiveCompact : radius.interactive
  } = styles3;
  const width = fullWidth ? "100%" : "auto";
  const textTypography = compact ? typography.accentEmphasized : typography.bodyEmphasized;
  return /* @__PURE__ */ jsxs2(
    Button,
    __spreadProps(__spreadValues({
      ref,
      disabled,
      leftSection: LeftIcon && /* @__PURE__ */ jsx4(LeftIcon, { size: iconSize, fill: "currentColor", stroke: "currentColor" }),
      rightSection: RightIcon && /* @__PURE__ */ jsx4(RightIcon, { size: iconSize, fill: "currentColor", stroke: "currentColor" }),
      styles: {
        // 'inner' refers to the Mantine Button's inner span
        // We apply these styles so any left or right icons are aligned properly
        inner: {
          display: "flex",
          justifyContent: "center",
          gap: iconGap
        },
        section: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        label: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      },
      css: {
        backgroundColor: backgroundColor ? theme.colors[backgroundColor] : "transparent",
        border: !disabled && borderColor ? `1px solid ${theme.colors[borderColor]}` : "none",
        borderRadius,
        cursor: "pointer",
        padding,
        position: "relative",
        minHeight,
        minWidth,
        width,
        color: theme.colors[textColor],
        "&:hover": {
          backgroundColor: theme.colors[hoverColor],
          color: theme.colors[hoverTextColor]
        },
        "&:active": {
          backgroundColor: theme.colors[activeColor],
          color: theme.colors[activeTextColor]
        },
        ":focus-visible": {
          // focus has the same styles as hover, with the inclusion of outline
          backgroundColor: theme.colors[hoverColor],
          color: theme.colors[hoverTextColor],
          outline: `2px solid ${theme.colors[focusColor]}`,
          outlineOffset: "2px"
        },
        ":disabled": {
          backgroundColor: theme.colors[disabledColor],
          color: theme.colors[disabledTextColor],
          cursor: "not-allowed"
        }
      },
      style: __spreadValues({}, loading && {
        backgroundColor: theme.colors[activeColor],
        cursor: "not-allowed"
      }),
      onClick: loading || disabled ? void 0 : onClick,
      unstyled: true
    }, rest), {
      children: [
        loading && /* @__PURE__ */ jsx4(
          "div",
          {
            css: {
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: theme.colors[activeColor],
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "none",
              borderRadius
            },
            children: /* @__PURE__ */ jsx4(
              LoadingDots,
              {
                loadingDotSize,
                loadingDotGap,
                color: theme.colors[dotLoaderColor]
              }
            )
          }
        ),
        /* @__PURE__ */ jsx4("span", { css: __spreadValues({ display: "flex" }, textTypography), children: props.children })
      ]
    })
  );
});
ButtonBase.displayName = "ButtonBase";

// src/layout/Flex/Flex.tsx
import { Flex as IdsFlex } from "@instacart/ids-core";
import { jsx as jsx5 } from "@emotion/react/jsx-runtime";
function Row(_a) {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx5(IdsFlex, __spreadProps(__spreadValues({ flexDirection: "row" }, rest), { children }));
}
__name(Row, "Row");
function Column(_a) {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx5(IdsFlex, __spreadProps(__spreadValues({ flexDirection: "column" }, rest), { children }));
}
__name(Column, "Column");
var Flex = IdsFlex;
Flex.Row = Row;
Flex.Column = Column;

// src/molecules/Button/ButtonGroup.tsx
import { jsx as jsx6 } from "@emotion/react/jsx-runtime";
function ButtonGroup({ children }) {
  return /* @__PURE__ */ jsx6(Flex.Row, { alignItems: "center", css: { gap: spacing.s8 }, children });
}
__name(ButtonGroup, "ButtonGroup");

// src/molecules/Button/utils.ts
var getButtonStylesForVariant = /* @__PURE__ */ __name((variant) => {
  if (variant === "primary") {
    return {
      backgroundColor: "brandPrimaryRegular",
      textColor: "systemGrayscale00",
      hoverTextColor: "systemGrayscale00",
      disabledTextColor: "systemGrayscale30",
      hoverColor: "brandPrimaryDark",
      focusColor: "systemGrayscale80",
      activeColor: "brandPrimaryExtraDark",
      activeTextColor: "systemGrayscale00",
      disabledColor: "systemGrayscale10",
      dotLoaderColor: "systemGrayscale00"
    };
  }
  if (variant === "secondary") {
    return {
      borderColor: "systemGrayscale20",
      backgroundColor: "systemGrayscale00",
      textColor: "brandPrimaryRegular",
      hoverTextColor: "brandPrimaryDark",
      disabledTextColor: "systemGrayscale30",
      hoverColor: "brandPrimaryLight",
      focusColor: "systemGrayscale80",
      activeColor: "brandPrimaryExtraLight",
      activeTextColor: "brandPrimaryExtraDark",
      disabledColor: "systemGrayscale10",
      dotLoaderColor: "brandPrimaryExtraDark"
    };
  }
  if (variant === "tertiary") {
    return {
      backgroundColor: "systemGrayscale00",
      textColor: "brandPrimaryRegular",
      hoverTextColor: "brandPrimaryDark",
      disabledTextColor: "systemGrayscale30",
      hoverColor: "brandPrimaryLight",
      focusColor: "systemGrayscale80",
      activeColor: "brandPrimaryExtraLight",
      activeTextColor: "brandPrimaryExtraDark",
      disabledColor: "systemGrayscale10",
      dotLoaderColor: "brandPrimaryExtraDark"
    };
  }
  if (variant === "detrimental") {
    return {
      backgroundColor: "systemDetrimentalRegular",
      textColor: "systemGrayscale00",
      hoverTextColor: "systemGrayscale00",
      disabledTextColor: "systemGrayscale30",
      hoverColor: "systemDetrimentalDark",
      focusColor: "systemGrayscale80",
      activeColor: "systemDetrimentalExtraDark",
      activeTextColor: "systemGrayscale00",
      disabledColor: "systemGrayscale10",
      dotLoaderColor: "systemGrayscale00"
    };
  }
  if (variant === "detrimental-secondary") {
    return {
      borderColor: "systemGrayscale20",
      backgroundColor: "systemGrayscale00",
      textColor: "systemDetrimentalRegular",
      hoverTextColor: "systemDetrimentalDark",
      disabledTextColor: "systemGrayscale30",
      hoverColor: "systemDetrimentalLight",
      focusColor: "systemGrayscale80",
      activeColor: "systemDetrimentalLight",
      activeTextColor: "systemDetrimentalExtraDark",
      disabledColor: "systemGrayscale10",
      dotLoaderColor: "systemDetrimentalExtraDark"
    };
  }
  if (variant === "detrimental-tertiary") {
    return {
      backgroundColor: "systemGrayscale00",
      textColor: "systemDetrimentalRegular",
      hoverTextColor: "systemDetrimentalDark",
      disabledTextColor: "systemGrayscale30",
      hoverColor: "systemDetrimentalLight",
      focusColor: "systemGrayscale80",
      activeColor: "systemDetrimentalLight",
      activeTextColor: "systemDetrimentalExtraDark",
      disabledColor: "systemGrayscale10",
      dotLoaderColor: "systemDetrimentalExtraDark"
    };
  }
  return {
    backgroundColor: null,
    textColor: "systemGrayscale80",
    hoverTextColor: "systemGrayscale80",
    disabledTextColor: "systemGrayscale00",
    dotLoaderColor: "brandPrimaryExtraDark",
    hoverColor: "systemGrayscale10",
    focusColor: "systemGrayscale80",
    activeColor: "systemGrayscale20",
    activeTextColor: "systemGrayscale80",
    disabledColor: "systemGrayscale30"
  };
}, "getButtonStylesForVariant");

// src/molecules/Button/Button.tsx
import { forwardRef as forwardRef2 } from "react";
import { jsx as jsx7 } from "@emotion/react/jsx-runtime";
var Button2 = forwardRef2((props, ref) => {
  const _a = props, { variant = "primary" } = _a, rest = __objRest(_a, ["variant"]);
  const styles3 = getButtonStylesForVariant(variant);
  return /* @__PURE__ */ jsx7(ButtonBase, __spreadValues({ ref, styles: styles3 }, rest));
});
Button2.Group = ButtonGroup;
Button2.displayName = "Button";

// src/molecules/Button/IconButton.tsx
import { forwardRef as forwardRef3 } from "react";
import { jsx as jsx8 } from "@emotion/react/jsx-runtime";
var IconButton = forwardRef3(
  /* @__PURE__ */ __name(function IconButton2(props, ref) {
    const _a = props, { compact, variant = "primary", icon: Icon, disabled, size } = _a, rest = __objRest(_a, ["compact", "variant", "icon", "disabled", "size"]);
    const iconButtonStyles = __spreadProps(__spreadValues({}, getButtonStylesForVariant(variant)), {
      padding: compact ? "4px" : "10px",
      loadingDotSize: compact ? 4 : 6,
      loadingDotGap: 2,
      minWidth: "20px",
      minHeight: "20px",
      width: "auto"
    });
    const iconSize = size != null ? size : compact ? 16 : 20;
    const iconColor = rest.color ? rest.color : "currentColor";
    return /* @__PURE__ */ jsx8(
      ButtonBase,
      __spreadProps(__spreadValues({
        ref,
        styles: iconButtonStyles,
        compact,
        disabled
      }, rest), {
        children: /* @__PURE__ */ jsx8(Icon, { size: iconSize, fill: iconColor, stroke: iconColor })
      })
    );
  }, "IconButton")
);

// src/molecules/CloseButton/CloseButton.tsx
import { forwardRef as forwardRef4 } from "react";
import { jsx as jsx9 } from "@emotion/react/jsx-runtime";
var CloseButton = forwardRef4((props, ref) => {
  const _a = props, { variant = "unstyled" } = _a, rest = __objRest(_a, ["variant"]);
  return /* @__PURE__ */ jsx9(IconButton, __spreadValues({ ref, icon: CloseIcon, variant }, rest));
});

// src/molecules/Alert/Alert.tsx
import { jsx as jsx10, jsxs as jsxs3 } from "@emotion/react/jsx-runtime";
var Alert = forwardRef5((props, ref) => {
  const _a = props, {
    layout = "horizontal",
    variant = "info",
    buttons,
    children,
    isDismissible = false,
    onDismiss,
    css: css2,
    style,
    className
  } = _a, rest = __objRest(_a, [
    "layout",
    "variant",
    "buttons",
    "children",
    "isDismissible",
    "onDismiss",
    /** The below props are omitted to prevent custom restyling */
    "css",
    "style",
    "className"
  ]);
  const [visible, setVisible] = useState(true);
  const handleDismiss = /* @__PURE__ */ __name(() => {
    setVisible(false);
    onDismiss == null ? void 0 : onDismiss();
  }, "handleDismiss");
  const theme = useTheme();
  if (!visible) {
    return null;
  }
  const alertContainerStyles = {
    padding: "16px",
    borderRadius: "4px",
    gap: "16px",
    display: "flex",
    alignItems: "start",
    justifyContent: "space-between",
    backgroundColor: "systemGrayscale00"
  };
  const bodyContainerStyles = __spreadValues({
    display: "flex",
    flexDirection: layout === "stacked" ? "column" : "row",
    flex: 1,
    justifyContent: "space-between",
    alignSelf: "center",
    alignItems: layout === "stacked" ? "flex-start" : "center",
    gap: "8px"
  }, typography.bodyRegular);
  const buttonsContainerStyles = {
    display: "flex",
    gap: "16px",
    alignItems: "end"
  };
  switch (variant) {
    case "info":
      alertContainerStyles.backgroundColor = theme.colors.systemInfoLight;
      break;
    case "success":
      alertContainerStyles.backgroundColor = theme.colors.systemSuccessLight;
      break;
    case "warning":
      alertContainerStyles.backgroundColor = theme.colors.systemAlertLight;
      break;
    case "error":
      alertContainerStyles.backgroundColor = theme.colors.systemDetrimentalLight;
      break;
  }
  const iconProps = {
    size: 24
  };
  let icon = /* @__PURE__ */ jsx10(InformationIcon, __spreadProps(__spreadValues({}, iconProps), { "data-testid": "information-icon" }));
  switch (variant) {
    case "success":
      icon = /* @__PURE__ */ jsx10(
        ApprovedIcon,
        __spreadProps(__spreadValues({}, iconProps), {
          fill: theme.colors.systemSuccessDark,
          "data-testid": "approved-icon"
        })
      );
      break;
    case "warning":
      icon = /* @__PURE__ */ jsx10(
        IssueIcon,
        __spreadProps(__spreadValues({}, iconProps), {
          fill: theme.colors.systemAlertRegular,
          "data-testid": "notification-icon"
        })
      );
      break;
    case "error":
      icon = /* @__PURE__ */ jsx10(
        IssueIcon,
        __spreadProps(__spreadValues({}, iconProps), {
          fill: theme.colors.systemDetrimentalDark,
          "data-testid": "issue-icon"
        })
      );
      break;
  }
  return /* @__PURE__ */ jsxs3("div", __spreadProps(__spreadValues({ css: alertContainerStyles, role: "alert", ref }, rest), { children: [
    icon,
    /* @__PURE__ */ jsxs3("div", { css: bodyContainerStyles, children: [
      children,
      buttons && /* @__PURE__ */ jsx10("div", { css: buttonsContainerStyles, children: buttons })
    ] }),
    isDismissible && /* @__PURE__ */ jsx10(CloseButton, { onClick: handleDismiss, compact: true, variant: "secondary" })
  ] }));
});

// src/molecules/LinkBase/LinkBase.tsx
import { Button as Button3 } from "@mantine/core";
import { jsx as jsx11 } from "@emotion/react/jsx-runtime";
function LinkBase(props) {
  const theme = useTheme();
  const _a = props, {
    leftIcon: LeftIcon,
    rightIcon: RightIcon,
    disabled,
    onClick,
    href,
    styles: styles3,
    onChange,
    hideUnderline,
    className: className,
    style
  } = _a, rest = __objRest(_a, [
    "leftIcon",
    "rightIcon",
    "disabled",
    "onClick",
    "href",
    "styles",
    "onChange",
    "hideUnderline",
    /** The below props are omitted to prevent custom restyling */
    "className",
    "style"
  ]);
  const { textColor, activeColor, disabledColor, focusColor, hoverColor } = styles3;
  return /* @__PURE__ */ jsx11(
    Button3,
    __spreadValues({
      component: "a",
      leftSection: LeftIcon && /* @__PURE__ */ jsx11(LeftIcon, { size: 16, fill: "currentColor", stroke: "currentColor" }),
      rightSection: RightIcon && /* @__PURE__ */ jsx11(RightIcon, { size: 16, fill: "currentColor", stroke: "currentColor" }),
      styles: {
        root: {
          display: "inline-flex"
        },
        section: {
          display: "inline-flex",
          alignItems: "center"
        },
        inner: {
          display: "inline-flex",
          columnGap: "4px"
        }
      },
      css: __spreadProps(__spreadValues({
        cursor: "pointer",
        color: theme.colors[textColor],
        "&:hover": {
          color: theme.colors[hoverColor]
        },
        "&:active": {
          color: theme.colors[activeColor]
        },
        ":focus-visible": {
          outline: `2px solid ${theme.colors[focusColor]}`,
          outlineOffset: "2px"
        }
      }, typography.bodyLink), {
        textDecoration: hideUnderline ? "none" : "underline",
        border: "none",
        borderRadius: "2px"
      }),
      style: __spreadValues({}, disabled && {
        color: theme.colors[disabledColor],
        cursor: "not-allowed"
      }),
      onClick: disabled ? void 0 : onClick,
      href: disabled ? void 0 : href,
      unstyled: true
    }, rest)
  );
}
__name(LinkBase, "LinkBase");

// src/molecules/Link/Link.tsx
import { jsx as jsx12 } from "@emotion/react/jsx-runtime";
var styles = {
  textColor: "brandPrimaryRegular",
  activeColor: "brandPrimaryExtraDark",
  hoverColor: "brandPrimaryDark",
  focusColor: "systemGrayscale80",
  disabledColor: "systemGrayscale30"
};
function Link(props) {
  return /* @__PURE__ */ jsx12(LinkBase, __spreadValues({ styles }, props));
}
__name(Link, "Link");

// src/molecules/DatePicker/SingleDatePicker/SingleDatePicker.tsx
import { useMemo as useMemo5, useEffect, useCallback as useCallback2, useState as useState2 } from "react";

// src/molecules/DatePickerBase/DatePickerBaseDropdown.tsx
import { useCallback } from "react";
import { Popover, Input } from "@mantine/core";

// src/molecules/DatePickerBase/utils/useSharedDatePickerConfig.tsx
import { useMemo as useMemo3 } from "react";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  DateIcon
} from "@instacart/ids-core";

// src/molecules/DatePickerBase/DatePickerDayIndicator.tsx
import { Indicator } from "@mantine/core";
import { jsx as jsx13 } from "@emotion/react/jsx-runtime";
function createCurrentDateIndicator(currentDate) {
  return (date) => {
    const theme = useTheme();
    const day = date.getDate();
    const disabled = date.getDate() !== currentDate.getDate() || date.getMonth() !== currentDate.getMonth() || date.getFullYear() !== currentDate.getFullYear();
    return /* @__PURE__ */ jsx13(
      Indicator,
      {
        "data-testid": "date-picker-day-indicator",
        size: 6,
        color: theme.colors.systemDetrimentalRegular,
        disabled,
        "data-disabled": disabled,
        style: {
          "--indicator-top": "-2px",
          "--indicator-right": "-4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "12px"
        },
        children: /* @__PURE__ */ jsx13("div", { children: day })
      }
    );
  };
}
__name(createCurrentDateIndicator, "createCurrentDateIndicator");

// src/molecules/DatePickerBase/utils/useSharedDatePickerConfig.tsx
import { jsx as jsx14 } from "@emotion/react/jsx-runtime";
var useSharedCalendarConfig = /* @__PURE__ */ __name((showDayIndicator) => {
  const currentDate = useMemo3(() => /* @__PURE__ */ new Date(), []);
  const CurrentDateIndicator = useMemo3(() => createCurrentDateIndicator(currentDate), [currentDate]);
  const sharedStyles = useMemo3(() => {
    return {
      calendarLeftIcon: ChevronLeftIcon,
      calendarRightIcon: ChevronRightIcon,
      calendarRenderDay: showDayIndicator ? CurrentDateIndicator : void 0
    };
  }, [showDayIndicator, CurrentDateIndicator]);
  return sharedStyles;
}, "useSharedCalendarConfig");
var useSharedInputConfig = /* @__PURE__ */ __name(({
  width,
  maxWidth,
  minWidth,
  compact,
  disabled,
  isCalendarOpen,
  readOnly,
  component
}) => {
  const theme = useTheme();
  const textColor = disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80;
  const sharedStyles = useMemo3(() => {
    return {
      inputLeftIcon: DateIcon({
        size: 16,
        fill: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale60
      }),
      inputRightIcon: readOnly ? void 0 : isCalendarOpen ? /* @__PURE__ */ jsx14(
        ChevronUpIcon,
        {
          size: 16,
          css: { cursor: disabled ? "not-allowed" : "pointer", fill: textColor }
        }
      ) : /* @__PURE__ */ jsx14(
        ChevronDownIcon,
        {
          size: 16,
          css: { cursor: disabled ? "not-allowed" : "pointer", fill: textColor }
        }
      ),
      css: {
        width,
        maxWidth,
        minWidth,
        [`& ${component}`]: __spreadValues({
          cursor: readOnly ? "unset" : "pointer",
          minHeight: "unset",
          height: compact ? "30px" : "40px",
          padding: compact ? "2px 34px" : "4px 34px",
          border: `1px solid ${isCalendarOpen ? theme.colors.brandPrimaryRegular : theme.colors.systemGrayscale30}`,
          borderRadius: compact ? radius.interactiveCompact : radius.interactive,
          color: textColor
        }, typography.bodyEmphasized),
        [`& ${component}[data-error="true"]`]: {
          backgroundColor: theme.colors.systemDetrimentalLight,
          borderColor: theme.colors.systemDetrimentalRegular
        },
        [`& ${component}:disabled`]: {
          backgroundColor: theme.colors.systemGrayscale10,
          color: theme.colors.systemGrayscale30,
          borderColor: theme.colors.systemGrayscale20
        },
        [`& ${component}:focus-visible:not([data-error="true"])`]: {
          borderColor: theme.colors.brandPrimaryRegular,
          outline: `2px solid ${theme.colors.systemGrayscale80}`,
          outlineOffset: "2px"
        },
        [`& ${component}[data-readonly="true"]`]: {
          backgroundColor: "transparent",
          borderColor: "transparent"
        },
        [`:hover ${component}:not(:disabled):not([data-error="true"]):not([data-readonly="true"])`]: {
          color: textColor,
          borderColor: theme.colors.systemGrayscale60
        }
      }
    };
  }, [
    disabled,
    theme,
    isCalendarOpen,
    textColor,
    width,
    maxWidth,
    minWidth,
    compact,
    readOnly,
    component
  ]);
  return sharedStyles;
}, "useSharedInputConfig");

// src/utils/getInputWidths.tsx
function isNumeric(value) {
  if (value === void 0 || value === null) {
    return false;
  }
  return !Number.isNaN(Number(value));
}
__name(isNumeric, "isNumeric");
function getInputWidths(props) {
  const { maxWidthPx: inputMaxWidth, minWidthPx: inputMinWidth, width: inputWidth } = props || {};
  let width = "100%";
  let maxWidth = "628px";
  let minWidth = "100px";
  if (inputWidth !== void 0) {
    width = isNumeric(inputWidth) ? `${inputWidth}px` : inputWidth;
  }
  if (inputMaxWidth !== void 0 && isNumeric(inputMaxWidth)) {
    maxWidth = `${Math.min(inputMaxWidth, 628)}px`;
  }
  if (inputMinWidth !== void 0 && isNumeric(inputMinWidth)) {
    minWidth = `${inputMinWidth}px`;
  }
  return { width, maxWidth, minWidth };
}
__name(getInputWidths, "getInputWidths");

// src/molecules/DatePickerBase/DatePickerBaseDropdown.tsx
import { RemoveIcon } from "@instacart/ids-core";
import { jsx as jsx15, jsxs as jsxs4 } from "@emotion/react/jsx-runtime";
function DatePickerBaseDropdown(props) {
  const theme = useTheme();
  const closeIconTestId = "date-picker-close-icon";
  const _a = props, {
    disabled,
    compact,
    label,
    error,
    readOnly,
    formattedValue,
    children,
    isCalendarOpen,
    setIsCalendarOpen,
    width,
    maxWidthPx,
    minWidthPx,
    popoverProps,
    clearDateInput,
    css: css2,
    style,
    className
  } = _a, rest = __objRest(_a, [
    "disabled",
    "compact",
    "label",
    "error",
    "readOnly",
    "formattedValue",
    "children",
    "isCalendarOpen",
    "setIsCalendarOpen",
    "width",
    "maxWidthPx",
    "minWidthPx",
    "popoverProps",
    "clearDateInput",
    /** The below props are omitted to prevent custom restyling */
    "css",
    "style",
    "className"
  ]);
  const {
    width: inputWidth,
    maxWidth: inputMaxWidth,
    minWidth: inputMinWidth
  } = getInputWidths({
    width,
    maxWidthPx,
    minWidthPx
  });
  const {
    css: inputCSS,
    inputLeftIcon,
    inputRightIcon
  } = useSharedInputConfig({
    component: "button",
    width: inputWidth,
    maxWidth: inputMaxWidth,
    minWidth: inputMinWidth,
    compact,
    disabled,
    isCalendarOpen,
    readOnly
  });
  const updateIsCalendarOpen = useCallback(
    (isOpen) => {
      if (!disabled && !readOnly) {
        setIsCalendarOpen(isOpen);
      } else if (!isOpen) {
        setIsCalendarOpen(false);
      }
    },
    [disabled, readOnly, setIsCalendarOpen]
  );
  const foscusAndActiveStyles = {
    ":focus-visible": {
      outline: `1px solid ${theme.colors.brandPrimaryRegular}`,
      outlineOffset: "1px"
    },
    ":focus": {
      outline: `1px solid ${theme.colors.brandPrimaryRegular}`,
      outlineOffset: "1px"
    },
    ":active": {
      outline: "none"
    }
  };
  const renderRemoveIcon = /* @__PURE__ */ __name(() => {
    return /* @__PURE__ */ jsx15(
      RemoveIcon,
      {
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            clearDateInput == null ? void 0 : clearDateInput();
          }
        },
        css: foscusAndActiveStyles,
        tabIndex: 0,
        "data-testid": closeIconTestId,
        onClick: clearDateInput,
        color: "systemGrayscale60"
      }
    );
  }, "renderRemoveIcon");
  const rightSection = inputRightIcon ? /* @__PURE__ */ jsxs4(
    Flex,
    {
      style: {
        display: "flex",
        cursor: "pointer",
        right: 10,
        position: "absolute"
      },
      children: [
        formattedValue && renderRemoveIcon(),
        /* @__PURE__ */ jsx15(
          Flex,
          {
            css: __spreadProps(__spreadValues({}, foscusAndActiveStyles), {
              marginLeft: spacing.s8
            }),
            onClick: () => updateIsCalendarOpen(!isCalendarOpen),
            role: "button",
            tabIndex: 0,
            onKeyDown: (e) => {
              if (e.key === "Enter") {
                updateIsCalendarOpen(!isCalendarOpen);
              }
            },
            children: inputRightIcon
          }
        )
      ]
    }
  ) : renderRemoveIcon();
  return /* @__PURE__ */ jsx15(
    Input.Wrapper,
    {
      styles: {
        root: {
          width: inputWidth,
          minWidth: inputMinWidth
        },
        label: __spreadValues({}, typography.bodyEmphasized),
        error: { color: theme.colors.systemDetrimentalRegular }
      },
      label,
      error,
      children: /* @__PURE__ */ jsxs4(
        Popover,
        __spreadProps(__spreadValues({
          position: "bottom-start",
          trapFocus: false,
          opened: isCalendarOpen,
          onOpen: () => updateIsCalendarOpen(true),
          onClose: () => updateIsCalendarOpen(false),
          closeOnClickOutside: true,
          closeOnEscape: true,
          styles: {
            dropdown: __spreadValues({
              borderRadius: radius.interactive
            }, elevation.high.shadow)
          }
        }, popoverProps), {
          children: [
            /* @__PURE__ */ jsx15(Popover.Target, { children: /* @__PURE__ */ jsx15(
              Input,
              __spreadProps(__spreadValues({
                css: inputCSS,
                type: "button",
                component: "button",
                leftSection: inputLeftIcon,
                rightSection,
                leftSectionPointerEvents: "none",
                rightSectionPointerEvents: "auto",
                disabled,
                "data-readonly": readOnly,
                "data-error": Boolean(error),
                onClick: (e) => {
                  if (!e.target.closest(`[data-testid="${closeIconTestId}"]`)) {
                    updateIsCalendarOpen(!isCalendarOpen);
                  }
                }
              }, rest), {
                children: formattedValue
              })
            ) }),
            /* @__PURE__ */ jsx15(Popover.Dropdown, { children })
          ]
        })
      )
    }
  );
}
__name(DatePickerBaseDropdown, "DatePickerBaseDropdown");

// src/molecules/DatePickerBase/DatePickerCalendar.tsx
import { useMemo as useMemo4 } from "react";
import {
  DatePicker as MantineDatePicker
} from "@mantine/dates";
import { ClassNames } from "@emotion/react";
import { jsx as jsx16 } from "@emotion/react/jsx-runtime";
var getSharedButtonStyles = /* @__PURE__ */ __name((theme) => {
  const calendarButtonStyles = getButtonStylesForVariant("tertiary");
  return {
    backgroundColor: theme.colors[calendarButtonStyles.backgroundColor],
    color: theme.colors[calendarButtonStyles.textColor],
    ":focus-visible": {
      backgroundColor: theme.colors[calendarButtonStyles.hoverColor],
      outline: `2px solid ${theme.colors[calendarButtonStyles.focusColor]}`,
      outlineOffset: "2px"
    },
    ":hover": {
      backgroundColor: `${theme.colors[calendarButtonStyles.hoverColor]} !important`,
      color: `${theme.colors[calendarButtonStyles.hoverTextColor]} !important`
    },
    ":active": {
      backgroundColor: `${theme.colors[calendarButtonStyles.activeColor]} !important`,
      color: `${theme.colors[calendarButtonStyles.activeTextColor]} !important`
    },
    ":disabled": {
      color: `${theme.colors[calendarButtonStyles.disabledTextColor]} !important`,
      backgroundColor: `${theme.colors[calendarButtonStyles.backgroundColor]} !important`
    }
  };
}, "getSharedButtonStyles");
function DatePickerCalendar(props) {
  const theme = useTheme();
  const _a = props, { showDayIndicator, defaultValue, defaultDate } = _a, rest = __objRest(_a, ["showDayIndicator", "defaultValue", "defaultDate"]);
  const {
    calendarRightIcon: CalendarNextIcon,
    calendarLeftIcon: CalendarPreviousIcon,
    calendarRenderDay
  } = useSharedCalendarConfig(showDayIndicator);
  const sharedButtonStyles = useMemo4(() => getSharedButtonStyles(theme), [theme]);
  return /* @__PURE__ */ jsx16(ClassNames, { children: ({ css: css2 }) => /* @__PURE__ */ jsx16(
    MantineDatePicker,
    __spreadValues({
      classNames: {
        calendarHeader: css2(__spreadProps(__spreadValues({
          display: "flex",
          columnGap: spacing.s8
        }, typography.subtitle), {
          marginBottom: spacing.s16,
          width: "100%",
          maxWidth: "unset"
        })),
        calendarHeaderLevel: css2(__spreadValues(__spreadValues({}, typography.subtitle), sharedButtonStyles)),
        calendarHeaderControl: css2(__spreadValues({}, sharedButtonStyles)),
        month: css2({
          width: "auto"
        }),
        monthCell: css2({
          border: `1px solid ${theme.colors.systemGrayscale20}`,
          "&[data-with-spacing]": {
            padding: 0
          },
          height: "auto"
        }),
        yearsListControl: css2(__spreadValues(__spreadValues({}, typography.bodyEmphasized), sharedButtonStyles)),
        monthsListControl: css2(__spreadValues(__spreadValues({}, typography.bodyEmphasized), sharedButtonStyles)),
        day: css2(__spreadProps(__spreadValues({}, typography.accentEmphasized), {
          color: theme.colors.systemGrayscale80,
          borderRadius: 0,
          height: 39,
          width: 39,
          "&:not([disabled]):not([data-selected])": {
            "&:hover": {
              color: `${theme.colors.systemGrayscale80} !important`,
              backgroundColor: `${theme.colors.brandPrimaryExtraLight} !important`
            },
            "&:active": {
              color: `${theme.colors.systemGrayscale00} !important`,
              backgroundColor: `${theme.colors.brandPrimaryDark} !important`
            }
          },
          "&[data-selected]": {
            backgroundColor: `${theme.colors.brandPrimaryRegular} !important`,
            color: `${theme.colors.systemGrayscale00} !important`,
            "&:hover": {
              backgroundColor: `${theme.colors.brandPrimaryDark} !important`,
              color: `${theme.colors.systemGrayscale00} !important`
            }
          },
          "&[disabled]": {
            pointerEvents: "none"
          },
          "&[data-in-range]:hover:not([data-selected])": {
            backgroundColor: `${theme.colors.brandPrimaryLight} !important`
          },
          "&[data-in-range]:not([data-selected])": {
            backgroundColor: `${theme.colors.brandPrimaryLight} !important`,
            "&:active": {
              backgroundColor: `${theme.colors.brandPrimaryDark} !important`
            }
          },
          ":focus-visible": {
            outline: `2px solid ${theme.colors.systemGrayscale80}`,
            outlineOffset: "-1px"
          }
        })),
        weekday: css2(__spreadValues({
          color: theme.colors.systemGrayscale60
        }, typography.accentRegular)),
        levelsGroup: css2({
          gap: spacing.s24
        })
      },
      nextIcon: /* @__PURE__ */ jsx16(CalendarNextIcon, { size: 24, fill: "currentColor", stroke: "currentColor" }),
      renderDay: calendarRenderDay,
      previousIcon: /* @__PURE__ */ jsx16(CalendarPreviousIcon, { size: 24, fill: "currentColor", stroke: "currentColor" }),
      hideOutsideDates: true
    }, rest)
  ) });
}
__name(DatePickerCalendar, "DatePickerCalendar");

// src/molecules/DatePickerBase/utils/dateFormatUtils.ts
var import_dayjs = __toESM(require_dayjs_min());
var DATE_FORMAT = "MMM D, YYYY";
var DATE_HYPHEN = "\u2013";
var formatSingleDate = /* @__PURE__ */ __name((date) => {
  if (!date) {
    return "";
  }
  const parsedDate = (0, import_dayjs.default)(date);
  if (!parsedDate.isValid()) {
    return "";
  }
  return parsedDate.format(DATE_FORMAT);
}, "formatSingleDate");
var formatDateRange = /* @__PURE__ */ __name((dateRange) => {
  if (!dateRange) return "";
  const { startDate, endDate } = dateRange;
  if (!startDate || !endDate) return "";
  return `${formatSingleDate(startDate)} ${DATE_HYPHEN} ${formatSingleDate(endDate)}`;
}, "formatDateRange");

// src/molecules/DatePicker/SingleDatePicker/SingleDatePicker.tsx
import { jsx as jsx17 } from "@emotion/react/jsx-runtime";
function SingleDatePicker(props) {
  const _a = props, {
    value,
    onChange,
    label,
    error,
    compact,
    readOnly,
    disabled,
    calendarProps,
    showDayIndicator = true,
    closeOnChange = true,
    minWidthPx = 200
  } = _a, rest = __objRest(_a, [
    "value",
    "onChange",
    "label",
    "error",
    "compact",
    "readOnly",
    "disabled",
    "calendarProps",
    "showDayIndicator",
    "closeOnChange",
    "minWidthPx"
  ]);
  const [focusedDate, setFocusedDate] = useState2(() => /* @__PURE__ */ new Date());
  const [isCalendarOpen, setIsCalendarOpen] = useState2(false);
  useEffect(() => {
    if (value) {
      setFocusedDate(value);
    }
  }, [value]);
  const { formattedValue } = useMemo5(
    () => ({
      formattedValue: formatSingleDate(value)
    }),
    [value]
  );
  const onChangeHandler = useCallback2(
    (newDate) => {
      onChange == null ? void 0 : onChange(newDate);
      if (closeOnChange) {
        setIsCalendarOpen(false);
      }
    },
    [onChange, closeOnChange]
  );
  return /* @__PURE__ */ jsx17(
    DatePickerBaseDropdown,
    __spreadProps(__spreadValues({
      "data-testid": "single-date-picker-input",
      label,
      error,
      compact,
      readOnly,
      disabled,
      isCalendarOpen,
      formattedValue,
      setIsCalendarOpen,
      clearDateInput: () => {
        setIsCalendarOpen(false);
        onChange == null ? void 0 : onChange(null);
      },
      minWidthPx
    }, rest), {
      children: /* @__PURE__ */ jsx17(
        DatePickerCalendar,
        __spreadValues({
          "data-testid": "single-date-picker-calendar",
          type: "default",
          hideOutsideDates: true,
          value,
          date: focusedDate,
          onChange: onChangeHandler,
          onDateChange: setFocusedDate,
          showDayIndicator
        }, calendarProps)
      )
    })
  );
}
__name(SingleDatePicker, "SingleDatePicker");

// src/molecules/DatePicker/DateRangePicker/DateRangePicker.tsx
import { useEffect as useEffect2, useState as useState3 } from "react";

// src/molecules/DatePickerBase/DatePickerBaseInput.tsx
import { DateInput } from "@mantine/dates";
import { RemoveIcon as RemoveIcon2 } from "@instacart/ids-core";
import { jsx as jsx18 } from "@emotion/react/jsx-runtime";
function DatePickerBaseInput({
  value,
  onChange,
  onCancel,
  label
}) {
  const theme = useTheme();
  const { inputLeftIcon, css: css2 } = useSharedInputConfig({
    width: "100%",
    compact: false,
    disabled: false,
    readOnly: false,
    isCalendarOpen: false,
    component: "input"
  });
  const foscusAndActiveStyles = {
    ":focus-visible": {
      outline: `1px solid ${theme.colors.brandPrimaryRegular}`,
      outlineOffset: "1px"
    },
    ":focus": {
      outline: `1px solid ${theme.colors.brandPrimaryRegular}`,
      outlineOffset: "1px"
    },
    ":active": {
      outline: "none"
    },
    cursor: "pointer"
  };
  const renderRemoveIcon = /* @__PURE__ */ __name(() => {
    return /* @__PURE__ */ jsx18(
      RemoveIcon2,
      {
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            onCancel == null ? void 0 : onCancel();
          }
        },
        css: foscusAndActiveStyles,
        tabIndex: 0,
        "data-testid": "date-picker-close-icon",
        onClick: onCancel,
        color: "systemGrayscale60"
      }
    );
  }, "renderRemoveIcon");
  return /* @__PURE__ */ jsx18(
    DateInput,
    {
      type: "input",
      leftSection: inputLeftIcon,
      rightSection: value && renderRemoveIcon(),
      value,
      onChange,
      valueFormat: DATE_FORMAT,
      css: css2,
      popoverProps: {
        // Hide the calendar, we only use the input for
        // parsing date values
        styles: {
          dropdown: {
            display: "none"
          }
        }
      },
      styles: {
        label: __spreadValues({}, theme.typography.bodyEmphasized),
        input: __spreadValues({}, theme.typography.bodyEmphasized)
      },
      label
    }
  );
}
__name(DatePickerBaseInput, "DatePickerBaseInput");

// src/molecules/Text/Text.tsx
import { forwardRef as forwardRef6, useMemo as useMemo6 } from "react";
import { ClassNames as ClassNames2 } from "@emotion/react";
import { jsx as jsx19 } from "@emotion/react/jsx-runtime";
var Text = forwardRef6(/* @__PURE__ */ __name(function Text2(_a, ref) {
  var _b = _a, {
    typography: typography2,
    as: Component = "p",
    color,
    children,
    className,
    style,
    tabularNumbers
  } = _b, rest = __objRest(_b, [
    "typography",
    "as",
    "color",
    "children",
    "className",
    "style",
    "tabularNumbers"
  ]);
  const theme = useTheme();
  const typographyStyles = theme.typography[typography2];
  const colorValue = color ? theme.colors[color] : theme.colors.systemGrayscale80;
  const computedStyle = useMemo6(() => {
    return __spreadValues(__spreadProps(__spreadValues({}, typographyStyles), {
      color: colorValue
    }), tabularNumbers ? { fontVariantNumeric: "tabular-nums" } : {});
  }, [typographyStyles, colorValue, tabularNumbers]);
  const styleProp = useMemo6(() => {
    return style ? __spreadValues(__spreadValues({}, style), computedStyle) : void 0;
  }, [style, computedStyle]);
  return /* @__PURE__ */ jsx19(ClassNames2, { children: ({ css: css2, cx }) => /* @__PURE__ */ jsx19(
    Component,
    __spreadProps(__spreadValues({}, rest), {
      ref,
      className: cx(className, css2(computedStyle)),
      style: styleProp,
      children
    })
  ) });
}, "Text"));
Text.displayName = "Text";

// src/molecules/DatePickerBase/DatePickerPresetItem.tsx
import { ConfirmIcon } from "@instacart/ids-core";

// src/molecules/DatePickerBase/utils/DateRangePickerPresets.utils.ts
var import_dayjs2 = __toESM(require_dayjs_min());
var import_quarterOfYear = __toESM(require_quarterOfYear());
import_dayjs2.default.extend(import_quarterOfYear.default);
var DateRangePickerPresetOption = /* @__PURE__ */ ((DateRangePickerPresetOption2) => {
  DateRangePickerPresetOption2["Custom"] = "custom";
  DateRangePickerPresetOption2["Yesterday"] = "yesterday";
  DateRangePickerPresetOption2["Last7Days"] = "last_7_days";
  DateRangePickerPresetOption2["Last28Days"] = "last_28_days";
  DateRangePickerPresetOption2["Last84Days"] = "last_84_days";
  DateRangePickerPresetOption2["LastWeek"] = "last_week";
  DateRangePickerPresetOption2["TwoWeeksAgo"] = "two_weeks_ago";
  DateRangePickerPresetOption2["ThreeWeeksAgo"] = "three_weeks_ago";
  DateRangePickerPresetOption2["FourWeeksAgo"] = "four_weeks_ago";
  DateRangePickerPresetOption2["FiveWeeksAgo"] = "five_weeks_ago";
  DateRangePickerPresetOption2["Last30Days"] = "last_30_days";
  DateRangePickerPresetOption2["LastMonth"] = "last_month";
  DateRangePickerPresetOption2["Last90Days"] = "last_90_days";
  DateRangePickerPresetOption2["QuarterToDate"] = "quarter_to_date";
  DateRangePickerPresetOption2["Last120Days"] = "last_120_days";
  DateRangePickerPresetOption2["LastYear"] = "last_1_year";
  DateRangePickerPresetOption2["YearToDate"] = "year_to_date";
  DateRangePickerPresetOption2["Last2Years"] = "last_2_years";
  DateRangePickerPresetOption2["Tomorrow"] = "tomorrow";
  DateRangePickerPresetOption2["Next7Days"] = "next_7_days";
  DateRangePickerPresetOption2["NextWeek"] = "next_week";
  DateRangePickerPresetOption2["NextMonth"] = "next_month";
  return DateRangePickerPresetOption2;
})(DateRangePickerPresetOption || {});
var WeekStartDay = /* @__PURE__ */ ((WeekStartDay2) => {
  WeekStartDay2["Saturday"] = "saturday";
  WeekStartDay2["Sunday"] = "sunday";
  WeekStartDay2["Monday"] = "monday";
  WeekStartDay2["Tuesday"] = "tuesday";
  WeekStartDay2["Wednesday"] = "wednesday";
  WeekStartDay2["Thursday"] = "thursday";
  WeekStartDay2["Friday"] = "friday";
  return WeekStartDay2;
})(WeekStartDay || {});
var weekStartDayOptions = [
  {
    value: "saturday" /* Saturday */,
    label: "Saturday" /* Saturday */
  },
  {
    value: "sunday" /* Sunday */,
    label: "Sunday" /* Sunday */
  },
  {
    value: "monday" /* Monday */,
    label: "Monday" /* Monday */
  },
  {
    value: "tuesday" /* Tuesday */,
    label: "Tuesday" /* Tuesday */
  },
  {
    value: "wednesday" /* Wednesday */,
    label: "Wednesday" /* Wednesday */
  },
  {
    value: "thursday" /* Thursday */,
    label: "Thursday" /* Thursday */
  },
  {
    value: "friday" /* Friday */,
    label: "Friday" /* Friday */
  }
];
var weekStartDayToDateDifference = {
  ["saturday" /* Saturday */]: -1,
  ["sunday" /* Sunday */]: 0,
  ["monday" /* Monday */]: 1,
  ["tuesday" /* Tuesday */]: 2,
  ["wednesday" /* Wednesday */]: 3,
  ["thursday" /* Thursday */]: 4,
  ["friday" /* Friday */]: 5
};
var dateRangePickerPastDatesPresetLabels = {
  ["yesterday" /* Yesterday */]: "Yesterday",
  ["last_7_days" /* Last7Days */]: "Last 7 Days",
  ["last_28_days" /* Last28Days */]: "Last 28 Days",
  ["last_84_days" /* Last84Days */]: "Last 84 Days",
  ["last_week" /* LastWeek */]: "Last Week",
  ["two_weeks_ago" /* TwoWeeksAgo */]: "2 Weeks Ago",
  ["three_weeks_ago" /* ThreeWeeksAgo */]: "3 Weeks Ago",
  ["four_weeks_ago" /* FourWeeksAgo */]: "4 Weeks Ago",
  ["five_weeks_ago" /* FiveWeeksAgo */]: "5 Weeks Ago",
  ["last_30_days" /* Last30Days */]: "Last 30 Days",
  ["last_month" /* LastMonth */]: "Last Month",
  ["last_90_days" /* Last90Days */]: "Last 90 Days",
  ["quarter_to_date" /* QuarterToDate */]: "Quarter to Date",
  ["last_120_days" /* Last120Days */]: "Last 120 Days",
  ["last_1_year" /* LastYear */]: "Last Year",
  ["last_2_years" /* Last2Years */]: "Last 2 Years",
  ["year_to_date" /* YearToDate */]: "Year to Date"
};
var dateRangePickerFutureDatesPresetLabels = {
  ["tomorrow" /* Tomorrow */]: "Tomorrow",
  ["next_7_days" /* Next7Days */]: "Next 7 Days",
  ["next_week" /* NextWeek */]: "Next Week",
  ["next_month" /* NextMonth */]: "Next Month"
};
var dateRangePickerCustomDatePresetLabel = {
  ["custom" /* Custom */]: "Custom"
};
var buildDateRangePresetConfig = /* @__PURE__ */ __name((presets, weekStartDay) => {
  const pastPresets = [
    {
      start: (0, import_dayjs2.default)().subtract(1, "days").toDate(),
      end: (0, import_dayjs2.default)().subtract(1, "days").toDate(),
      key: "yesterday" /* Yesterday */,
      label: dateRangePickerPastDatesPresetLabels["yesterday" /* Yesterday */]
    },
    {
      start: (0, import_dayjs2.default)().subtract(7, "days").toDate(),
      end: (0, import_dayjs2.default)().subtract(1, "days").toDate(),
      key: "last_7_days" /* Last7Days */,
      label: dateRangePickerPastDatesPresetLabels["last_7_days" /* Last7Days */]
    },
    {
      start: (0, import_dayjs2.default)().subtract(28, "days").toDate(),
      end: (0, import_dayjs2.default)().subtract(1, "days").toDate(),
      key: "last_28_days" /* Last28Days */,
      label: dateRangePickerPastDatesPresetLabels["last_28_days" /* Last28Days */]
    },
    {
      start: (0, import_dayjs2.default)().subtract(84, "days").toDate(),
      end: (0, import_dayjs2.default)().subtract(1, "days").toDate(),
      key: "last_84_days" /* Last84Days */,
      label: dateRangePickerPastDatesPresetLabels["last_84_days" /* Last84Days */]
    },
    {
      start: (0, import_dayjs2.default)().subtract(1, "week").startOf("week").add(weekStartDayToDateDifference[weekStartDay], "day").toDate(),
      end: (0, import_dayjs2.default)().subtract(1, "weeks").endOf("week").add(weekStartDayToDateDifference[weekStartDay], "day").toDate(),
      key: "last_week" /* LastWeek */,
      label: dateRangePickerPastDatesPresetLabels["last_week" /* LastWeek */]
    },
    {
      start: (0, import_dayjs2.default)().subtract(2, "weeks").startOf("week").add(weekStartDayToDateDifference[weekStartDay], "day").toDate(),
      end: (0, import_dayjs2.default)().subtract(2, "weeks").endOf("week").add(weekStartDayToDateDifference[weekStartDay], "day").toDate(),
      key: "two_weeks_ago" /* TwoWeeksAgo */,
      label: dateRangePickerPastDatesPresetLabels["two_weeks_ago" /* TwoWeeksAgo */]
    },
    {
      key: "three_weeks_ago" /* ThreeWeeksAgo */,
      label: dateRangePickerPastDatesPresetLabels["three_weeks_ago" /* ThreeWeeksAgo */],
      start: (0, import_dayjs2.default)().subtract(3, "weeks").startOf("week").add(weekStartDayToDateDifference[weekStartDay], "day").toDate(),
      end: (0, import_dayjs2.default)().subtract(3, "weeks").endOf("week").add(weekStartDayToDateDifference[weekStartDay], "day").toDate()
    },
    {
      key: "four_weeks_ago" /* FourWeeksAgo */,
      label: dateRangePickerPastDatesPresetLabels["four_weeks_ago" /* FourWeeksAgo */],
      end: (0, import_dayjs2.default)().subtract(4, "weeks").startOf("week").add(weekStartDayToDateDifference[weekStartDay], "day").add(6, "day").toDate(),
      start: (0, import_dayjs2.default)().subtract(4, "weeks").startOf("week").add(weekStartDayToDateDifference[weekStartDay], "day").toDate()
    },
    {
      key: "five_weeks_ago" /* FiveWeeksAgo */,
      label: dateRangePickerPastDatesPresetLabels["five_weeks_ago" /* FiveWeeksAgo */],
      end: (0, import_dayjs2.default)().subtract(5, "weeks").startOf("week").add(weekStartDayToDateDifference[weekStartDay], "day").add(6, "day").toDate(),
      start: (0, import_dayjs2.default)().subtract(5, "weeks").startOf("week").add(weekStartDayToDateDifference[weekStartDay], "day").toDate()
    },
    {
      key: "last_30_days" /* Last30Days */,
      label: dateRangePickerPastDatesPresetLabels["last_30_days" /* Last30Days */],
      end: (0, import_dayjs2.default)().subtract(1, "days").endOf("day").toDate(),
      start: (0, import_dayjs2.default)().subtract(30, "d").toDate()
    },
    {
      key: "last_month" /* LastMonth */,
      label: dateRangePickerPastDatesPresetLabels["last_month" /* LastMonth */],
      end: (0, import_dayjs2.default)().subtract(1, "months").endOf("month").toDate(),
      start: (0, import_dayjs2.default)().subtract(1, "months").date(1).toDate()
    },
    {
      key: "last_90_days" /* Last90Days */,
      label: dateRangePickerPastDatesPresetLabels["last_90_days" /* Last90Days */],
      end: (0, import_dayjs2.default)().subtract(1, "days").endOf("day").toDate(),
      start: (0, import_dayjs2.default)().subtract(90, "d").toDate()
    },
    {
      key: "quarter_to_date" /* QuarterToDate */,
      label: dateRangePickerPastDatesPresetLabels["quarter_to_date" /* QuarterToDate */],
      end: (0, import_dayjs2.default)().subtract(1, "days").endOf("day").toDate(),
      start: (0, import_dayjs2.default)().startOf("Q").toDate()
    },
    {
      key: "last_120_days" /* Last120Days */,
      label: dateRangePickerPastDatesPresetLabels["last_120_days" /* Last120Days */],
      end: (0, import_dayjs2.default)().subtract(1, "days").endOf("day").toDate(),
      start: (0, import_dayjs2.default)().subtract(120, "d").toDate()
    },
    {
      key: "last_1_year" /* LastYear */,
      label: dateRangePickerPastDatesPresetLabels["last_1_year" /* LastYear */],
      end: (0, import_dayjs2.default)().subtract(1, "days").endOf("day").toDate(),
      start: (0, import_dayjs2.default)().subtract(1, "y").toDate()
    },
    {
      key: "last_2_years" /* Last2Years */,
      label: dateRangePickerPastDatesPresetLabels["last_2_years" /* Last2Years */],
      end: (0, import_dayjs2.default)().subtract(1, "days").endOf("day").toDate(),
      start: (0, import_dayjs2.default)().subtract(2, "y").toDate()
    },
    {
      key: "year_to_date" /* YearToDate */,
      label: dateRangePickerPastDatesPresetLabels["year_to_date" /* YearToDate */],
      end: (0, import_dayjs2.default)().subtract(1, "days").endOf("day").toDate(),
      start: (0, import_dayjs2.default)().startOf("year").toDate()
    }
  ];
  const customPresets = [
    {
      key: "custom" /* Custom */,
      label: "Custom",
      end: (0, import_dayjs2.default)().toDate(),
      start: (0, import_dayjs2.default)().toDate()
    }
  ];
  const futurePresets = [
    {
      start: (0, import_dayjs2.default)().add(1, "days").toDate(),
      end: (0, import_dayjs2.default)().add(1, "days").toDate(),
      key: "tomorrow" /* Tomorrow */,
      label: dateRangePickerFutureDatesPresetLabels["tomorrow" /* Tomorrow */]
    },
    {
      start: (0, import_dayjs2.default)().add(1, "days").toDate(),
      end: (0, import_dayjs2.default)().add(7, "days").toDate(),
      key: "next_7_days" /* Next7Days */,
      label: dateRangePickerFutureDatesPresetLabels["next_7_days" /* Next7Days */]
    },
    {
      start: (0, import_dayjs2.default)().add(1, "week").startOf("week").add(weekStartDayToDateDifference[weekStartDay], "day").toDate(),
      end: (0, import_dayjs2.default)().add(1, "weeks").endOf("week").add(weekStartDayToDateDifference[weekStartDay], "day").toDate(),
      key: "next_week" /* NextWeek */,
      label: dateRangePickerFutureDatesPresetLabels["next_week" /* NextWeek */]
    },
    {
      start: (0, import_dayjs2.default)().add(1, "months").date(1).toDate(),
      end: (0, import_dayjs2.default)().add(1, "months").endOf("month").toDate(),
      key: "next_month" /* NextMonth */,
      label: dateRangePickerFutureDatesPresetLabels["next_month" /* NextMonth */]
    }
  ];
  const concatenatedPresets = customPresets.concat(pastPresets).concat(futurePresets);
  if (!presets) {
    return concatenatedPresets;
  }
  return presets.map((presetKey) => concatenatedPresets.find(({ key }) => key === presetKey)).filter(Boolean);
}, "buildDateRangePresetConfig");
var buildPresetDateRangeOptions = /* @__PURE__ */ __name((presetsConfig) => presetsConfig.map(({ label, key }) => ({
  label,
  value: key,
  disabled: key === "custom" /* Custom */
})), "buildPresetDateRangeOptions");
var findMatchingPresetConfig = /* @__PURE__ */ __name((dateRange, presetsConfig) => {
  const exactMatch = dateRange.key && presetsConfig.find(
    (config) => (0, import_dayjs2.default)(config.start).isSame(dateRange.startDate, "day") && (0, import_dayjs2.default)(config.end).isSame(dateRange.endDate, "day") && config.key === dateRange.key
  );
  return exactMatch || presetsConfig.find(
    (config) => (0, import_dayjs2.default)(config.start).isSame(dateRange.startDate, "day") && (0, import_dayjs2.default)(config.end).isSame(dateRange.endDate, "day")
  );
}, "findMatchingPresetConfig");
var findMatchingPresetConfigKey = /* @__PURE__ */ __name((dateRange, presetsConfig) => {
  var _a;
  return ((_a = findMatchingPresetConfig(dateRange, presetsConfig)) == null ? void 0 : _a.key) || "custom" /* Custom */;
}, "findMatchingPresetConfigKey");

// src/molecules/DatePickerBase/DatePickerPresetItem.tsx
import { jsx as jsx20, jsxs as jsxs5 } from "@emotion/react/jsx-runtime";
function DatePickerPresetItem({
  preset,
  presetsConfig,
  startDate,
  endDate,
  onChange
}) {
  const theme = useTheme();
  const isPresetActive = /* @__PURE__ */ __name(() => {
    if (!presetsConfig) return false;
    return findMatchingPresetConfigKey({ startDate, endDate }, presetsConfig) === preset.key;
  }, "isPresetActive");
  return /* @__PURE__ */ jsx20(
    Flex,
    {
      role: "button",
      "data-testid": "date-picker-preset-item",
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onChange([preset.start, preset.end]);
        }
      },
      tabIndex: 0,
      css: {
        padding: `${spacing.s8} 0`,
        width: "186px",
        ":hover": {
          backgroundColor: theme.colors.brandPrimaryLight,
          cursor: "pointer"
        },
        ":focus-visible": {
          backgroundColor: theme.colors.brandPrimaryLight,
          outline: `1px solid ${theme.colors.brandPrimaryRegular}`,
          outlineOffset: "-1px"
        },
        flexDirection: "column",
        backgroundColor: isPresetActive() ? theme.colors.brandPrimaryExtraLight : void 0
      },
      onClick: () => onChange([preset.start, preset.end]),
      children: /* @__PURE__ */ jsxs5(
        Flex.Row,
        {
          css: {
            padding: `${spacing.s4} ${spacing.s16}`,
            alignItems: "center",
            justifyContent: "space-between"
          },
          children: [
            /* @__PURE__ */ jsx20(Text, { typography: "bodyRegular", css: { margin: 0 }, children: preset.label }),
            isPresetActive() && /* @__PURE__ */ jsx20(ConfirmIcon, { size: 20 })
          ]
        }
      )
    }
  );
}
__name(DatePickerPresetItem, "DatePickerPresetItem");

// src/molecules/DatePicker/DateRangePicker/DateRangePickerDropdown.tsx
import { Divider, ScrollArea } from "@mantine/core";
import { jsx as jsx21, jsxs as jsxs6 } from "@emotion/react/jsx-runtime";
function DateRangePickerDropdown({
  startDate,
  endDate,
  startDateLabel = "Start date",
  endDateLabel = "End date",
  focusedDate,
  onChange,
  onDateChange,
  showDayIndicator,
  numberOfColumns,
  allowSingleDateInRange,
  onCancel,
  onApply,
  calendarProps,
  presetsConfig,
  hidePresets
}) {
  const theme = useTheme();
  const viewportStyles = {
    type: "auto",
    styles: {
      scrollbar: {
        width: "2px",
        padding: "0px"
      }
    },
    css: {
      borderRight: `1px solid ${theme.colors.systemGrayscale20}`
    }
  };
  const maxDropdownContentHeight = 470;
  return /* @__PURE__ */ jsxs6("div", { children: [
    /* @__PURE__ */ jsxs6(
      "div",
      {
        css: {
          display: "flex",
          gap: 0
        },
        children: [
          !hidePresets && /* @__PURE__ */ jsx21(
            ScrollArea.Autosize,
            __spreadProps(__spreadValues({
              h: maxDropdownContentHeight,
              mah: maxDropdownContentHeight,
              "data-testid": "date-range-picker-presets"
            }, viewportStyles), {
              children: presetsConfig == null ? void 0 : presetsConfig.map((preset) => /* @__PURE__ */ jsx21(
                DatePickerPresetItem,
                {
                  preset,
                  startDate,
                  endDate,
                  onChange,
                  presetsConfig
                },
                preset.key
              ))
            })
          ),
          /* @__PURE__ */ jsx21(
            "div",
            {
              css: {
                padding: `${spacing.s24} ${spacing.s24}`
              },
              children: /* @__PURE__ */ jsxs6(Flex.Column, { css: { gap: spacing.s16 }, children: [
                /* @__PURE__ */ jsxs6(
                  Flex.Row,
                  {
                    css: {
                      gap: spacing.s16,
                      padding: `${spacing.s16} ${spacing.s16} 0`,
                      alignItems: "center",
                      justifyContent: "center"
                    },
                    children: [
                      /* @__PURE__ */ jsx21(
                        DatePickerBaseInput,
                        {
                          value: startDate,
                          onChange: (value) => onChange([value, endDate]),
                          onCancel: () => startDate && onChange([null, endDate]),
                          label: startDateLabel
                        }
                      ),
                      /* @__PURE__ */ jsx21(Text, { css: { height: "100%", paddingTop: "22px" }, typography: "bodyRegular", children: DATE_HYPHEN }),
                      /* @__PURE__ */ jsx21(
                        DatePickerBaseInput,
                        {
                          value: endDate,
                          onChange: (value) => onChange([startDate, value]),
                          onCancel: () => endDate && onChange([startDate, null]),
                          label: endDateLabel
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ jsx21("div", { css: { padding: `0 ${spacing.s16}` }, children: /* @__PURE__ */ jsx21(
                  DatePickerCalendar,
                  __spreadValues({
                    type: "range",
                    "data-testid": "date-range-picker-calendar",
                    hideOutsideDates: true,
                    value: [startDate, endDate],
                    date: focusedDate || void 0,
                    onChange,
                    onDateChange,
                    showDayIndicator,
                    numberOfColumns,
                    allowSingleDateInRange
                  }, calendarProps)
                ) })
              ] })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx21(
      Divider,
      {
        css: __spreadValues({
          borderColor: theme.colors.systemGrayscale20
        }, elevation.high.shadow)
      }
    ),
    /* @__PURE__ */ jsx21(
      "div",
      {
        css: {
          display: "flex",
          width: "100%",
          justifyContent: "flex-end"
        },
        children: /* @__PURE__ */ jsxs6(Flex.Row, { css: { gap: spacing.s16, padding: spacing.s16 }, children: [
          /* @__PURE__ */ jsx21(Button2, { variant: "secondary", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsx21(Button2, { onClick: onApply, children: "Apply" })
        ] })
      }
    )
  ] });
}
__name(DateRangePickerDropdown, "DateRangePickerDropdown");

// src/molecules/DatePicker/DateRangePicker/DateRangePicker.tsx
import { jsx as jsx22 } from "@emotion/react/jsx-runtime";
var DEFAULT_PRESETS = [
  "custom" /* Custom */,
  "last_week" /* LastWeek */,
  "last_7_days" /* Last7Days */,
  "last_28_days" /* Last28Days */,
  "last_month" /* LastMonth */,
  "last_84_days" /* Last84Days */,
  "quarter_to_date" /* QuarterToDate */,
  "year_to_date" /* YearToDate */
];
function DateRangePicker(props) {
  const _a = props, {
    value,
    onChange,
    presets = DEFAULT_PRESETS,
    weekStartDay = "sunday" /* Sunday */,
    startDateLabel,
    endDateLabel,
    label,
    error,
    compact,
    readOnly,
    disabled,
    calendarProps,
    showDayIndicator = true,
    allowSingleDateInRange = true,
    minWidthPx = 400,
    hidePresets = false
  } = _a, rest = __objRest(_a, [
    "value",
    "onChange",
    "presets",
    "weekStartDay",
    "startDateLabel",
    "endDateLabel",
    "label",
    "error",
    "compact",
    "readOnly",
    "disabled",
    "calendarProps",
    "showDayIndicator",
    "allowSingleDateInRange",
    "minWidthPx",
    "hidePresets"
  ]);
  const [focusedDate, setFocusedDate] = useState3(() => /* @__PURE__ */ new Date());
  const [internalDateRange, setInternalDateRange] = useState3({
    startDate: (value == null ? void 0 : value.startDate) || null,
    endDate: (value == null ? void 0 : value.endDate) || null
  });
  const [isCalendarOpen, setIsCalendarOpen] = useState3(false);
  useEffect2(() => {
    if (value) {
      setFocusedDate(value.startDate || value.endDate || /* @__PURE__ */ new Date());
    }
  }, [value]);
  const formattedValue = (value == null ? void 0 : value.key) && (value == null ? void 0 : value.key) !== "custom" /* Custom */ ? `${dateRangePickerFutureDatesPresetLabels[value.key] || dateRangePickerPastDatesPresetLabels[value.key]} (${formatDateRange(value)})` : formatDateRange(value);
  const presetsConfig = buildDateRangePresetConfig(presets, weekStartDay);
  const onChangeHandler = /* @__PURE__ */ __name((newDate) => {
    const dateRangePreset = findMatchingPresetConfigKey(
      { startDate: newDate.startDate, endDate: newDate.endDate },
      presetsConfig
    );
    setInternalDateRange(__spreadProps(__spreadValues({}, newDate), {
      key: dateRangePreset
    }));
  }, "onChangeHandler");
  const onApply = /* @__PURE__ */ __name(() => {
    onChange == null ? void 0 : onChange(internalDateRange);
    setIsCalendarOpen(false);
  }, "onApply");
  const onCancel = /* @__PURE__ */ __name(() => {
    setIsCalendarOpen(false);
    setInternalDateRange(value || { startDate: null, endDate: null });
  }, "onCancel");
  const clearDateRangeInput = /* @__PURE__ */ __name(() => {
    setIsCalendarOpen(false);
    setInternalDateRange({ startDate: null, endDate: null });
    setFocusedDate(/* @__PURE__ */ new Date());
    onChange == null ? void 0 : onChange({ startDate: null, endDate: null });
  }, "clearDateRangeInput");
  return /* @__PURE__ */ jsx22(
    DatePickerBaseDropdown,
    __spreadProps(__spreadValues({
      "data-testid": "date-range-picker-input",
      label,
      error,
      compact,
      readOnly,
      disabled,
      isCalendarOpen,
      formattedValue,
      setIsCalendarOpen,
      minWidthPx,
      clearDateInput: clearDateRangeInput,
      popoverProps: {
        styles: {
          dropdown: __spreadValues({
            padding: 0,
            borderRadius: radius.interactive
          }, elevation.high.shadow)
        }
      }
    }, rest), {
      children: /* @__PURE__ */ jsx22(
        DateRangePickerDropdown,
        {
          startDate: internalDateRange.startDate,
          endDate: internalDateRange.endDate,
          startDateLabel,
          endDateLabel,
          focusedDate,
          onChange: (newDate) => onChangeHandler({
            startDate: newDate[0],
            endDate: newDate[1],
            key: findMatchingPresetConfigKey(
              { startDate: newDate[0], endDate: newDate[1] },
              presetsConfig
            )
          }),
          onDateChange: setFocusedDate,
          showDayIndicator,
          numberOfColumns: 2,
          allowSingleDateInRange,
          onApply,
          onCancel,
          presetsConfig,
          calendarProps,
          hidePresets
        }
      )
    })
  );
}
__name(DateRangePicker, "DateRangePicker");

// src/molecules/MarkerBase/MarkerBase.tsx
import { jsx as jsx23 } from "@emotion/react/jsx-runtime";
var TEXT_COLOR = "systemGrayscale80";
function MarkerBase({ text, styles: styles3 }) {
  const { backgroundColor } = styles3;
  const theme = useTheme();
  return /* @__PURE__ */ jsx23(
    "span",
    {
      css: __spreadValues({
        display: "inline-block",
        padding: `1px ${spacing.s4}`,
        backgroundColor: theme.colors[backgroundColor],
        color: theme.colors[TEXT_COLOR]
      }, typography.accentRegular),
      children: text
    }
  );
}
__name(MarkerBase, "MarkerBase");

// src/molecules/Marker/Marker.tsx
import { jsx as jsx24 } from "@emotion/react/jsx-runtime";
var getStylesForVariant = /* @__PURE__ */ __name((variant) => {
  if (variant === "neutral") {
    return { backgroundColor: "systemGrayscale10" };
  }
  if (variant === "success") {
    return { backgroundColor: "systemSuccessLight" };
  }
  if (variant === "detrimental") {
    return { backgroundColor: "systemDetrimentalLight" };
  }
  return { backgroundColor: "systemAlertLight" };
}, "getStylesForVariant");
function Marker({ text, variant }) {
  const styles3 = getStylesForVariant(variant);
  return /* @__PURE__ */ jsx24(MarkerBase, { text, styles: styles3 });
}
__name(Marker, "Marker");

// src/molecules/TooltipBase/TooltipBase.tsx
import { forwardRef as forwardRef7 } from "react";
import { Tooltip as MantineTooltip } from "@mantine/core";
import { jsx as jsx25 } from "@emotion/react/jsx-runtime";
var TooltipPosition = {
  top: "top",
  bottom: "bottom",
  left: "left",
  right: "right",
  topEnd: "top-end",
  topStart: "top-start",
  bottomEnd: "bottom-end",
  bottomStart: "bottom-start",
  leftEnd: "left-end",
  leftStart: "left-start",
  rightEnd: "right-end",
  rightStart: "right-start"
};
var ToolTipContent = forwardRef7((props, ref) => /* @__PURE__ */ jsx25("div", { css: { display: "flex", width: "fit-content", height: "fit-content" }, ref, children: props.children }));
function TooltipBase(props) {
  const theme = useTheme();
  const { position = "top", maxWidth = "240px", children, label, styles: styles3, disabled } = props;
  const { color, backgroundColor, arrowSize, arrowOffset } = styles3;
  return /* @__PURE__ */ jsx25(
    MantineTooltip,
    {
      styles: {
        arrow: {
          backgroundColor: theme.colors[backgroundColor]
        }
      },
      css: __spreadValues({
        color: theme.colors[color],
        backgroundColor: theme.colors[backgroundColor],
        position: "absolute",
        padding: "8px 12px",
        boxShadow: elevation.high.shadow.boxShadow,
        maxWidth
      }, typography.bodyRegular),
      position: TooltipPosition[position],
      arrowSize,
      arrowOffset,
      label,
      disabled,
      withArrow: true,
      unstyled: true,
      children: /* @__PURE__ */ jsx25(ToolTipContent, { children })
    }
  );
}
__name(TooltipBase, "TooltipBase");

// src/molecules/Tooltip/Tooltip.tsx
import { jsx as jsx26 } from "@emotion/react/jsx-runtime";
function Tooltip(props) {
  const styles3 = {
    backgroundColor: "systemInfoLight",
    color: "systemGrayscale80",
    arrowSize: 10,
    arrowOffset: 10
  };
  return /* @__PURE__ */ jsx26(TooltipBase, __spreadValues({ styles: styles3 }, props));
}
__name(Tooltip, "Tooltip");

// src/molecules/Tooltip/InformationIconTooltip.tsx
import { InformationOutlineIcon } from "@instacart/ids-core";
import { jsx as jsx27 } from "@emotion/react/jsx-runtime";
function InformationIconTooltip(props) {
  const { disabled } = props;
  const theme = useTheme();
  return /* @__PURE__ */ jsx27(Tooltip, __spreadProps(__spreadValues({}, props), { children: /* @__PURE__ */ jsx27(
    InformationOutlineIcon,
    {
      cursor: disabled ? "auto" : "pointer",
      fill: theme.colors.systemGrayscale80,
      size: 16
    }
  ) }));
}
__name(InformationIconTooltip, "InformationIconTooltip");

// src/molecules/ButtonText/ButtonText.tsx
import { forwardRef as forwardRef8 } from "react";
import { jsx as jsx28 } from "@emotion/react/jsx-runtime";
var getActionButtonStyles = /* @__PURE__ */ __name((compact) => __spreadProps(__spreadValues({}, getButtonStylesForVariant("tertiary")), {
  padding: "0px 4px",
  minHeight: "20px",
  minWidth: "auto",
  innerGap: compact ? spacing.s4 : spacing.s8,
  borderRadius: spacing.s4,
  iconSize: 16
}), "getActionButtonStyles");
var ButtonText = forwardRef8((props, ref) => {
  const _a = props, { compact } = _a, rest = __objRest(_a, ["compact"]);
  const styles3 = getActionButtonStyles(compact);
  return /* @__PURE__ */ jsx28(ButtonBase, __spreadValues({ compact, ref, styles: styles3 }, rest));
});
ButtonText.displayName = "ButtonText";

// src/molecules/CheckboxBase/CheckboxBase.tsx
import { useEffect as useEffect3, useState as useState4, useCallback as useCallback3 } from "react";
import { Checkbox as MantineCheckbox } from "@mantine/core";
import {
  CheckboxSelectedIcon,
  CheckboxUnselectedIcon,
  CheckboxIndeterminateIcon
} from "@instacart/ids-core";
import { jsx as jsx29 } from "@emotion/react/jsx-runtime";
var getLabelTypography = /* @__PURE__ */ __name((checked, compact) => {
  if (compact) {
    return typography.accentEmphasized;
  }
  return checked ? typography.bodyEmphasized : typography.bodyRegular;
}, "getLabelTypography");
function CheckboxBase(props) {
  const theme = useTheme();
  const _a = props, {
    checked,
    indeterminate,
    disabled,
    onChange,
    styles: styles3,
    label,
    description,
    compact,
    className: className,
    style
  } = _a, rest = __objRest(_a, [
    "checked",
    "indeterminate",
    "disabled",
    "onChange",
    "styles",
    "label",
    "description",
    "compact",
    /** The below props are omitted to prevent custom restyling */
    "className",
    "style"
  ]);
  const { textColor, disabledColor, checkboxBorderColor, checkboxIconColor, focusColor } = styles3;
  const [internalChecked, setInternalChecked] = useState4(checked != null ? checked : false);
  const displayChecked = indeterminate || internalChecked;
  const labelTypography = getLabelTypography(displayChecked, compact);
  const checkboxSize = compact ? 16 : 20;
  useEffect3(() => {
    setInternalChecked(checked);
  }, [checked]);
  const defaultOnChange2 = useCallback3(
    (evt) => {
      if (checked === void 0) {
        setInternalChecked(evt.currentTarget.checked);
      }
    },
    [setInternalChecked, checked]
  );
  const onChangeHandler = onChange || defaultOnChange2;
  const Icon = indeterminate ? CheckboxIndeterminateIcon : internalChecked ? CheckboxSelectedIcon : CheckboxUnselectedIcon;
  return /* @__PURE__ */ jsx29(
    MantineCheckbox,
    __spreadValues({
      styles: {
        body: {
          display: "flex"
        },
        label: __spreadValues({
          cursor: disabled ? "not-allowed" : "pointer",
          color: disabled ? theme.colors[disabledColor] : theme.colors[textColor]
        }, labelTypography),
        labelWrapper: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingLeft: "4px"
        },
        description: __spreadValues({
          margin: "0px",
          color: disabled ? theme.colors[disabledColor] : theme.colors[textColor]
        }, typography.accentRegular),
        input: {
          margin: 0,
          width: `${checkboxSize}px`,
          height: `${checkboxSize}px`,
          appearance: "none",
          cursor: disabled ? "not-allowed" : "pointer"
        },
        inner: {
          display: "flex",
          position: "relative"
        }
      },
      css: {
        // Mantine does not allow styling input focus styles directly through Styles API
        // so we apply the CSS via emotion
        "& input:focus": {
          outline: "none"
        },
        "& input:focus-visible": {
          outline: `2px solid ${theme.colors[focusColor]}`,
          outlineOffset: "1px",
          borderRadius: "2px"
        }
      },
      onChange: disabled ? void 0 : onChangeHandler,
      icon: () => /* @__PURE__ */ jsx29(
        Icon,
        {
          size: checkboxSize,
          css: {
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            padding: compact ? "1px 0" : "0"
          },
          fill: disabled ? theme.colors[disabledColor] : displayChecked ? theme.colors[checkboxIconColor] : theme.colors[checkboxBorderColor]
        }
      ),
      indeterminate,
      checked,
      disabled,
      label,
      description,
      unstyled: true
    }, rest)
  );
}
__name(CheckboxBase, "CheckboxBase");

// src/molecules/InputGroupLayout/InputGroupLayout.tsx
import { jsx as jsx30, jsxs as jsxs7 } from "@emotion/react/jsx-runtime";
function InputGroupLayout(props) {
  const { label, direction = "row", children, styles: styles3 } = props;
  const { rowGap = 24, columnGap = 16, maxWidth = 628, itemsPerRow = 4 } = styles3 != null ? styles3 : {};
  const isRowLayout = direction === "row";
  const itemWidth = 100 / (itemsPerRow != null ? itemsPerRow : 4);
  const containerCSS = {
    flexWrap: "wrap",
    maxWidth,
    rowGap,
    /**
     * Set each item to take an equal height/width, accounting for gaps
     * See https://go/checkboxLayout for reference
     */
    "& > *": __spreadValues({}, isRowLayout && { width: `calc(${itemWidth}% - ${columnGap}px)`, flexGrow: 1 })
  };
  return /* @__PURE__ */ jsxs7(
    Flex.Column,
    {
      css: {
        flexGrow: 1,
        rowGap: "8px"
      },
      children: [
        label,
        /* @__PURE__ */ jsx30(
          Flex,
          {
            "data-test-id": "input-group-layout-container",
            flexDirection: direction,
            css: containerCSS,
            children
          }
        )
      ]
    }
  );
}
__name(InputGroupLayout, "InputGroupLayout");

// src/molecules/Checkbox/CheckboxLayout.tsx
import { jsx as jsx31 } from "@emotion/react/jsx-runtime";
function CheckboxLayout(props) {
  const { label: Label, children, direction: flexDirection = "column" } = props;
  return /* @__PURE__ */ jsx31(InputGroupLayout, { label: Label, direction: flexDirection, children });
}
__name(CheckboxLayout, "CheckboxLayout");

// src/molecules/Checkbox/Checkbox.tsx
import { jsx as jsx32 } from "@emotion/react/jsx-runtime";
var styles2 = {
  textColor: "systemGrayscale80",
  disabledColor: "systemGrayscale30",
  checkboxBorderColor: "systemGrayscale60",
  checkboxIconColor: "systemGrayscale80",
  focusColor: "systemGrayscale80"
};
function Checkbox(props) {
  return /* @__PURE__ */ jsx32(CheckboxBase, __spreadProps(__spreadValues({}, props), { styles: styles2 }));
}
__name(Checkbox, "Checkbox");
Checkbox.Layout = CheckboxLayout;

// src/molecules/MenuBase/MenuBase.tsx
import { useTheme as useTheme2 } from "@instacart/ids-core";
import { Menu } from "@mantine/core";
import { jsx as jsx33, jsxs as jsxs8 } from "@emotion/react/jsx-runtime";
var MenuPosition = {
  bottomEnd: "bottom-end",
  bottomStart: "bottom-start"
};
function MenuBase(props) {
  const { target, children, position = "bottomStart", onMenuStateChange } = props;
  const theme = useTheme2();
  return /* @__PURE__ */ jsxs8(
    Menu,
    {
      position: MenuPosition[position],
      onChange: onMenuStateChange,
      offset: 4,
      styles: {
        dropdown: {
          boxShadow: elevation.high.shadow.boxShadow,
          border: "none",
          borderRadius: 8,
          display: "flex",
          flexDirection: "column",
          padding: "8px 0px",
          backgroundColor: theme.colors.systemGrayscale00
        }
      },
      children: [
        /* @__PURE__ */ jsx33(Menu.Target, { children: target }),
        /* @__PURE__ */ jsx33(Menu.Dropdown, { children })
      ]
    }
  );
}
__name(MenuBase, "MenuBase");

// src/molecules/MenuBase/ButtonMenu.tsx
import { ChevronDownIcon as ChevronDownIcon2, ChevronUpIcon as ChevronUpIcon2 } from "@instacart/ids-core";
import { useState as useState5 } from "react";
import { jsx as jsx34 } from "@emotion/react/jsx-runtime";
function ButtonMenu(props) {
  const _a = props, { position, buttonText, children, disabled } = _a, buttonProps = __objRest(_a, ["position", "buttonText", "children", "disabled"]);
  const [isOpen, setIsOpen] = useState5(false);
  return /* @__PURE__ */ jsx34(
    MenuBase,
    {
      position,
      onMenuStateChange: (newIsOpen) => setIsOpen(newIsOpen),
      target: /* @__PURE__ */ jsx34(
        Button2,
        __spreadProps(__spreadValues({
          disabled
        }, buttonProps), {
          rightIcon: isOpen ? ChevronUpIcon2 : ChevronDownIcon2,
          "data-testid": "button-menu-target",
          children: buttonText
        })
      ),
      children
    }
  );
}
__name(ButtonMenu, "ButtonMenu");

// src/molecules/MenuBase/IconButtonMenu.tsx
import { jsx as jsx35 } from "@emotion/react/jsx-runtime";
function IconButtonMenu(props) {
  const _a = props, { children, position = "bottomStart" } = _a, buttonProps = __objRest(_a, ["children", "position"]);
  return /* @__PURE__ */ jsx35(
    MenuBase,
    {
      position,
      target: /* @__PURE__ */ jsx35(IconButton, __spreadProps(__spreadValues({}, buttonProps), { "data-testid": "icon-button-menu-target" })),
      children
    }
  );
}
__name(IconButtonMenu, "IconButtonMenu");

// src/molecules/MenuItem/MenuItem.tsx
import { forwardRef as forwardRef9 } from "react";
import { Menu as Menu2 } from "@mantine/core";
import { css } from "@emotion/react";
import { jsx as jsx36, jsxs as jsxs9 } from "@emotion/react/jsx-runtime";
var MenuItem = forwardRef9(/* @__PURE__ */ __name(function MenuItem2(props, ref) {
  const { leftIcon: LeftIcon, compact, disabled, title, text, onClick } = props;
  const theme = useTheme();
  const headerTypography = compact ? typography.accentEmphasized : typography.bodyEmphasized;
  const textTypography = compact ? typography.accentRegular : typography.bodyRegular;
  const bodyCss = css({
    boxSizing: "border-box",
    backgroundColor: theme.colors.systemGrayscale00,
    color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80,
    padding: compact ? "6px 16px" : "10px 16px",
    cursor: disabled ? "not-allowed" : "pointer",
    border: 0,
    pointerEvents: "auto",
    minWidth: 300,
    "&:hover": {
      backgroundColor: theme.colors.brandPrimaryLight
    },
    ":focus-visible": {
      backgroundColor: theme.colors.brandPrimaryLight,
      outline: `2px solid ${theme.colors.brandPrimaryDark}`,
      outlineOffset: "2px",
      zIndex: 1
    }
  });
  return /* @__PURE__ */ jsx36(Menu2.Item, { css: __spreadValues({}, bodyCss), disabled, ref, onClick, children: /* @__PURE__ */ jsxs9(
    "div",
    {
      css: {
        display: "flex",
        flexDirection: "row",
        gap: 8
      },
      children: [
        LeftIcon && /* @__PURE__ */ jsx36("div", { css: { flexShrink: 0 }, children: /* @__PURE__ */ jsx36(
          LeftIcon,
          {
            css: { position: "relative", top: 2 },
            size: 16,
            fill: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80,
            "data-testid": "menu-item-left-icon"
          }
        ) }),
        /* @__PURE__ */ jsxs9(
          "div",
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              flexGrow: 1
            },
            children: [
              /* @__PURE__ */ jsx36("div", { css: __spreadProps(__spreadValues({}, headerTypography), { wordBreak: "break-word", textAlign: "left" }), children: title }),
              /* @__PURE__ */ jsx36("div", { css: __spreadProps(__spreadValues({}, textTypography), { wordBreak: "break-word", textAlign: "left" }), children: text })
            ]
          }
        )
      ]
    }
  ) });
}, "MenuItem"));

// src/molecules/MenuHeader/MenuHeader.tsx
import { useTheme as useTheme3 } from "@instacart/ids-core";
import { jsx as jsx37, jsxs as jsxs10 } from "@emotion/react/jsx-runtime";
function MenuHeader(props) {
  const { leftIcon: LeftIcon, compact, title } = props;
  const theme = useTheme3();
  const headerTypography = compact ? typography.accentEmphasized : typography.bodyEmphasized;
  return /* @__PURE__ */ jsx37(
    "div",
    {
      css: {
        boxSizing: "border-box",
        backgroundColor: theme.colors.systemGrayscale00,
        color: theme.colors.systemGrayscale80,
        padding: compact ? "6px 16px" : "10px 16px",
        cursor: "auto",
        border: 0,
        minWidth: 300
      },
      children: /* @__PURE__ */ jsxs10(
        "div",
        {
          css: {
            display: "flex",
            flexDirection: "row",
            gap: 8
          },
          children: [
            LeftIcon && /* @__PURE__ */ jsx37("div", { css: { flexShrink: 0 }, children: /* @__PURE__ */ jsx37(
              LeftIcon,
              {
                css: { position: "relative", top: 2 },
                size: 16,
                fill: theme.colors.systemGrayscale80,
                "data-testid": "menu-header-left-icon"
              }
            ) }),
            /* @__PURE__ */ jsx37(
              "div",
              {
                css: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  flexGrow: 1
                },
                children: /* @__PURE__ */ jsx37("div", { css: __spreadProps(__spreadValues({}, headerTypography), { wordBreak: "break-word", textAlign: "left" }), children: title })
              }
            )
          ]
        }
      )
    }
  );
}
__name(MenuHeader, "MenuHeader");

// src/molecules/Pill/Pill.tsx
import { forwardRef as forwardRef10 } from "react";
import { CORE_COLORS } from "@instacart/ids-core";
import { jsx as jsx38, jsxs as jsxs11 } from "@emotion/react/jsx-runtime";
var Pill = forwardRef10((props, ref) => {
  const _a = props, {
    color = "gray",
    icon: Icon,
    disabled,
    onClose,
    className,
    css: css2,
    style,
    children
  } = _a, rest = __objRest(_a, [
    "color",
    "icon",
    "disabled",
    "onClose",
    "className",
    "css",
    "style",
    "children"
  ]);
  const theme = useTheme();
  const pillStyles = __spreadProps(__spreadValues({
    display: "inline-flex",
    alignSelf: "center",
    alignItems: "center",
    height: "20px",
    minWidth: "50px",
    padding: "1px 1px",
    paddingLeft: "4px",
    paddingRight: onClose ? "1px" : "4px",
    borderRadius: "4px",
    gap: "4px",
    justifyContent: "center"
  }, typography.accentEmphasized), {
    backgroundColor: theme.colors.systemGrayscale00,
    color: theme.colors.systemGrayscale10,
    border: `1px solid ${theme.colors.systemGrayscale20}`
  });
  if (color === "gray") {
    pillStyles.backgroundColor = theme.colors.systemGrayscale10;
    pillStyles.color = theme.colors.systemGrayscale60;
    pillStyles.border = "none";
  } else if (color === "green") {
    pillStyles.backgroundColor = theme.colors.brandPrimaryExtraLight;
    pillStyles.color = CORE_COLORS.kale;
    pillStyles.border = "none";
  }
  if (disabled) {
    pillStyles.backgroundColor = theme.colors.systemGrayscale20;
    pillStyles.color = theme.colors.systemGrayscale30;
  }
  const iconColor = disabled ? "systemGrayscale30" : color === "gray" ? "systemGrayscale80" : "brandKale";
  return /* @__PURE__ */ jsxs11("div", __spreadProps(__spreadValues({ css: pillStyles, ref }, rest), { children: [
    Icon && /* @__PURE__ */ jsx38("span", { css: { display: "flex", alignItems: "center" }, children: /* @__PURE__ */ jsx38(Icon, { size: 16, color: iconColor }) }),
    children,
    onClose && /* @__PURE__ */ jsx38(CloseButton, { size: 8, color: pillStyles.color, compact: true, onClick: onClose })
  ] }));
});
function CategoryPill(props) {
  return /* @__PURE__ */ jsx38(Pill, __spreadValues({ color: "green" }, props));
}
__name(CategoryPill, "CategoryPill");
function SelectionPill(props) {
  return /* @__PURE__ */ jsx38(Pill, __spreadValues({ color: "gray" }, props));
}
__name(SelectionPill, "SelectionPill");

// src/molecules/Pill/PillGroup.tsx
import { CloseIcon as CloseIcon2 } from "@instacart/ids-core";
import { jsx as jsx39, jsxs as jsxs12 } from "@emotion/react/jsx-runtime";
function PillGroup(props) {
  const { children, gap: gap2 = "8px", clearButtonText, onClearAll } = props;
  return /* @__PURE__ */ jsxs12(Flex.Row, { children: [
    /* @__PURE__ */ jsx39(Flex.Row, { gap: gap2, children }),
    onClearAll && /* @__PURE__ */ jsx39(Button2, { rightIcon: CloseIcon2, compact: true, variant: "tertiary", onClick: onClearAll, children: clearButtonText })
  ] });
}
__name(PillGroup, "PillGroup");

// src/molecules/SwitchToggle/SwitchToggle.tsx
import { Switch as MantineSwitchToggle } from "@mantine/core";
import { useEffect as useEffect4, useState as useState6 } from "react";
import { jsx as jsx40 } from "@emotion/react/jsx-runtime";
var trackHeight = 1;
var trackWidth = 1.75;
var trackBorderRadius = 1;
var thumbMargin = 0.1;
var thumbDiameter = trackHeight - thumbMargin * 2;
var thumbMovingDistance = trackWidth - trackHeight;
var switchToggleMeasurements = {
  trackHeight: `${trackHeight}rem`,
  trackWidth: `${trackWidth}rem`,
  trackBorderRadius: `${trackBorderRadius}rem`,
  thumbMargin: `${thumbMargin}rem`,
  thumbDiameter: `${thumbDiameter}rem`,
  thumbMovingDistance: `${thumbMovingDistance}rem`
};
function SwitchToggle(props) {
  const theme = useTheme();
  const _a = props, {
    value,
    initialValue,
    label,
    description,
    disabled,
    css: css2,
    className,
    style,
    onChange
  } = _a, rest = __objRest(_a, [
    "value",
    "initialValue",
    "label",
    "description",
    "disabled",
    "css",
    "className",
    "style",
    "onChange"
  ]);
  const isControlled = value !== void 0;
  const [localChecked, setLocalChecked] = useState6(initialValue != null ? initialValue : false);
  const checked = isControlled ? value : localChecked;
  const onChangeHandler = isControlled ? onChange : () => setLocalChecked((prevChecked) => !prevChecked);
  useEffect4(() => {
    if (isControlled) {
      setLocalChecked(value);
    }
  }, [value, isControlled]);
  const textColor = disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80;
  return /* @__PURE__ */ jsx40(
    MantineSwitchToggle,
    __spreadValues({
      styles: {
        labelWrapper: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start"
        },
        label: __spreadValues({
          color: textColor
        }, checked ? typography.bodyEmphasized : typography.bodyRegular),
        description: __spreadValues({
          margin: "0",
          color: textColor
        }, typography.accentRegular),
        body: {
          position: "relative",
          display: "flex",
          justifyContent: "flex-start",
          columnGap: "2.25rem"
        },
        input: {
          opacity: "0",
          width: "0",
          height: "0"
        },
        track: {
          position: "absolute",
          width: switchToggleMeasurements.trackWidth,
          height: switchToggleMeasurements.trackHeight,
          backgroundColor: disabled ? theme.colors.systemGrayscale10 : checked ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale30,
          borderRadius: switchToggleMeasurements.trackBorderRadius,
          transition: "background-color 0.3s",
          marginLeft: switchToggleMeasurements.thumbMargin,
          marginTop: switchToggleMeasurements.thumbMargin
        },
        thumb: {
          position: "absolute",
          width: switchToggleMeasurements.thumbDiameter,
          height: switchToggleMeasurements.thumbDiameter,
          left: switchToggleMeasurements.thumbMargin,
          bottom: switchToggleMeasurements.thumbMargin,
          backgroundColor: disabled ? theme.colors.systemGrayscale20 : theme.colors.systemGrayscale00,
          borderRadius: radius.round,
          transition: "transform 0.3s",
          transform: checked ? `translateX(${switchToggleMeasurements.thumbMovingDistance})` : "none"
        }
      },
      label,
      description,
      checked,
      onChange: onChangeHandler,
      disabled,
      unstyled: true
    }, rest)
  );
}
__name(SwitchToggle, "SwitchToggle");

// src/molecules/Radio/Radio.tsx
import {
  forwardRef as forwardRef11
} from "react";
import { Radio as MantineRadio } from "@mantine/core";
import {
  RadioSelectedIcon,
  RadioUnselectedIcon,
  RadioDisabledUnselectedIcon,
  RadioDisabledSelectedIcon
} from "@instacart/ids-core";

// src/molecules/Radio/RadioGroupContext.ts
import { createContext, useContext as useContext2 } from "react";
var RadioGroupContext = createContext(void 0);
var useRadioGroupContext = /* @__PURE__ */ __name(() => {
  return useContext2(RadioGroupContext);
}, "useRadioGroupContext");

// src/molecules/Radio/RadioGroup.tsx
import { useUncontrolled } from "@mantine/hooks";
import { jsx as jsx41 } from "@emotion/react/jsx-runtime";
function RadioGroup(props) {
  const _a = props, {
    children,
    value,
    defaultValue,
    onChange,
    label,
    direction,
    style: style,
    className,
    css: css2
  } = _a, rest = __objRest(_a, [
    "children",
    "value",
    "defaultValue",
    "onChange",
    "label",
    "direction",
    /** The below props are omitted to prevent custom restyling */
    "style",
    "className",
    "css"
  ]);
  const [internalValue, setValue] = useUncontrolled({
    value,
    defaultValue,
    finalValue: "",
    onChange
  });
  return /* @__PURE__ */ jsx41(RadioGroupContext.Provider, { value: { value: internalValue, onChange: setValue }, children: /* @__PURE__ */ jsx41(InputGroupLayout, __spreadProps(__spreadValues({ role: "radiogroup", label, direction }, rest), { children })) });
}
__name(RadioGroup, "RadioGroup");

// src/molecules/Radio/Radio.tsx
import { jsx as jsx42 } from "@emotion/react/jsx-runtime";
var RADIO_COLOR_STYLES = {
  textColor: "systemGrayscale80",
  radioCheckedColor: "systemGrayscale80",
  radioUncheckedColor: "systemGrayscale60",
  disabledColor: "systemGrayscale30"
};
var getIconComponent = /* @__PURE__ */ __name((checked, disabled) => {
  if (disabled) {
    return checked ? RadioDisabledSelectedIcon : RadioDisabledUnselectedIcon;
  }
  return checked ? RadioSelectedIcon : RadioUnselectedIcon;
}, "getIconComponent");
var Radio = forwardRef11((props, ref) => {
  const radioGroupContext = useRadioGroupContext();
  const theme = useTheme();
  const _a = props, {
    label,
    description,
    disabled,
    value,
    checked: externalChecked,
    onChange,
    css: css2,
    style,
    className
  } = _a, rest = __objRest(_a, [
    "label",
    "description",
    "disabled",
    "value",
    "checked",
    "onChange",
    /** The below props are omitted to prevent custom restyling */
    "css",
    "style",
    "className"
  ]);
  const checked = externalChecked || (radioGroupContext == null ? void 0 : radioGroupContext.value) === value;
  const { textColor, radioCheckedColor, radioUncheckedColor, disabledColor } = RADIO_COLOR_STYLES;
  const labelTypography = checked ? typography.bodyEmphasized : typography.bodyRegular;
  const Icon = getIconComponent(checked, disabled);
  const iconColor = disabled ? theme.colors[disabledColor] : checked ? theme.colors[radioCheckedColor] : theme.colors[radioUncheckedColor];
  const iconSize = 20;
  return /* @__PURE__ */ jsx42(
    MantineRadio,
    __spreadValues({
      styles: {
        body: {
          display: "flex"
        },
        label: __spreadValues({
          cursor: disabled ? "not-allowed" : "pointer",
          color: disabled ? theme.colors[disabledColor] : theme.colors[textColor]
        }, labelTypography),
        labelWrapper: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingLeft: "4px"
        },
        description: __spreadValues({
          margin: "0px",
          color: disabled ? theme.colors[disabledColor] : theme.colors[textColor]
        }, typography.accentRegular),
        radio: {
          width: `${iconSize}px`,
          height: `${iconSize}px`,
          appearance: "none",
          cursor: disabled ? "not-allowed" : "pointer",
          margin: 0
        },
        inner: {
          display: "flex",
          position: "relative"
        }
      },
      icon: () => /* @__PURE__ */ jsx42(
        Icon,
        {
          size: iconSize,
          css: {
            position: "absolute",
            inset: 0,
            pointerEvents: "none"
          },
          fill: iconColor
        }
      ),
      label,
      description,
      disabled,
      checked,
      value,
      onChange: disabled ? void 0 : (e) => {
        onChange == null ? void 0 : onChange(e.target.value);
        radioGroupContext == null ? void 0 : radioGroupContext.onChange(e.target.value);
      },
      ref,
      unstyled: true
    }, rest)
  );
});
Radio.Group = RadioGroup;

// src/molecules/Tabs/Tabs.tsx
import { Tabs as MantineTabs4 } from "@mantine/core";

// src/molecules/Tabs/Tab.tsx
import { forwardRef as forwardRef12 } from "react";
import { Tabs as MantineTabs } from "@mantine/core";
import { IssueIcon as IssueIcon2 } from "@instacart/ids-core";
import { jsx as jsx43 } from "@emotion/react/jsx-runtime";
var Tab = forwardRef12((props, ref) => {
  const theme = useTheme();
  const _a = props, {
    value,
    children,
    withWarning,
    style: style,
    className,
    css: css2
  } = _a, rest = __objRest(_a, [
    "value",
    "children",
    "withWarning",
    /** The below props are omitted to prevent custom restyling */
    "style",
    "className",
    "css"
  ]);
  return /* @__PURE__ */ jsx43(
    MantineTabs.Tab,
    __spreadProps(__spreadValues({
      ref,
      css: __spreadValues({
        "&[data-active]": __spreadValues({
          color: theme.colors.systemGrayscale80,
          borderColor: theme.colors.systemGrayscale80
        }, typography.bodyEmphasized),
        "&:not([data-active])": {
          color: theme.colors.systemGrayscale60,
          borderColor: theme.colors.systemGrayscale20
        },
        ":hover": {
          backgroundColor: "transparent"
        },
        ":focus-visible": {
          outline: `2px solid ${theme.colors.systemGrayscale80}`,
          outlineOffset: "2px"
        },
        padding: "12px 0",
        borderRadius: "unset"
      }, typography.bodyRegular),
      value,
      rightSection: withWarning ? /* @__PURE__ */ jsx43(
        IssueIcon2,
        {
          "data-testid": "tab-warning-icon",
          size: 16,
          fill: theme.colors.systemDetrimentalRegular
        }
      ) : void 0,
      color: theme.colors.systemGrayscale80,
      styles: {
        tabSection: {
          marginLeft: "8px"
        }
      },
      unstyled: true
    }, rest), {
      children: children || value
    })
  );
});

// src/molecules/Tabs/TabPanel.tsx
import { forwardRef as forwardRef13 } from "react";
import { Tabs as MantineTabs2 } from "@mantine/core";
import { jsx as jsx44 } from "@emotion/react/jsx-runtime";
var TabPanel = forwardRef13((props, ref) => {
  const _a = props, {
    value,
    children,
    style: style,
    className,
    css: css2
  } = _a, rest = __objRest(_a, [
    "value",
    "children",
    /** The below props are omitted to prevent custom restyling */
    "style",
    "className",
    "css"
  ]);
  return /* @__PURE__ */ jsx44(MantineTabs2.Panel, __spreadProps(__spreadValues({ value, ref }, rest), { children }));
});

// src/molecules/Tabs/TabList.tsx
import { forwardRef as forwardRef14 } from "react";
import { Tabs as MantineTabs3 } from "@mantine/core";
import { jsx as jsx45 } from "@emotion/react/jsx-runtime";
var TabList = forwardRef14((props, ref) => {
  const _a = props, {
    children,
    style: style,
    className,
    css: css2
  } = _a, rest = __objRest(_a, [
    "children",
    /** The below props are omitted to prevent custom restyling */
    "style",
    "className",
    "css"
  ]);
  return /* @__PURE__ */ jsx45(MantineTabs3.List, __spreadProps(__spreadValues({ ref }, rest), { children }));
});

// src/molecules/Tabs/Tabs.tsx
import { jsx as jsx46 } from "@emotion/react/jsx-runtime";
function Tabs(props) {
  const { value, defaultValue, onChange, children } = props;
  return /* @__PURE__ */ jsx46(
    MantineTabs4,
    {
      value,
      defaultValue,
      onChange,
      styles: {
        list: {
          gap: "16px",
          "--tab-border-color": "transparent"
        }
      },
      children
    }
  );
}
__name(Tabs, "Tabs");
Tabs.Tab = Tab;
Tabs.Panel = TabPanel;
Tabs.List = TabList;

// src/molecules/TextField/TextField.tsx
import { useState as useState7, forwardRef as forwardRef15 } from "react";
import { Box } from "@instacart/ids-core";

// src/molecules/TextInputBase/TextInputBase.tsx
import { RemoveIcon as RemoveIcon3 } from "@instacart/ids-core";

// src/molecules/TextInputLabel/TextInputLabel.tsx
import { InformationIcon as InformationIcon2 } from "@instacart/ids-core";
import { Fragment as Fragment2, jsx as jsx47, jsxs as jsxs13 } from "@emotion/react/jsx-runtime";
var OPTIONAL_TEXT = "(optional)";
var gap = "1px";
var accentRegular = typography.accentRegular;
var bodyRegular = typography.bodyRegular;
var bodyEmphasized = typography.bodyEmphasized;
function TextInputLabel(props) {
  const theme = useTheme();
  const { label, optional, hint, labelTooltipProps, currentLength = 0, maxLength } = props;
  const charCounter = `${currentLength} / ${maxLength}`;
  return /* @__PURE__ */ jsxs13(Fragment2, { children: [
    /* @__PURE__ */ jsxs13(Flex.Row, { alignItems: "center", height: "20px", gap, children: [
      /* @__PURE__ */ jsx47("div", { css: __spreadValues({}, bodyEmphasized), children: label }),
      optional && /* @__PURE__ */ jsx47("div", { css: __spreadValues({ color: theme.colors.systemGrayscale60 }, bodyRegular), children: OPTIONAL_TEXT }),
      (labelTooltipProps == null ? void 0 : labelTooltipProps.label) && /* @__PURE__ */ jsx47(Tooltip, __spreadProps(__spreadValues({}, labelTooltipProps), { children: /* @__PURE__ */ jsx47(InformationIcon2, { cursor: "pointer", color: "systemGrayscale30" }) })),
      maxLength !== void 0 && /* @__PURE__ */ jsx47(
        "div",
        {
          css: __spreadValues({
            color: theme.colors.systemGrayscale60,
            marginLeft: "auto"
          }, accentRegular),
          children: charCounter
        }
      )
    ] }),
    hint && /* @__PURE__ */ jsx47("div", { css: __spreadValues({ color: theme.colors.systemGrayscale60, marginBottom: "2px" }, accentRegular), children: hint })
  ] });
}
__name(TextInputLabel, "TextInputLabel");

// src/molecules/TextInputBase/TextInputBase.tsx
import { css as EmotionCSS } from "@emotion/react";
import { jsx as jsx48, jsxs as jsxs14 } from "@emotion/react/jsx-runtime";
function defaultOnChange(maxLength, setInputValue) {
  return (event) => {
    if (!(maxLength && event.target.value.length > maxLength)) {
      setInputValue(event.target.value);
    }
  };
}
__name(defaultOnChange, "defaultOnChange");
function useTextInputBase(props) {
  const theme = useTheme();
  const {
    disabled,
    compact,
    error,
    placeholderText,
    readOnly,
    labelProps,
    leftIcon: LeftIcon,
    onLeftIconClick,
    rightIcon: RightIcon,
    onRightIconClick,
    value,
    inputType,
    isLoading,
    width,
    maxWidthPx,
    minWidthPx,
    showRemoveIcon,
    onRemoveIconClick
  } = props;
  const textarea = inputType === "textarea" /* TEXTAREA */;
  const LeftIconComponent = isLoading ? /* @__PURE__ */ jsx48("div", { css: { position: "relative", paddingLeft: spacing.s16 }, children: /* @__PURE__ */ jsx48(LoadingDots, { loadingDotSize: 4, loadingDotGap: 4 }) }) : LeftIcon ? /* @__PURE__ */ jsx48(LeftIcon, { color: "systemGrayscale60" }) : null;
  const inputLeftPadding = LeftIcon ? spacing.s8 : readOnly ? "0px" : spacing.s16;
  const {
    width: inputWidth,
    maxWidth: inputMaxWidth,
    minWidth: inputMinWidth
  } = getInputWidths({
    width,
    maxWidthPx,
    minWidthPx
  });
  const styles3 = {
    root: {
      width: inputWidth,
      maxWidth: inputMaxWidth,
      minWidth: inputMinWidth
    },
    wrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      pointerEvents: "none",
      height: textarea ? "104px" : compact ? "28px" : "40px",
      boxSizing: "border-box"
    },
    label: {
      display: "block",
      color: theme.colors.systemGrayscale80
    },
    input: __spreadValues({
      border: "none",
      outline: "none",
      backgroundColor: "transparent",
      pointerEvents: "auto",
      height: "calc(100% - 22px)",
      width: `calc(100% - ${inputLeftPadding} - ${spacing.s8} - 2px)`,
      resize: "none",
      padding: `10px ${spacing.s8} 10px ${inputLeftPadding}`,
      color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80
    }, value && !readOnly ? typography.bodyEmphasized : typography.bodyRegular),
    section: {
      display: "flex",
      pointerEvents: "auto"
    }
  };
  const disabledOrReadOnly = disabled || readOnly;
  const focusErrorBorderColor = error ? theme.colors.systemDetrimentalRegular : theme.colors.brandPrimaryRegular;
  const activitySelectors = disabledOrReadOnly ? {} : {
    "&:hover": {
      borderColor: error ? theme.colors.systemDetrimentalRegular : theme.colors.systemGrayscale60
    },
    "&:focus-within": {
      outlineWidth: "0",
      borderWidth: "1px",
      borderColor: focusErrorBorderColor,
      backgroundColor: theme.colors.systemGrayscale00
    },
    "&:focus": {
      borderWidth: "1px",
      borderColor: focusErrorBorderColor,
      outline: `2px solid ${theme.colors.systemGrayscale80}`,
      outlineOffset: "2px",
      backgroundColor: theme.colors.systemGrayscale00
    }
  };
  const css2 = EmotionCSS({
    [`div:has(${inputType})`]: __spreadValues({
      borderWidth: "1px",
      borderStyle: "solid",
      border: `1px solid ${readOnly ? theme.colors.systemGrayscale00 : disabled ? theme.colors.systemGrayscale20 : error ? theme.colors.systemDetrimentalRegular : theme.colors.systemGrayscale30}`,
      borderRadius: radius.interactive,
      color: disabled ? theme.colors.systemGrayscale10 : theme.colors.systemGrayscale80,
      backgroundColor: disabled ? theme.colors.systemGrayscale10 : error ? `${theme.colors.systemDetrimentalLight}` : theme.colors.systemGrayscale00,
      cursor: disabled ? "not-allowed" : "auto"
    }, activitySelectors),
    [`${inputType}::placeholder, ${inputType}::-ms-input-placeholder `]: {
      color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale60
    }
  });
  return {
    styles: styles3,
    css: css2,
    disabled,
    error,
    placeholder: placeholderText,
    leftSection: LeftIconComponent,
    rightSection: /* @__PURE__ */ jsxs14(Flex.Row, { gap: spacing.s8, children: [
      RightIcon && /* @__PURE__ */ jsx48(
        RightIcon,
        {
          color: "systemGrayscale60",
          onClick: onRightIconClick,
          "data-testid": "right-icon"
        }
      ),
      showRemoveIcon && value && /* @__PURE__ */ jsx48(
        RemoveIcon3,
        {
          color: "systemGrayscale60",
          onClick: onRemoveIconClick,
          style: { cursor: "pointer" },
          "data-testid": "remove-icon"
        }
      )
    ] }),
    leftSectionProps: {
      style: {
        height: spacing.s16,
        paddingLeft: spacing.s8,
        cursor: onLeftIconClick ? "pointer" : "default"
      },
      onClick: onLeftIconClick
    },
    rightSectionProps: {
      style: {
        height: spacing.s16,
        paddingRight: spacing.s8,
        cursor: onRightIconClick ? "pointer" : "default"
      }
    },
    label: (labelProps == null ? void 0 : labelProps.label) && TextInputLabel(__spreadProps(__spreadValues({}, labelProps), { currentLength: String(value).length })),
    value
  };
}
__name(useTextInputBase, "useTextInputBase");

// src/molecules/TextInputBase/TextInputDescription.tsx
import { jsx as jsx49 } from "@emotion/react/jsx-runtime";
function TextInputDescription({
  description,
  error
}) {
  const theme = useTheme();
  return /* @__PURE__ */ jsx49(
    "div",
    {
      css: __spreadValues({
        marginTop: "1px",
        color: error ? theme.colors.systemDetrimentalRegular : theme.colors.systemGrayscale60
      }, typography.accentRegular),
      children: description
    }
  );
}
__name(TextInputDescription, "TextInputDescription");

// src/molecules/TextField/TextField.tsx
import { TextInput as MantineTextInput } from "@mantine/core";
import { jsx as jsx50, jsxs as jsxs15 } from "@emotion/react/jsx-runtime";
var TextField = forwardRef15((props, ref) => {
  const _a = props, {
    disabled,
    compact,
    error,
    labelTooltipProps,
    maxLength,
    placeholderText,
    description,
    readOnly,
    labelProps,
    leftIcon: LeftIcon,
    rightIcon: RightIcon,
    onChange: customOnChange,
    value,
    width,
    isLoading,
    showRemoveIcon,
    css: css2,
    style,
    className
  } = _a, rest = __objRest(_a, [
    "disabled",
    "compact",
    "error",
    "labelTooltipProps",
    "maxLength",
    "placeholderText",
    "description",
    "readOnly",
    "labelProps",
    "leftIcon",
    "rightIcon",
    "onChange",
    "value",
    "width",
    "isLoading",
    "showRemoveIcon",
    "css",
    "style",
    "className"
  ]);
  const [internalValue, setInternalValue] = useState7(value != null ? value : "");
  const onChange = customOnChange || (readOnly ? void 0 : defaultOnChange(
    labelProps == null ? void 0 : labelProps.maxLength,
    setInternalValue
  ));
  const onRemoveIconClick = /* @__PURE__ */ __name(() => {
    setInternalValue("");
    if (customOnChange) {
      customOnChange({ target: { value: "" } });
    }
  }, "onRemoveIconClick");
  const renderProps = useTextInputBase({
    disabled,
    compact,
    error,
    labelTooltipProps,
    maxLength,
    placeholderText,
    readOnly,
    labelProps,
    leftIcon: LeftIcon,
    rightIcon: RightIcon,
    value: value != null ? value : internalValue,
    inputType: "input" /* INPUT */,
    width,
    isLoading,
    showRemoveIcon,
    onRemoveIconClick
  });
  return /* @__PURE__ */ jsxs15(Box, { css: __spreadValues({}, renderProps.styles.root), children: [
    /* @__PURE__ */ jsx50(
      MantineTextInput,
      __spreadProps(__spreadValues(__spreadValues({}, renderProps), rest), {
        onChange,
        ref,
        maxLength,
        unstyled: true
      })
    ),
    description && /* @__PURE__ */ jsx50(TextInputDescription, { description, error })
  ] });
});

// src/molecules/TextArea/TextArea.tsx
import { forwardRef as forwardRef16, useState as useState8 } from "react";
import { Box as Box2 } from "@instacart/ids-core";
import { Textarea as MantineTextArea } from "@mantine/core";
import { jsx as jsx51, jsxs as jsxs16 } from "@emotion/react/jsx-runtime";
var TextArea = forwardRef16((props, ref) => {
  const _a = props, {
    disabled,
    compact,
    error,
    labelTooltipProps,
    maxLength,
    placeholderText,
    description,
    readOnly,
    labelProps,
    onChange: customOnChange,
    width,
    value,
    css: css2,
    style,
    className
  } = _a, rest = __objRest(_a, [
    "disabled",
    "compact",
    "error",
    "labelTooltipProps",
    "maxLength",
    "placeholderText",
    "description",
    "readOnly",
    "labelProps",
    "onChange",
    "width",
    "value",
    "css",
    "style",
    "className"
  ]);
  const [internalValue, setInternalValue] = useState8(value != null ? value : "");
  const onChange = customOnChange || (readOnly ? void 0 : defaultOnChange(
    labelProps == null ? void 0 : labelProps.maxLength,
    setInternalValue
  ));
  const renderProps = useTextInputBase({
    disabled,
    compact,
    error,
    labelTooltipProps,
    maxLength,
    placeholderText,
    readOnly,
    labelProps,
    value: value != null ? value : internalValue,
    inputType: "textarea" /* TEXTAREA */,
    width
  });
  return /* @__PURE__ */ jsxs16(Box2, { css: __spreadValues({}, renderProps.styles.root), children: [
    /* @__PURE__ */ jsx51(MantineTextArea, __spreadProps(__spreadValues(__spreadValues({}, renderProps), rest), { onChange, ref, unstyled: true })),
    description && /* @__PURE__ */ jsx51(TextInputDescription, { description, error })
  ] });
});

// src/molecules/SearchInput/SearchInput.tsx
import { useState as useState9 } from "react";
import { TextInput as MantineTextInput2 } from "@mantine/core";
import { SearchIcon, RemoveIcon as RemoveIcon4, Box as Box3 } from "@instacart/ids-core";
import { jsx as jsx52, jsxs as jsxs17 } from "@emotion/react/jsx-runtime";
function SearchInput(props) {
  const _a = props, {
    disabled,
    compact,
    error,
    labelTooltipProps,
    maxLength,
    placeholderText,
    description,
    labelProps,
    onSearch,
    onClear,
    onChange: customOnChange,
    width,
    value,
    isLoading,
    css: css2,
    style,
    className,
    maxWidthPx,
    minWidthPx
  } = _a, rest = __objRest(_a, [
    "disabled",
    "compact",
    "error",
    "labelTooltipProps",
    "maxLength",
    "placeholderText",
    "description",
    "labelProps",
    "onSearch",
    "onClear",
    "onChange",
    "width",
    "value",
    "isLoading",
    "css",
    "style",
    "className",
    "maxWidthPx",
    "minWidthPx"
  ]);
  const [internalValue, setInternalValue] = useState9(value != null ? value : "");
  const onChange = customOnChange || defaultOnChange(labelProps == null ? void 0 : labelProps.maxLength, setInternalValue);
  const handleClear = /* @__PURE__ */ __name(() => {
    setInternalValue("");
    onClear ? onClear() : onChange == null ? void 0 : onChange({ target: { value: "" } });
  }, "handleClear");
  const renderProps = useTextInputBase({
    disabled,
    compact,
    error,
    labelTooltipProps,
    maxLength,
    placeholderText,
    labelProps,
    maxWidthPx,
    minWidthPx,
    leftIcon: SearchIcon,
    onLeftIconClick: onSearch,
    rightIcon: value || internalValue ? RemoveIcon4 : void 0,
    onRightIconClick: /* @__PURE__ */ __name(() => {
      handleClear();
    }, "onRightIconClick"),
    value: value != null ? value : internalValue,
    inputType: "input" /* INPUT */,
    width,
    isLoading
  });
  return /* @__PURE__ */ jsxs17(Box3, { css: __spreadValues({}, renderProps.styles.root), children: [
    /* @__PURE__ */ jsx52(MantineTextInput2, __spreadProps(__spreadValues(__spreadValues({}, renderProps), rest), { onChange, unstyled: true })),
    description && /* @__PURE__ */ jsx52(TextInputDescription, { description, error })
  ] });
}
__name(SearchInput, "SearchInput");

// src/molecules/SelectField/SelectField.tsx
import { useEffect as useEffect5, useRef, useState as useState10 } from "react";

// src/molecules/SelectBase/useSelectStyles.tsx
import { ChevronDownIcon as ChevronDownIcon3, ChevronUpIcon as ChevronUpIcon3, RemoveIcon as RemoveIcon5, spacing as spacing2 } from "@instacart/ids-core";
import { jsx as jsx53, jsxs as jsxs18 } from "@emotion/react/jsx-runtime";
var bodyRegular2 = typography.bodyRegular;
var accentRegular2 = typography.accentRegular;
var NO_RESULTS_MESSAGE = "No results";
var LOADING_MESSAGE = "Loading...";
function RightSection({
  onRemoveIconClick,
  dropdownOpened,
  disabled,
  iconColor,
  toggleDropdown
}) {
  return /* @__PURE__ */ jsxs18(Flex.Row, { gap: spacing2.s8, children: [
    onRemoveIconClick && /* @__PURE__ */ jsx53(
      RemoveIcon5,
      {
        color: "systemGrayscale60",
        onClick: onRemoveIconClick,
        style: { cursor: "pointer" },
        "data-testid": "remove-icon"
      }
    ),
    dropdownOpened && !disabled ? /* @__PURE__ */ jsx53(ChevronUpIcon3, { color: iconColor, "data-testid": "chevron-up-icon", onClick: toggleDropdown }) : /* @__PURE__ */ jsx53(
      ChevronDownIcon3,
      {
        color: iconColor,
        "data-testid": "chevron-down-icon",
        onClick: toggleDropdown
      }
    )
  ] });
}
__name(RightSection, "RightSection");
function NothingFoundMessage({
  compact,
  disabled,
  isLoading
}) {
  const theme = useTheme();
  return /* @__PURE__ */ jsx53(
    "div",
    {
      css: __spreadValues({
        height: compact ? "18px" : "28px",
        padding: compact ? "0px 6px" : "4px 6px",
        textAlign: "left",
        color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale60
      }, bodyRegular2),
      children: isLoading ? LOADING_MESSAGE : NO_RESULTS_MESSAGE
    }
  );
}
__name(NothingFoundMessage, "NothingFoundMessage");
function useSelectStyles(props) {
  const {
    dropdownOpened,
    disabled = false,
    compact = false,
    onRemoveIconClick,
    width,
    maxWidthPx,
    minWidthPx,
    isLoading,
    toggleDropdown,
    errorMessage
  } = props;
  const theme = useTheme();
  const height = compact ? "30px" : "42px";
  const iconColor = disabled ? "systemGrayscale30" : "systemGrayscale60";
  const {
    width: inputWidth,
    maxWidth: inputMaxWidth,
    minWidth: inputMinWidth
  } = getInputWidths({
    width,
    maxWidthPx,
    minWidthPx
  });
  return {
    rootStyles: {
      width: inputWidth,
      maxWidth: inputMaxWidth,
      minWidth: inputMinWidth,
      minHeight: height,
      height: "fit-content"
    },
    wrapperStyles: {
      height: "100%"
    },
    inputStyles: __spreadValues({
      height: "100%",
      minHeight: height,
      padding: compact ? "4px 0px 4px 12px" : "10px 0px 10px 16px",
      backgroundColor: disabled ? theme.colors.systemGrayscale10 : errorMessage ? theme.colors.systemDetrimentalLight : theme.colors.systemGrayscale00,
      borderRadius: compact ? radius.interactiveCompact : radius.interactive,
      color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80,
      paddingLeft: isLoading ? "34px" : void 0
    }, compact ? accentRegular2 : bodyRegular2),
    sectionStyles: {
      marginRight: onRemoveIconClick ? "12px" : "0px"
    },
    dropdownStyles: {
      boxShadow: elevation.high.shadow.boxShadow,
      border: "unset",
      height: "fit-content",
      padding: "8px 0px",
      marginTop: "-6px"
    },
    optionStyles: {
      padding: "0"
    },
    viewportStyles: {
      type: "auto",
      styles: {
        scrollbar: {
          width: "2px",
          padding: "0px"
        }
      }
    },
    inputCSS: {
      border: `1px solid ${disabled ? theme.colors.systemGrayscale20 : errorMessage ? theme.colors.systemDetrimentalRegular : dropdownOpened ? theme.colors.brandPrimaryRegular : theme.colors.systemGrayscale30}`,
      "&:hover": {
        borderColor: disabled ? theme.colors.systemGrayscale20 : dropdownOpened ? theme.colors.brandPrimaryRegular : theme.colors.systemGrayscale60
      },
      "&:focus": {
        borderColor: disabled ? theme.colors.systemGrayscale20 : theme.colors.brandPrimaryRegular,
        outline: disabled || dropdownOpened ? "unset" : `1px solid ${theme.colors.systemGrayscale80}`,
        outlineOffset: disabled ? "unset" : "2px"
      },
      "&::placeholder": {
        color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale60
      }
    },
    maxDropdownHeight: compact ? 196 : 240,
    rightSection: RightSection({
      onRemoveIconClick,
      dropdownOpened,
      disabled,
      iconColor,
      toggleDropdown
    }),
    nothingFoundMessage: NothingFoundMessage({ compact, disabled, isLoading })
  };
}
__name(useSelectStyles, "useSelectStyles");

// src/molecules/SelectField/SelectField.tsx
import { Select as MantineSelect } from "@mantine/core";
import { Box as Box4, ConfirmIcon as ConfirmIcon2 } from "@instacart/ids-core";
import { jsx as jsx54, jsxs as jsxs19 } from "@emotion/react/jsx-runtime";
function RenderOption(item, compact) {
  const theme = useTheme();
  const { option, checked } = item;
  return /* @__PURE__ */ jsx54(
    "div",
    {
      css: __spreadValues({
        height: "fit-content",
        width: "100%",
        minHeight: compact ? "28px" : "40px",
        padding: compact ? "4px 16px" : "10px 16px",
        color: option.disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80,
        backgroundColor: checked ? theme.colors.brandPrimaryExtraLight : "transparent",
        "&:hover": {
          backgroundColor: theme.colors.brandPrimaryLight
        }
      }, typography.bodyRegular),
      "data-testid": `${option.label}-option`,
      children: /* @__PURE__ */ jsxs19(Flex.Row, { justifyContent: "space-between", alignItems: "center", children: [
        option.label,
        checked ? /* @__PURE__ */ jsx54(ConfirmIcon2, { css: { flexShrink: 0 }, color: "systemGrayscale80", size: compact ? 16 : 20 }) : null
      ] })
    }
  );
}
__name(RenderOption, "RenderOption");
function SelectField(props) {
  const {
    options,
    placeholder,
    disabled,
    searchable,
    onChange: onChangeControlled,
    compact,
    allowDeselect = true,
    defaultValue,
    width,
    maxWidthPx,
    minWidthPx,
    testId,
    value,
    clearable,
    onSearchChange,
    searchValue,
    isLoading,
    errorMessage
  } = props;
  const theme = useTheme();
  const [dropdownOpened, setDropdownOpened] = useState10(false);
  const [localValue, setLocalValue] = useState10(defaultValue != null ? defaultValue : null);
  const previousValue = useRef(value);
  const onChange = /* @__PURE__ */ __name((v) => {
    setLocalValue(v);
    onChangeControlled == null ? void 0 : onChangeControlled(v);
  }, "onChange");
  useEffect5(() => {
    if (!value && previousValue.current) {
      setLocalValue(null);
    }
    previousValue.current = value;
  }, [value]);
  const {
    rootStyles,
    wrapperStyles,
    inputStyles,
    sectionStyles,
    dropdownStyles,
    optionStyles,
    viewportStyles,
    inputCSS,
    maxDropdownHeight,
    rightSection,
    nothingFoundMessage
  } = useSelectStyles({
    dropdownOpened,
    disabled,
    compact,
    onRemoveIconClick: clearable && (value || localValue) ? () => onChange(null) : void 0,
    width,
    maxWidthPx,
    minWidthPx,
    isLoading,
    errorMessage,
    toggleDropdown: /* @__PURE__ */ __name(() => setDropdownOpened((prev) => !prev), "toggleDropdown")
  });
  return /* @__PURE__ */ jsx54(Box4, { css: __spreadValues({}, rootStyles), children: /* @__PURE__ */ jsx54(
    MantineSelect,
    {
      dropdownOpened,
      styles: {
        root: rootStyles,
        wrapper: wrapperStyles,
        input: __spreadProps(__spreadValues({}, inputStyles), {
          textOverflow: "ellipsis",
          paddingRight: "34px"
        }),
        dropdown: dropdownStyles,
        section: sectionStyles,
        groupLabel: __spreadValues({
          width: "100%",
          minHeight: compact ? "28px" : "40px",
          padding: compact ? "4px 16px" : "10px 16px",
          color: theme.colors.systemGrayscale80
        }, typography.bodyEmphasized),
        option: optionStyles
      },
      css: {
        input: inputCSS
      },
      searchable,
      allowDeselect,
      onDropdownOpen: () => setDropdownOpened(true),
      onDropdownClose: () => setDropdownOpened(false),
      data: options,
      placeholder,
      onChange,
      renderOption: (item) => RenderOption(item, compact),
      rightSection,
      disabled,
      maxDropdownHeight,
      comboboxProps: { withinPortal: false },
      nothingFoundMessage,
      scrollAreaProps: __spreadValues({
        viewportProps: { style: { padding: "0px" } }
      }, viewportStyles),
      "data-testid": testId,
      value: value || localValue,
      rightSectionPointerEvents: "all",
      onSearchChange,
      searchValue,
      leftSection: isLoading ? /* @__PURE__ */ jsx54(LoadingDots, { "data-testid": "loading-dots", loadingDotSize: 4, loadingDotGap: 4 }) : null,
      error: errorMessage && /* @__PURE__ */ jsx54(TextInputDescription, { description: errorMessage, error: true })
    }
  ) });
}
__name(SelectField, "SelectField");

// src/molecules/MultiselectDropdown/MultiselectDropdown.tsx
import { useEffect as useEffect6, useRef as useRef2, useState as useState11 } from "react";
import {
  Combobox,
  Input as Input2,
  Pill as MantinePill,
  PillsInput,
  useCombobox,
  ScrollArea as ScrollArea2
} from "@mantine/core";
import { jsx as jsx55, jsxs as jsxs20 } from "@emotion/react/jsx-runtime";
var MANTINE_PILLS_INPUT_CLASS = ".mantine-PillsInput-input";
var REMOVE_BUTTON_TEXT = "Remove";
var APPLY_BUTTON_TEXT = "Apply";
function RenderOption2(item, compact) {
  const theme = useTheme();
  const { option, checked } = item;
  return /* @__PURE__ */ jsx55(
    "div",
    {
      css: __spreadValues({
        height: "fit-content",
        width: "100%",
        minHeight: compact ? "28px" : "40px",
        padding: compact ? "4px 16px" : "10px 16px",
        color: option.disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80,
        backgroundColor: theme.colors.systemGrayscale00,
        "&:hover": {
          backgroundColor: theme.colors.brandPrimaryLight
        }
      }, typography.bodyRegular),
      "data-testid": `${option.label}-option`,
      children: /* @__PURE__ */ jsx55(
        Flex.Row,
        {
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "8px",
          css: { pointerEvents: "none" },
          children: /* @__PURE__ */ jsx55(
            Checkbox,
            {
              label: option.label,
              checked,
              "aria-hidden": true,
              tabIndex: -1,
              "data-testid": `checkbox-${option.value}`
            }
          )
        }
      )
    }
  );
}
__name(RenderOption2, "RenderOption");
function MultiselectDropdown(props) {
  const {
    compact,
    disabled,
    options,
    onChange,
    placeholder,
    width = "100%",
    testId,
    value,
    searchable,
    onSearchChange,
    searchValue,
    maxOptions,
    controlShouldRenderValue = true,
    withConfirmation,
    clearable,
    isLoading
  } = props;
  const theme = useTheme();
  const [dropdownOpened, setDropdownOpened] = useState11(false);
  const combobox = useCombobox({
    onDropdownClose: /* @__PURE__ */ __name(() => {
      combobox.resetSelectedOption();
      setDropdownOpened(false);
    }, "onDropdownClose"),
    onDropdownOpen: /* @__PURE__ */ __name(() => {
      combobox.updateSelectedOptionIndex("active");
      setDropdownOpened(true);
    }, "onDropdownOpen")
  });
  const [internalValue, setInternalValue] = useState11(value != null ? value : []);
  const previousValue = useRef2(
    value
  );
  const [search, setSearch] = useState11(searchValue);
  const [preSelectedValue, setPreSelectedValue] = useState11([]);
  useEffect6(() => {
    if (!value && previousValue.current) {
      setInternalValue([]);
    }
    previousValue.current = value;
  }, [value]);
  const handleValueSelect = /* @__PURE__ */ __name((val) => {
    const selectedOption = options.find((option) => option.value === val);
    const getNewValue = /* @__PURE__ */ __name((current) => current.some((item) => item.value === (selectedOption == null ? void 0 : selectedOption.value)) ? current.filter((item) => item.value !== (selectedOption == null ? void 0 : selectedOption.value)) : selectedOption ? [...current, selectedOption] : current, "getNewValue");
    if (withConfirmation) {
      setPreSelectedValue((current) => {
        if (selectedOption) {
          const newValue = getNewValue(current);
          return newValue;
        }
        return current;
      });
    } else {
      setInternalValue((current) => {
        if (selectedOption) {
          const newValue = getNewValue(current);
          if (onChange) {
            onChange(newValue);
          }
          return newValue;
        }
        return current;
      });
    }
  }, "handleValueSelect");
  const handleValueRemove = /* @__PURE__ */ __name((val, removeFromValue = false) => {
    const getNewValue = /* @__PURE__ */ __name((current) => current.filter((item) => item.value !== val), "getNewValue");
    if (withConfirmation && !removeFromValue) {
      setPreSelectedValue((current) => {
        const newValue = getNewValue(current);
        return newValue;
      });
    } else {
      setInternalValue((current) => {
        const newValue = getNewValue(current);
        if (onChange) {
          onChange(newValue);
        }
        return newValue;
      });
    }
  }, "handleValueRemove");
  const valueToRender = value || internalValue;
  useEffect6(() => {
    if (dropdownOpened === false && withConfirmation) {
      setPreSelectedValue(valueToRender);
    }
  }, [dropdownOpened, value, internalValue, withConfirmation, valueToRender]);
  const values = controlShouldRenderValue ? valueToRender.map((item) => /* @__PURE__ */ jsx55(
    Pill,
    {
      onClose: () => handleValueRemove(item.value, true),
      "data-testid": item.value,
      children: item.label
    },
    item.value
  )) : [];
  const onClear = /* @__PURE__ */ __name(() => {
    setInternalValue([]);
    onChange == null ? void 0 : onChange([]);
  }, "onClear");
  const {
    rootStyles,
    wrapperStyles,
    inputStyles,
    sectionStyles,
    dropdownStyles,
    optionStyles,
    viewportStyles,
    inputCSS,
    maxDropdownHeight,
    rightSection,
    nothingFoundMessage
  } = useSelectStyles({
    dropdownOpened,
    width,
    disabled,
    compact,
    isLoading,
    onRemoveIconClick: clearable && valueToRender.length > 0 ? onClear : void 0,
    toggleDropdown: combobox.toggleDropdown
  });
  const renderOptions = options.filter((option) => {
    var _a;
    if (searchable) {
      return option.label.toLowerCase().includes((_a = search == null ? void 0 : search.toLowerCase()) != null ? _a : "");
    }
    return true;
  }).map((option) => {
    const withConfirmationValue = withConfirmation ? preSelectedValue : valueToRender;
    const checked = withConfirmationValue.some((item) => item.value === option.value);
    return /* @__PURE__ */ jsx55(
      Combobox.Option,
      {
        value: option.value,
        active: checked,
        disabled: !checked && withConfirmationValue.length >= (maxOptions != null ? maxOptions : Infinity),
        children: RenderOption2(
          {
            option,
            checked
          },
          compact
        )
      },
      option.value
    );
  });
  const searchValueToSet = searchValue != null ? searchValue : search;
  return /* @__PURE__ */ jsxs20(
    Combobox,
    {
      styles: {
        dropdown: dropdownStyles,
        option: optionStyles
      },
      store: combobox,
      onOptionSubmit: handleValueSelect,
      withinPortal: false,
      disabled,
      "data-testid": testId,
      children: [
        /* @__PURE__ */ jsx55(Combobox.DropdownTarget, { children: /* @__PURE__ */ jsx55(
          PillsInput,
          {
            styles: {
              root: __spreadValues({}, rootStyles),
              wrapper: wrapperStyles,
              input: __spreadProps(__spreadValues({}, inputStyles), {
                height: "fit-content",
                cursor: disabled ? "not-allowed" : "pointer",
                paddingLeft: isLoading ? "34px" : void 0
              })
            },
            css: {
              [MANTINE_PILLS_INPUT_CLASS]: inputCSS
            },
            rightSection,
            rightSectionProps: {
              style: __spreadValues({
                cursor: !disabled ? "pointer" : "not-allowed"
              }, sectionStyles)
            },
            onClick: (event) => {
              const target = event.target;
              if (target.closest("button")) {
                return;
              }
              combobox.toggleDropdown();
            },
            leftSection: isLoading ? /* @__PURE__ */ jsx55(LoadingDots, { "data-testid": "loading-dots", loadingDotSize: 4, loadingDotGap: 4 }) : null,
            children: /* @__PURE__ */ jsxs20(MantinePill.Group, { css: { minHeight: "20px" }, children: [
              values.length > 0 ? values : /* @__PURE__ */ jsx55(
                Input2.Placeholder,
                {
                  css: {
                    color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale60
                  },
                  children: placeholder
                }
              ),
              /* @__PURE__ */ jsx55(Combobox.EventsTarget, { children: /* @__PURE__ */ jsx55(
                PillsInput.Field,
                {
                  type: searchable ? "visible" : "hidden",
                  onBlur: () => combobox.closeDropdown(),
                  onKeyDown: searchable && searchValueToSet ? void 0 : (event) => {
                    if (event.key === "Backspace") {
                      event.preventDefault();
                      handleValueRemove(internalValue[internalValue.length - 1].value, true);
                    }
                  },
                  onChange: (event) => {
                    setSearch(event.target.value);
                    if (onSearchChange) {
                      onSearchChange(event.target.value);
                    }
                  },
                  value: searchValueToSet
                }
              ) })
            ] })
          }
        ) }),
        /* @__PURE__ */ jsxs20(Combobox.Dropdown, { "data-testid": "dropdown", children: [
          /* @__PURE__ */ jsx55(ScrollArea2.Autosize, __spreadProps(__spreadValues({ mah: maxDropdownHeight }, viewportStyles), { children: /* @__PURE__ */ jsx55(Combobox.Options, { children: renderOptions.length > 0 ? renderOptions : /* @__PURE__ */ jsx55(Combobox.Empty, { children: nothingFoundMessage }) }) })),
          withConfirmation && /* @__PURE__ */ jsx55(Combobox.Footer, { style: { padding: "8px 8px 0px 8px", margin: "unset" }, children: /* @__PURE__ */ jsxs20(Flex.Row, { justifyContent: "flex-end", css: { gap: "8px" }, children: [
            /* @__PURE__ */ jsx55(Button2, { variant: "secondary", compact: true, onClick: () => setPreSelectedValue([]), children: REMOVE_BUTTON_TEXT }),
            /* @__PURE__ */ jsx55(
              Button2,
              {
                variant: "primary",
                compact: true,
                onClick: () => {
                  setInternalValue(preSelectedValue);
                  if (onChange) {
                    onChange(preSelectedValue);
                  }
                  combobox.closeDropdown();
                },
                children: APPLY_BUTTON_TEXT
              }
            )
          ] }) })
        ] })
      ]
    }
  );
}
__name(MultiselectDropdown, "MultiselectDropdown");

// src/molecules/Pagination/Pagination.tsx
import { ArrowRightIcon, ArrowLeftIcon } from "@instacart/ids-core";
import { jsx as jsx56, jsxs as jsxs21 } from "@emotion/react/jsx-runtime";
var bodyRegular3 = typography.bodyRegular;
function Pagination(props) {
  const theme = useTheme();
  const _a = props, {
    currentPage = "",
    onCurrentPageChange,
    totalPages,
    itemsPerPage,
    compact,
    backgroundColor = "systemGrayscale00",
    width = "100%",
    css: css2,
    className,
    style
  } = _a, rest = __objRest(_a, [
    "currentPage",
    "onCurrentPageChange",
    "totalPages",
    "itemsPerPage",
    "compact",
    "backgroundColor",
    "width",
    "css",
    "className",
    "style"
  ]);
  const borderRadius = compact ? radius.interactiveCompact : radius.interactive;
  const totalPagesLabel = `of ${totalPages}`;
  const borderProp = `1px solid ${theme.colors.systemGrayscale30}`;
  const compactLength = compact ? "28px" : "40px";
  const leftArrowDisabled = !currentPage || currentPage === 1;
  const leftIconSize = leftArrowDisabled ? 20 : 18;
  const rightArrowDisabled = currentPage === totalPages;
  const rightIconSize = rightArrowDisabled ? 20 : 18;
  return /* @__PURE__ */ jsx56(
    Flex.Row,
    __spreadProps(__spreadValues({
      css: __spreadValues({
        height: compact ? "44px" : "64px",
        boxSizing: "border-box",
        padding: "12px 8px",
        width,
        minWidth: "500px",
        backgroundColor: theme.colors[backgroundColor],
        color: theme.colors.systemGrayscale60,
        alignItems: "center"
      }, bodyRegular3)
    }, rest), {
      children: /* @__PURE__ */ jsxs21(Flex.Row, { justifyContent: "space-between", alignItems: "center", flexGrow: 1, children: [
        itemsPerPage && /* @__PURE__ */ jsxs21(
          Flex.Row,
          {
            justifyContent: "space-between",
            alignItems: "center",
            gap: "8px",
            height: compactLength,
            children: [
              /* @__PURE__ */ jsx56("label", { htmlFor: "select", style: { width: "120px", textAlign: "right" }, children: itemsPerPage.label }),
              /* @__PURE__ */ jsx56(
                "select",
                {
                  id: "select",
                  style: {
                    borderRadius,
                    width: compact ? "57px" : "64px",
                    height: "100%",
                    padding: compact ? "5px 8px" : "10px 8px",
                    border: borderProp,
                    textAlign: "center"
                  },
                  css: {
                    "&:focus, &:focus-visible": {
                      outline: "none"
                    }
                  },
                  value: itemsPerPage.current,
                  onChange: (event) => itemsPerPage.onChange(Number(event.target.value)),
                  children: itemsPerPage.options.map((option) => /* @__PURE__ */ jsx56("option", { value: option, children: option }, option))
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs21(
          Flex.Row,
          {
            justifyContent: "space-between",
            alignItems: "center",
            gap: "8px",
            height: compactLength,
            children: [
              /* @__PURE__ */ jsx56(
                IconButton,
                {
                  icon: ArrowLeftIcon,
                  compact,
                  variant: "secondary",
                  onClick: () => onCurrentPageChange(currentPage && currentPage - 1),
                  disabled: leftArrowDisabled,
                  size: leftIconSize
                }
              ),
              /* @__PURE__ */ jsx56(
                "input",
                {
                  value: currentPage,
                  onChange: (event) => {
                    const value = Number(event.target.value);
                    if (value >= 1 && value <= totalPages) {
                      onCurrentPageChange(value);
                    } else if (event.target.value === "") {
                      onCurrentPageChange("");
                    }
                  },
                  style: __spreadValues({
                    borderRadius,
                    height: "100%",
                    width: compactLength,
                    padding: "0",
                    boxSizing: "border-box",
                    border: borderProp,
                    textAlign: "center",
                    WebkitAppearance: "none",
                    MozAppearance: "textfield"
                  }, typography.bodyEmphasized),
                  css: {
                    "input:focus, input:focus-visible": {
                      border: "unset"
                    },
                    "&:focus, &:focus-visible": {
                      outline: "none"
                    }
                  }
                }
              ),
              /* @__PURE__ */ jsx56("div", { children: totalPagesLabel }),
              /* @__PURE__ */ jsx56(
                IconButton,
                {
                  icon: ArrowRightIcon,
                  compact,
                  variant: "secondary",
                  onClick: () => onCurrentPageChange(Number(currentPage) + 1),
                  disabled: rightArrowDisabled,
                  size: rightIconSize
                }
              )
            ]
          }
        )
      ] })
    })
  );
}
__name(Pagination, "Pagination");

// src/molecules/Divider/Divider.tsx
import { jsx as jsx57 } from "@emotion/react/jsx-runtime";
var getMeasurements = /* @__PURE__ */ __name((length) => {
  return {
    horizontal: {
      containerWidth: length,
      containerHeight: "16px",
      maxContainerHeight: "16px",
      dividerWidth: "100%",
      dividerHeight: "0px",
      dividerMargin: "8px 0px"
    },
    vertical: {
      containerWidth: "16px",
      maxContainerWidth: "16px",
      containerHeight: length,
      dividerWidth: "0px",
      dividerHeight: "100%",
      dividerMargin: "0px 8px"
    }
  };
}, "getMeasurements");
function Divider2(props) {
  const theme = useTheme();
  const { orientation = "horizontal", visible = true, length = "100%" } = props;
  const measurements = getMeasurements(length);
  return /* @__PURE__ */ jsx57(
    "div",
    {
      style: {
        width: measurements[orientation].containerWidth,
        height: measurements[orientation].containerHeight
      },
      children: /* @__PURE__ */ jsx57(
        "div",
        {
          role: "separator",
          style: {
            boxSizing: "border-box",
            width: measurements[orientation].dividerWidth,
            height: measurements[orientation].dividerHeight,
            border: `1px solid ${visible ? theme.colors.systemGrayscale20 : theme.colors.systemGrayscale00}`,
            margin: measurements[orientation].dividerMargin
          }
        }
      )
    }
  );
}
__name(Divider2, "Divider");

// src/molecules/Card/CardTitle.tsx
import { jsx as jsx58, jsxs as jsxs22 } from "@emotion/react/jsx-runtime";
function CardTitle(props) {
  const { title, icon: Icon } = props;
  return /* @__PURE__ */ jsxs22(Flex.Row, { gap: spacing.s24, justifyContent: "space-between", children: [
    title && /* @__PURE__ */ jsx58(
      "div",
      {
        css: __spreadValues({ flexGrow: 1, textAlign: "left" }, typography.subtitle),
        "data-testid": "card-title-title",
        children: title
      }
    ),
    Icon && /* @__PURE__ */ jsx58(Icon, { color: "systemGrayscale80", "data-testid": "card-title-icon", size: 24 })
  ] });
}
__name(CardTitle, "CardTitle");

// src/molecules/Card/CardHeader.tsx
import { jsx as jsx59 } from "@emotion/react/jsx-runtime";
function CardHeader(props) {
  const { header } = props;
  return /* @__PURE__ */ jsx59("div", { css: __spreadValues({ marginRight: "auto" }, typography.headline), "data-testid": "card-header", children: header });
}
__name(CardHeader, "CardHeader");

// src/molecules/Card/CardStatus.tsx
import { jsx as jsx60, jsxs as jsxs23 } from "@emotion/react/jsx-runtime";
function CardStatus(props) {
  const { status, marker } = props;
  return /* @__PURE__ */ jsxs23(Flex.Row, { justifyContent: "space-between", children: [
    status && /* @__PURE__ */ jsx60("div", { css: __spreadValues({}, typography.accentRegular), "data-testid": "card-status-status", children: status }),
    /* @__PURE__ */ jsx60("div", { children: marker && /* @__PURE__ */ jsx60(Marker, { variant: "neutral", text: marker }) })
  ] });
}
__name(CardStatus, "CardStatus");

// src/molecules/Card/CardLabel.tsx
import { jsx as jsx61, jsxs as jsxs24 } from "@emotion/react/jsx-runtime";
function CardLabel(props) {
  const { label, data } = props;
  return /* @__PURE__ */ jsxs24(Flex.Row, { justifyContent: "space-between", children: [
    /* @__PURE__ */ jsx61("div", { css: __spreadValues({}, typography.accentRegular), "data-testid": `card-label-label-${label}`, children: label }),
    /* @__PURE__ */ jsx61("div", { css: __spreadValues({}, typography.accentEmphasized), "data-testid": `card-label-data-${data}`, children: data })
  ] }, label);
}
__name(CardLabel, "CardLabel");

// src/molecules/Card/CardMetric.tsx
import { jsx as jsx62, jsxs as jsxs25 } from "@emotion/react/jsx-runtime";
function CardMetric(props) {
  const { color, name, value } = props;
  const theme = useTheme();
  return /* @__PURE__ */ jsxs25(Flex.Row, { justifyContent: "space-between", alignItems: "center", gap: "2px", children: [
    /* @__PURE__ */ jsx62(
      "span",
      {
        css: { backgroundColor: theme.colors[color], width: "12px", height: "12px", margin: "2px" },
        "data-testid": "card-metric-color"
      }
    ),
    /* @__PURE__ */ jsx62(
      "div",
      {
        css: __spreadValues({ marginRight: "auto" }, typography.accentRegular),
        "data-testid": "card-metric-name",
        children: name
      }
    ),
    /* @__PURE__ */ jsx62("div", { css: __spreadValues({}, typography.accentEmphasized), "data-testid": "card-metric-value", children: value })
  ] });
}
__name(CardMetric, "CardMetric");

// src/molecules/Card/CardImage.tsx
import { jsx as jsx63 } from "@emotion/react/jsx-runtime";
function CardImage(props) {
  const { src, width = "100%" } = props;
  return /* @__PURE__ */ jsx63(
    "img",
    {
      src,
      alt: "",
      css: {
        minWidth: width,
        maxWidth: width,
        marginTop: "-17px",
        marginLeft: "-17px",
        marginBottom: "12px",
        borderRadius: "inherit",
        borderBottomLeftRadius: "unset",
        borderBottomRightRadius: "unset"
      }
    }
  );
}
__name(CardImage, "CardImage");

// src/molecules/Card/CardDescription.tsx
import { jsx as jsx64 } from "@emotion/react/jsx-runtime";
function CardDescription(props) {
  const { cardDescription } = props;
  const theme = useTheme();
  return /* @__PURE__ */ jsx64(
    "div",
    {
      css: __spreadValues({
        marginRight: "auto",
        color: theme.colors.systemGrayscale60
      }, typography.bodyRegular),
      children: cardDescription
    }
  );
}
__name(CardDescription, "CardDescription");

// src/molecules/Card/CardBody.tsx
import { jsx as jsx65 } from "@emotion/react/jsx-runtime";
function CardBody(props) {
  const { children, gap: gap2 = spacing.s16 } = props;
  return /* @__PURE__ */ jsx65(Flex.Column, { gap: gap2, children });
}
__name(CardBody, "CardBody");

// src/molecules/Card/Card.tsx
import { useMemo as useMemo7 } from "react";
import { jsx as jsx66 } from "@emotion/react/jsx-runtime";
function Card(props) {
  const theme = useTheme();
  const _a = props, { width = "100%", css: css2, className, style, children } = _a, rest = __objRest(_a, ["width", "css", "className", "style", "children"]);
  const clickableState = useMemo7(() => {
    if (props.onClick) {
      return {
        borderRadius: radius.interactive,
        "&:hover": {
          backgroundColor: theme.colors.brandPrimaryLight
        }
      };
    }
    return {};
  }, [props.onClick, theme.colors.brandPrimaryLight]);
  return /* @__PURE__ */ jsx66(
    "div",
    __spreadProps(__spreadValues({
      css: __spreadValues({
        width,
        height: "auto",
        padding: spacing.s16,
        border: `1px solid ${theme.colors.systemGrayscale20}`,
        backgroundColor: theme.colors.systemGrayscale00,
        color: theme.colors.systemGrayscale80
      }, clickableState)
    }, rest), {
      children
    })
  );
}
__name(Card, "Card");
Card.Body = CardBody;
Card.Title = CardTitle;
Card.Header = CardHeader;
Card.Status = CardStatus;
Card.Label = CardLabel;
Card.Metric = CardMetric;
Card.Image = CardImage;
Card.Description = CardDescription;

// src/molecules/SegmentSwitch/SegmentSwitch.tsx
import { forwardRef as forwardRef17 } from "react";
import { SegmentedControl } from "@mantine/core";
import { jsx as jsx67 } from "@emotion/react/jsx-runtime";
var SegmentSwitch = forwardRef17((props, ref) => {
  const theme = useTheme();
  const _a = props, {
    items,
    className: className,
    css: css2,
    style,
    compact
  } = _a, rest = __objRest(_a, [
    "items",
    /** The below props are omitted to prevent custom restyling */
    "className",
    "css",
    "style",
    "compact"
  ]);
  const bgColor = theme.colors.systemGrayscale00;
  const bgSelectedColor = theme.colors.brandPrimaryExtraLight;
  const bgHoverColor = theme.colors.brandPrimaryLight;
  return /* @__PURE__ */ jsx67(
    SegmentedControl,
    __spreadValues(__spreadProps(__spreadValues({
      ref,
      data: items
    }, rest), {
      styles: {
        root: {
          backgroundColor: bgColor,
          borderRadius: 8,
          padding: 0,
          border: "1px solid",
          borderColor: theme.colors.systemGrayscale20,
          fontFeatureSettings: '"tnum" on',
          fontVariantNumeric: "tabular-nums"
        },
        control: {
          backgroundColor: "transparent"
        },
        label: {
          color: theme.colors.systemGrayscale80,
          fontWeight: 600,
          fontSize: 14,
          lineHeight: 1,
          minWidth: compact ? "40px" : "60px",
          padding: compact ? "6px 12px" : "10px 20px"
        },
        indicator: {
          position: "absolute",
          top: 1,
          left: 1,
          backgroundColor: bgSelectedColor,
          transform: "translateX(1px) translateY(1px)",
          borderRadius: 0,
          margin: -2,
          height: "calc(100% + 2px)",
          boxShadow: `0px 0px 0px 0px ${bgSelectedColor}`
        }
      },
      css: {
        label: {
          ":hover": {
            backgroundColor: bgHoverColor,
            borderRadius: 0
          },
          '&[data-active="true"]': {
            backgroundColor: bgSelectedColor,
            ":hover": {
              backgroundColor: bgHoverColor
            }
          }
        }
      }
    }), rest)
  );
});
SegmentSwitch.displayName = "SegmentSwitch";

// src/molecules/StepperSequentialBase/StepperSequentialBase.tsx
import { Timeline } from "@mantine/core";
import { CheckboxSelectedIcon as CheckboxSelectedIcon2 } from "@instacart/ids-core";

// src/molecules/StepperSequentialBase/utils.ts
var getStepperDefaultStyles = /* @__PURE__ */ __name((options) => {
  const { styles: styles3, theme, bulletSize, lineWidth, compact } = options;
  return {
    item: {
      marginTop: 0,
      paddingTop: 0,
      paddingLeft: spacing.s8,
      paddingBottom: compact ? 24 : 28,
      borderLeftStyle: "solid",
      borderLeftWidth: lineWidth,
      borderLeftColor: theme.colors[styles3.activeStepTitleColor]
    },
    itemBullet: __spreadProps(__spreadValues({}, typography.bodyEmphasized), {
      fontVariantNumeric: "tabular-nums",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: `${bulletSize}px`,
      height: `${bulletSize}px`,
      fontSize: 12,
      fontWeight: 600,
      borderStyle: "solid",
      borderWidth: "2px",
      borderRadius: 0,
      backgroundColor: theme.colors[styles3.stepBulletBackgroundColor],
      color: theme.colors[styles3.stepDescriptionColor],
      borderColor: theme.colors[styles3.stepBulletBorderColor]
    })
  };
}, "getStepperDefaultStyles");
var getStepperStateStyles = /* @__PURE__ */ __name((options) => {
  const { stepperState, isLastStep, styles: styles3, theme, compact, lineWidth } = options;
  return {
    item: {
      borderLeftWidth: lineWidth,
      borderLeftColor: isLastStep ? "transparent" : stepperState === "done" ? theme.colors[styles3.doneStepLineColor] : stepperState === "current" ? theme.colors[styles3.activeStepLineColor] : theme.colors[styles3.stepLineColor]
    },
    itemTitle: __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, compact ? typography.bodyEmphasized : typography.subtitle), {
      marginBottom: spacing.s4,
      color: theme.colors[styles3.stepTitleColor]
    }), stepperState === "current" && {
      color: theme.colors[styles3.activeStepTitleColor]
    }), stepperState === "done" && {
      color: theme.colors[styles3.doneStepTitleColor]
    }),
    itemBody: __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, typography.accentRegular), {
      color: theme.colors[styles3.stepDescriptionColor]
    }), stepperState === "current" && {
      color: theme.colors[styles3.activeStepDescriptionColor]
    }), stepperState === "done" && {
      color: theme.colors[styles3.doneStepDescriptionColor]
    }),
    itemBullet: __spreadValues(__spreadValues({}, stepperState === "current" && {
      backgroundColor: theme.colors[styles3.activeStepBulletBackgroundColor],
      color: theme.colors[styles3.activeStepTitleColor],
      borderColor: theme.colors[styles3.activeStepBulletBorderColor]
    }), stepperState === "done" && {
      borderColor: theme.colors[styles3.doneStepBulletBorderColor]
    })
  };
}, "getStepperStateStyles");

// src/molecules/StepperSequentialBase/StepperSequentialBase.tsx
import { useMemo as useMemo8 } from "react";
import { jsx as jsx68 } from "@emotion/react/jsx-runtime";
function StepperSequentialBase(props) {
  const theme = useTheme();
  const { steps, activeStep, compact = false, styles: styles3 } = props;
  const bulletSize = 20;
  const lineWidth = 2;
  const defaultStyles3 = useMemo8(
    () => getStepperDefaultStyles({ styles: styles3, theme, bulletSize, lineWidth, compact }),
    [styles3, theme, bulletSize, lineWidth, compact]
  );
  const itemStyles = useMemo8(() => {
    return steps.map((_, index) => {
      const stepperState = index < activeStep ? "done" : index === activeStep ? "current" : "pending";
      const isLastStep = index === steps.length - 1;
      return getStepperStateStyles({
        stepperState,
        isLastStep,
        styles: styles3,
        theme,
        compact,
        lineWidth
      });
    });
  }, [steps, activeStep, styles3, theme, compact, lineWidth]);
  return /* @__PURE__ */ jsx68(
    Timeline,
    {
      active: activeStep,
      bulletSize,
      lineWidth: 0,
      "data-testid": "stepper-sequential",
      css: {
        maxWidth: 302,
        backgroundColor: theme.colors[styles3.backgroundColor]
      },
      styles: defaultStyles3,
      children: steps.map((step, index) => /* @__PURE__ */ jsx68(
        Timeline.Item,
        {
          styles: itemStyles[index],
          title: step.label,
          bullet: index < activeStep ? /* @__PURE__ */ jsx68(
            CheckboxSelectedIcon2,
            {
              "data-testid": "checkbox-selected-icon",
              size: bulletSize,
              css: {
                scale: 1.1,
                position: "absolute",
                pointerEvents: "none"
              }
            }
          ) : index + 1,
          "data-testid": `stepper-item-${index}`,
          children: step.description
        },
        step.label
      ))
    }
  );
}
__name(StepperSequentialBase, "StepperSequentialBase");
StepperSequentialBase.displayName = "StepperSequentialBase";

// src/molecules/StepperSequential/StepperSequential.tsx
import { jsx as jsx69 } from "@emotion/react/jsx-runtime";
var defaultStyles = {
  backgroundColor: "systemGrayscale00",
  // Pending/Default state
  stepTitleColor: "systemGrayscale80",
  stepDescriptionColor: "systemGrayscale60",
  stepLineColor: "systemGrayscale20",
  stepBulletBackgroundColor: "systemGrayscale20",
  stepBulletBorderColor: "systemGrayscale20",
  // Active state
  activeStepTitleColor: "brandPrimaryRegular",
  activeStepDescriptionColor: "systemGrayscale80",
  activeStepLineColor: "systemGrayscale20",
  activeStepBulletBackgroundColor: "brandPrimaryExtraLight",
  activeStepBulletBorderColor: "brandPrimaryRegular",
  // Completed state
  doneStepTitleColor: "systemGrayscale60",
  doneStepDescriptionColor: "systemGrayscale30",
  doneStepLineColor: "systemGrayscale80",
  doneStepBulletBackgroundColor: "systemGrayscale80",
  doneStepBulletBorderColor: "systemGrayscale80"
};
function StepperSequential(props) {
  const { steps, activeStep, compact = false } = props;
  return /* @__PURE__ */ jsx69(
    StepperSequentialBase,
    {
      steps,
      activeStep,
      compact,
      styles: defaultStyles
    }
  );
}
__name(StepperSequential, "StepperSequential");
StepperSequential.displayName = "StepperSequential";

// src/molecules/StepperNonSequentialBase/StepperNonSequentialBase.tsx
import { ConfirmIcon as ConfirmIcon3, LockedIcon, UnlockedIcon } from "@instacart/ids-core";

// src/molecules/StepperNonSequentialBase/utils.ts
var getStepStateStyles = /* @__PURE__ */ __name(({ state, styles: styles3, theme }) => {
  const baseStyles = {
    container: {
      padding: spacing.s16,
      borderLeft: state === "selected" ? "4px solid" : "none",
      borderColor: theme.colors[styles3.selectedBorderColor],
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      transition: "all 150ms ease",
      "&:hover": {
        borderColor: theme.colors[styles3.hoverBorderColor]
      },
      ":focus-visible": {
        outline: `2px solid ${theme.colors.brandPrimaryRegular}`,
        outlineOffset: "2px",
        backgroundColor: theme.colors[styles3.hoverBackgroundColor],
        "& .step-title": {
          color: theme.colors[styles3.hoverTitleColor]
        },
        "& .step-icon": {
          fill: theme.colors[styles3.hoverTitleColor]
        }
      }
    },
    title: __spreadProps(__spreadValues({}, typography.bodyEmphasized), {
      color: theme.colors[styles3.stepTitleColor]
    }),
    description: __spreadProps(__spreadValues({}, typography.accentRegular), {
      color: theme.colors[styles3.stepDescriptionColor]
    }),
    icon: {
      color: styles3.unlockedIconColor
    }
  };
  switch (state) {
    case "pending":
      return {
        container: __spreadProps(__spreadValues({}, baseStyles.container), {
          backgroundColor: theme.colors[styles3.backgroundColor],
          cursor: "pointer",
          "&:hover": {
            backgroundColor: theme.colors[styles3.hoverBackgroundColor],
            "& .step-title": {
              color: theme.colors[styles3.hoverTitleColor]
            }
          }
        }),
        title: __spreadProps(__spreadValues({}, baseStyles.title), {
          color: theme.colors[styles3.stepTitleColor]
        }),
        description: __spreadProps(__spreadValues({}, baseStyles.description), {
          color: theme.colors[styles3.stepDescriptionColor]
        }),
        icon: {
          color: styles3.unlockedIconColor
        }
      };
    case "selected":
      return {
        container: __spreadProps(__spreadValues({}, baseStyles.container), {
          backgroundColor: theme.colors[styles3.selectedBackgroundColor],
          cursor: "pointer",
          "&:hover": {
            backgroundColor: theme.colors[styles3.hoverBackgroundColor],
            borderColor: theme.colors[styles3.hoverBorderColor],
            "& .step-title": {
              color: theme.colors[styles3.hoverTitleColor]
            },
            "& .step-icon": {
              fill: theme.colors[styles3.hoverTitleColor]
            }
          }
        }),
        title: __spreadProps(__spreadValues({}, baseStyles.title), {
          color: theme.colors[styles3.selectedTitleColor]
        }),
        description: __spreadProps(__spreadValues({}, baseStyles.description), {
          color: theme.colors[styles3.selectedDescriptionColor]
        }),
        icon: {
          color: styles3.unlockedIconColor
        }
      };
    case "completed":
      return {
        container: __spreadProps(__spreadValues({}, baseStyles.container), {
          backgroundColor: theme.colors[styles3.completedBackgroundColor],
          cursor: "pointer",
          "&:hover": {
            backgroundColor: theme.colors[styles3.hoverBackgroundColor],
            "& .step-title": {
              color: theme.colors[styles3.hoverTitleColor]
            },
            "& .step-icon": {
              fill: theme.colors[styles3.hoverTitleColor]
            }
          }
        }),
        title: __spreadProps(__spreadValues({}, baseStyles.title), {
          color: theme.colors[styles3.completedTitleColor]
        }),
        description: __spreadProps(__spreadValues({}, baseStyles.description), {
          color: theme.colors[styles3.completedDescriptionColor]
        }),
        icon: {
          color: styles3.completedIconColor
        }
      };
    case "locked":
      return {
        container: __spreadProps(__spreadValues({}, baseStyles.container), {
          backgroundColor: theme.colors[styles3.lockedBackgroundColor],
          cursor: "not-allowed",
          "&:hover": {
            backgroundColor: theme.colors[styles3.lockedHoverBackgroundColor]
          }
          // No hover styles for locked state
        }),
        title: __spreadProps(__spreadValues({}, baseStyles.title), {
          color: theme.colors[styles3.lockedTitleColor]
        }),
        description: __spreadProps(__spreadValues({}, baseStyles.description), {
          color: theme.colors[styles3.lockedDescriptionColor]
        }),
        icon: {
          color: styles3.lockedIconColor
        }
      };
    default:
      return baseStyles;
  }
}, "getStepStateStyles");

// src/molecules/StepperNonSequentialBase/StepperNonSequentialBase.tsx
import { useCallback as useCallback4 } from "react";
import { jsx as jsx70, jsxs as jsxs26 } from "@emotion/react/jsx-runtime";
function StepperNonSequentialBase(props) {
  const {
    steps,
    activeStep,
    completedSteps,
    onActiveStepChange,
    styles: styles3,
    stepperTitle,
    stepperDescription
  } = props;
  const theme = useTheme();
  const isStepLocked = useCallback4(
    (index) => {
      if (index !== steps.length - 1) return false;
      return !steps.every((_, idx) => idx === steps.length - 1 || completedSteps.includes(idx));
    },
    [steps, completedSteps]
  );
  const getStepState = useCallback4(
    (index) => {
      if (isStepLocked(index)) return "locked";
      if (activeStep === index) return "selected";
      if (completedSteps.includes(index)) return "completed";
      return "pending";
    },
    [isStepLocked, activeStep, completedSteps]
  );
  const handleStepClick = useCallback4(
    (index) => {
      if (!isStepLocked(index) && onActiveStepChange) {
        onActiveStepChange(index);
      }
    },
    [isStepLocked, onActiveStepChange]
  );
  const getStepsContent = /* @__PURE__ */ __name(() => {
    return steps.map((step, index) => {
      var _a, _b, _c;
      const state = getStepState(index);
      const stepStyles = getStepStateStyles({
        state,
        styles: styles3,
        theme
      });
      return /* @__PURE__ */ jsxs26("div", { children: [
        /* @__PURE__ */ jsxs26(
          "div",
          {
            onClick: () => handleStepClick(index),
            onKeyDown: (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleStepClick(index);
              }
            },
            role: "button",
            tabIndex: 0,
            css: stepStyles.container,
            "data-testid": `stepper-item-${index}`,
            children: [
              /* @__PURE__ */ jsxs26("div", { children: [
                /* @__PURE__ */ jsx70("div", { className: "step-title", css: stepStyles.title, children: step.label }),
                step.description && /* @__PURE__ */ jsx70("div", { css: stepStyles.description, children: step.description })
              ] }),
              /* @__PURE__ */ jsxs26("div", { css: { display: "flex", alignItems: "center" }, children: [
                completedSteps.includes(index) && /* @__PURE__ */ jsx70(
                  ConfirmIcon3,
                  {
                    size: 20,
                    fill: theme.colors[(_a = stepStyles.icon) == null ? void 0 : _a.color],
                    "data-testid": "checkbox-selected-icon",
                    className: "step-icon"
                  }
                ),
                index === steps.length - 1 && (isStepLocked(index) ? /* @__PURE__ */ jsx70(
                  LockedIcon,
                  {
                    size: 24,
                    fill: theme.colors[(_b = stepStyles.icon) == null ? void 0 : _b.color],
                    "data-testid": "lock-icon",
                    className: "step-icon"
                  }
                ) : /* @__PURE__ */ jsx70(
                  UnlockedIcon,
                  {
                    size: 24,
                    fill: theme.colors[(_c = stepStyles.icon) == null ? void 0 : _c.color],
                    "data-testid": "unlock-icon",
                    className: "step-icon"
                  }
                ))
              ] })
            ]
          }
        ),
        index === steps.length - 2 && /* @__PURE__ */ jsx70(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "center",
              marginTop: spacing.s24,
              marginBottom: spacing.s24
            },
            children: /* @__PURE__ */ jsx70(Divider2, {})
          }
        )
      ] }, step.label);
    });
  }, "getStepsContent");
  return /* @__PURE__ */ jsxs26("div", { style: { width: 302, backgroundColor: theme.colors.systemGrayscale00 }, children: [
    /* @__PURE__ */ jsxs26("div", { style: { marginBottom: spacing.s24 }, children: [
      stepperTitle && /* @__PURE__ */ jsx70(
        Text,
        {
          style: { marginBottom: 0, marginTop: 0 },
          color: styles3.stepperTitleColor,
          typography: "subtitle",
          children: stepperTitle
        }
      ),
      stepperDescription && /* @__PURE__ */ jsx70(
        Text,
        {
          style: { marginBottom: 0, marginTop: 0 },
          color: styles3.stepperDescriptionColor,
          typography: "bodyRegular",
          children: stepperDescription
        }
      )
    ] }),
    getStepsContent()
  ] });
}
__name(StepperNonSequentialBase, "StepperNonSequentialBase");
StepperNonSequentialBase.displayName = "StepperNonSequentialBase";

// src/molecules/StepperNonSequential/StepperNonSequential.tsx
import { jsx as jsx71 } from "@emotion/react/jsx-runtime";
var defaultStyles2 = {
  // Default/Pending state
  backgroundColor: "systemGrayscale00",
  stepperTitleColor: "systemGrayscale80",
  stepperDescriptionColor: "systemGrayscale80",
  stepTitleColor: "brandPrimaryRegular",
  stepDescriptionColor: "systemGrayscale80",
  unlockedIconColor: "brandPrimaryRegular",
  // Selected state
  selectedBackgroundColor: "brandPrimaryExtraLight",
  selectedBorderColor: "brandPrimaryRegular",
  selectedTitleColor: "brandPrimaryRegular",
  selectedDescriptionColor: "systemGrayscale80",
  // Completed state
  completedBackgroundColor: "systemGrayscale00",
  completedTitleColor: "brandPrimaryRegular",
  completedDescriptionColor: "systemGrayscale80",
  completedIconColor: "brandPrimaryRegular",
  // Hover state
  hoverBackgroundColor: "brandPrimaryLight",
  hoverBorderColor: "brandPrimaryDark",
  hoverTitleColor: "brandPrimaryDark",
  // Locked state
  lockedBackgroundColor: "systemGrayscale00",
  lockedHoverBackgroundColor: "systemGrayscale10",
  lockedTitleColor: "systemGrayscale30",
  lockedDescriptionColor: "systemGrayscale30",
  lockedIconColor: "systemGrayscale30"
};
function StepperNonSequential({
  steps,
  activeStep,
  completedSteps,
  onActiveStepChange,
  stepperTitle,
  stepperDescription
}) {
  return /* @__PURE__ */ jsx71(
    StepperNonSequentialBase,
    {
      steps,
      activeStep,
      completedSteps,
      onActiveStepChange,
      styles: defaultStyles2,
      stepperTitle,
      stepperDescription
    }
  );
}
__name(StepperNonSequential, "StepperNonSequential");
StepperNonSequential.displayName = "StepperNonSequential";

// src/organisms/PageHeader/PageHeaderBackLink.tsx
import { ArrowLeftIcon as ArrowLeftIcon2 } from "@instacart/ids-core";
import { jsx as jsx72 } from "@emotion/react/jsx-runtime";
function PageHeaderBackLink(props) {
  const { backLink } = props;
  if (!backLink) return null;
  return /* @__PURE__ */ jsx72("div", { css: { marginBottom: spacing.s4, wordBreak: "break-word", overflowWrap: "break-word" }, children: /* @__PURE__ */ jsx72(
    LinkBase,
    __spreadProps(__spreadValues({}, backLink), {
      hideUnderline: true,
      styles: {
        textColor: "brandPrimaryRegular",
        activeColor: "brandPrimaryExtraDark",
        hoverColor: "brandPrimaryDark",
        focusColor: "systemGrayscale80",
        disabledColor: "systemGrayscale30"
      },
      leftIcon: ArrowLeftIcon2
    })
  ) });
}
__name(PageHeaderBackLink, "PageHeaderBackLink");

// src/organisms/PageHeader/PageHeaderTitle.tsx
import { jsx as jsx73 } from "@emotion/react/jsx-runtime";
function PageHeaderTitle(props) {
  const { title } = props;
  return /* @__PURE__ */ jsx73(
    "div",
    {
      css: __spreadProps(__spreadValues({}, typography.headline), {
        wordBreak: "break-word",
        overflowWrap: "break-word",
        paddingTop: spacing.s4,
        paddingBottom: spacing.s4
      }),
      children: title.text
    }
  );
}
__name(PageHeaderTitle, "PageHeaderTitle");

// src/organisms/PageHeader/PageHeaderStatus.tsx
import { jsx as jsx74, jsxs as jsxs27 } from "@emotion/react/jsx-runtime";
function PageHeaderStatus(props) {
  const { marker, updatedAt } = props;
  if (!marker && !updatedAt) return null;
  return /* @__PURE__ */ jsxs27(Flex.Row, { alignItems: "center", gap: 16, children: [
    marker && /* @__PURE__ */ jsx74(Marker, __spreadValues({}, marker)),
    updatedAt && /* @__PURE__ */ jsxs27("div", { css: typography.accentRegular, children: [
      "Updated ",
      updatedAt.text
    ] })
  ] });
}
__name(PageHeaderStatus, "PageHeaderStatus");

// src/organisms/PageHeader/PageHeaderActions.tsx
import { OptionsIcon } from "@instacart/ids-core";
import { jsx as jsx75, jsxs as jsxs28 } from "@emotion/react/jsx-runtime";
function PageHeaderActions(props) {
  const { actions } = props;
  if (!actions) return null;
  return /* @__PURE__ */ jsxs28(Button2.Group, { children: [
    actions.overflowMenu && /* @__PURE__ */ jsx75(IconButtonMenu, { variant: "tertiary", icon: OptionsIcon, children: actions.overflowMenu.map((item) => {
      if (item.type === "header") {
        return /* @__PURE__ */ jsx75(MenuHeader, __spreadValues({}, item));
      }
      return /* @__PURE__ */ jsx75(MenuItem, __spreadValues({}, item));
    }) }),
    (actions == null ? void 0 : actions.secondary) && /* @__PURE__ */ jsx75(Button2, { variant: "secondary", onClick: actions.secondary.onClick, children: actions.secondary.label }),
    (actions == null ? void 0 : actions.primary) && /* @__PURE__ */ jsx75(Button2, { variant: "primary", onClick: actions.primary.onClick, children: actions.primary.label })
  ] });
}
__name(PageHeaderActions, "PageHeaderActions");

// src/organisms/PageHeader/PageHeaderAlert.tsx
import { jsx as jsx76 } from "@emotion/react/jsx-runtime";
function PageHeaderAlert(props) {
  const { alert } = props;
  if (!alert) return null;
  return /* @__PURE__ */ jsx76("div", { css: { marginBottom: spacing.s8 }, children: /* @__PURE__ */ jsx76(Alert, __spreadProps(__spreadValues({}, alert), { children: alert.text })) });
}
__name(PageHeaderAlert, "PageHeaderAlert");

// src/organisms/PageHeader/PageHeaderTabs.tsx
import { useEffect as useEffect7, useState as useState13 } from "react";

// src/organisms/PageHeader/PageHeaderProvider.tsx
import { useState as useState12, createContext as createContext2, useContext as useContext3 } from "react";
import { jsx as jsx77 } from "@emotion/react/jsx-runtime";
var PageHeaderContext = createContext2(void 0);
function usePageHeader() {
  const context = useContext3(PageHeaderContext);
  return context;
}
__name(usePageHeader, "usePageHeader");
function PageHeaderProvider({ children }) {
  const [tab, setTab] = useState12(null);
  return /* @__PURE__ */ jsx77(PageHeaderContext.Provider, { value: { tab, setTab }, children });
}
__name(PageHeaderProvider, "PageHeaderProvider");

// src/organisms/PageHeader/PageHeaderTabs.tsx
import { jsx as jsx78 } from "@emotion/react/jsx-runtime";
function PageHeaderTabs(props) {
  const pageHeaderContext = usePageHeader();
  const { tabs } = props;
  const [tabValue, setTabValue] = useState13((tabs == null ? void 0 : tabs[0].value) || null);
  useEffect7(() => {
    if (pageHeaderContext) {
      pageHeaderContext == null ? void 0 : pageHeaderContext.setTab(tabValue);
    }
  }, [tabValue, pageHeaderContext]);
  if (!tabs) return null;
  return /* @__PURE__ */ jsx78(Tabs, { defaultValue: tabs[0].value, value: tabValue, onChange: (newTab) => setTabValue(newTab), children: /* @__PURE__ */ jsx78(Tabs.List, { children: tabs.map((tab) => /* @__PURE__ */ jsx78(Tabs.Tab, __spreadProps(__spreadValues({}, tab), { children: tab.label }), tab.value)) }) });
}
__name(PageHeaderTabs, "PageHeaderTabs");

// src/organisms/PageHeader/PageHeader.tsx
import { jsx as jsx79, jsxs as jsxs29 } from "@emotion/react/jsx-runtime";
function PageHeader(props) {
  return /* @__PURE__ */ jsxs29("div", { css: { padding: "24px 80px" }, children: [
    /* @__PURE__ */ jsx79(PageHeaderBackLink, __spreadValues({}, props)),
    /* @__PURE__ */ jsxs29(Flex.Row, { css: { marginBottom: spacing.s8 }, children: [
      /* @__PURE__ */ jsxs29(
        Flex.Row,
        {
          alignItems: "center",
          flexGrow: 1,
          flexWrap: "wrap",
          gap: 16,
          marginRight: 16,
          css: {
            rowGap: spacing.s4
          },
          children: [
            /* @__PURE__ */ jsx79(PageHeaderTitle, __spreadValues({}, props)),
            /* @__PURE__ */ jsx79(PageHeaderStatus, __spreadValues({}, props))
          ]
        }
      ),
      /* @__PURE__ */ jsx79(PageHeaderActions, __spreadValues({}, props))
    ] }),
    /* @__PURE__ */ jsx79(PageHeaderAlert, __spreadValues({}, props)),
    /* @__PURE__ */ jsx79(PageHeaderTabs, __spreadValues({}, props))
  ] });
}
__name(PageHeader, "PageHeader");

// src/organisms/PageHeader/PageHeaderTabPanel.tsx
import { jsx as jsx80 } from "@emotion/react/jsx-runtime";
function PageHeaderTabPanel({ value, children }) {
  const context = usePageHeader();
  return /* @__PURE__ */ jsx80(Tabs, { value: context == null ? void 0 : context.tab, children: /* @__PURE__ */ jsx80(Tabs.Panel, { value, children }) });
}
__name(PageHeaderTabPanel, "PageHeaderTabPanel");

// src/organisms/Filters/Filters.tsx
import { useState as useState15 } from "react";

// src/organisms/Filters/Filter.tsx
import { jsx as jsx81 } from "@emotion/react/jsx-runtime";
function Filter({ filter, onFilterChange }) {
  var _a, _b;
  if (filter.type === 0 /* multi */) {
    return /* @__PURE__ */ jsx81(
      MultiselectDropdown,
      {
        options: (_a = filter.options) != null ? _a : [],
        placeholder: filter.label,
        onChange: (val) => onFilterChange(filter.id, val),
        testId: `filters-${filter.id}-multi-select`
      }
    );
  }
  if (filter.type === 1 /* single */) {
    return /* @__PURE__ */ jsx81(
      SelectField,
      {
        options: (_b = filter.options) != null ? _b : [],
        placeholder: filter.label,
        onChange: (val) => {
          var _a2;
          const selectedOption = (_a2 = filter.options) == null ? void 0 : _a2.find((opt) => opt.value === val);
          onFilterChange(filter.id, selectedOption ? [selectedOption] : []);
        },
        testId: `filters-${filter.id}-single-select`
      }
    );
  }
  return null;
}
__name(Filter, "Filter");

// src/organisms/Filters/PermanentFilters.tsx
import { jsx as jsx82 } from "@emotion/react/jsx-runtime";
function PermanentFilters({ permanentFilters, onFilterChange }) {
  if (!permanentFilters) return null;
  return /* @__PURE__ */ jsx82(Flex.Row, { gap: 8, alignItems: "center", flexWrap: "wrap", children: permanentFilters.map((filter) => /* @__PURE__ */ jsx82(Filter, { filter, onFilterChange }, filter.id)) });
}
__name(PermanentFilters, "PermanentFilters");

// src/organisms/Filters/AdditionalFilters.tsx
import { useState as useState14 } from "react";
import { AddIcon } from "@instacart/ids-core";
import { jsx as jsx83, jsxs as jsxs30 } from "@emotion/react/jsx-runtime";
function AdditionalFilters({ additionalFilters, onFilterChange }) {
  const [selectedAdditionalFilters, setSelectedAdditionalFilters] = useState14([]);
  if (!additionalFilters) return null;
  return /* @__PURE__ */ jsxs30(Flex.Row, { gap: 8, alignItems: "center", flexWrap: "wrap", children: [
    selectedAdditionalFilters.map((filter) => /* @__PURE__ */ jsx83(Filter, { filter, onFilterChange }, filter.id)),
    /* @__PURE__ */ jsx83(
      ButtonMenu,
      {
        leftIcon: AddIcon,
        variant: "secondary",
        buttonText: "Filter",
        disabled: selectedAdditionalFilters.length >= 5,
        children: additionalFilters.map((filter) => /* @__PURE__ */ jsx83(
          MenuItem,
          {
            text: filter.description,
            title: filter.label,
            onClick: () => setSelectedAdditionalFilters((prev) => {
              if (prev.some((f) => f.id === filter.id)) {
                return prev;
              }
              return [...prev, filter];
            }),
            disabled: selectedAdditionalFilters.some((f) => f.id === filter.id)
          },
          filter.id
        ))
      }
    ),
    selectedAdditionalFilters.length > 0 && // TODO: replace with i18n solution
    // eslint-disable-next-line
    /* @__PURE__ */ jsx83(ButtonText, { onClick: () => setSelectedAdditionalFilters([]), children: "Clear filters" })
  ] });
}
__name(AdditionalFilters, "AdditionalFilters");

// src/organisms/Filters/Filters.tsx
import { jsx as jsx84, jsxs as jsxs31 } from "@emotion/react/jsx-runtime";
var FilterConfigType = /* @__PURE__ */ ((FilterConfigType2) => {
  FilterConfigType2[FilterConfigType2["multi"] = 0] = "multi";
  FilterConfigType2[FilterConfigType2["single"] = 1] = "single";
  return FilterConfigType2;
})(FilterConfigType || {});
function Filters(props) {
  const { onChange } = props;
  const [selectedFilterOptions, setSelectedFilterOptions] = useState15({});
  const handleFilterOptionChange = /* @__PURE__ */ __name((filterId, value) => {
    const updatedFilters = __spreadProps(__spreadValues({}, selectedFilterOptions), { [filterId]: value });
    setSelectedFilterOptions(updatedFilters);
    onChange == null ? void 0 : onChange(updatedFilters);
  }, "handleFilterOptionChange");
  return /* @__PURE__ */ jsxs31(Flex.Row, { gap: 8, width: "100%", alignItems: "center", flexWrap: "wrap", children: [
    /* @__PURE__ */ jsx84(PermanentFilters, __spreadProps(__spreadValues({}, props), { onFilterChange: handleFilterOptionChange })),
    /* @__PURE__ */ jsx84(AdditionalFilters, __spreadProps(__spreadValues({}, props), { onFilterChange: handleFilterOptionChange }))
  ] });
}
__name(Filters, "Filters");
export {
  Alert,
  Button2 as Button,
  ButtonGroup,
  ButtonMenu,
  ButtonText,
  CachedTdsThemeProvider,
  Card,
  CardBody,
  CardDescription,
  CardHeader,
  CardImage,
  CardLabel,
  CardMetric,
  CardStatus,
  CardTitle,
  CategoryPill,
  Checkbox,
  CloseButton,
  DateRangePicker,
  DateRangePickerPresetOption,
  Divider2 as Divider,
  FilterConfigType,
  Filters,
  Flex,
  IconButton,
  IconButtonMenu,
  InformationIconTooltip,
  Link,
  LoadingDots,
  Marker,
  MenuHeader,
  MenuItem,
  MultiselectDropdown,
  PageHeader,
  PageHeaderProvider,
  PageHeaderTabPanel,
  Pagination,
  Pill,
  PillGroup,
  Radio,
  RadioGroup,
  SearchInput,
  SegmentSwitch,
  SelectField,
  SelectionPill,
  SingleDatePicker,
  StepperNonSequential,
  StepperSequential,
  SwitchToggle,
  TDS_DEFAULT_COLORS,
  Tab,
  Tabs,
  TdsProvider,
  Text,
  TextArea,
  TextField,
  Tooltip,
  WeekStartDay,
  buildDateRangePresetConfig,
  buildPresetDateRangeOptions,
  coreTheme,
  dateRangePickerCustomDatePresetLabel,
  dateRangePickerFutureDatesPresetLabels,
  dateRangePickerPastDatesPresetLabels,
  deriveThemeFromEmotionTheme,
  elevation,
  findMatchingPresetConfig,
  findMatchingPresetConfigKey,
  radius,
  spacing,
  typography,
  usePageHeader,
  useTheme,
  weekStartDayOptions
};
